var _style, _rect, _path, _path2, _path3, _path4, _use, _path5, _use2, _use3, _use4, _path6, _use5, _use6, _path7, _use7, _path8, _path9, _path10, _path11, _use8, _path12, _use9, _path13, _path14, _use10, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _use11, _use12, _path24, _path25, _use13, _path26, _path27, _use14, _use15, _path28, _path29, _use16, _path30, _use17, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _use18, _use19, _path40, _path41, _use20, _path42, _path43, _use21, _path44, _use22, _use23, _use24, _path45, _use25, _path46, _use26, _path47, _path48, _path49, _path50, _path51, _use27, _path52, _path53, _use28, _use29, _path54, _use30, _use31, _path55, _use32, _use33, _use34, _use35, _use36, _use37, _path56, _path57, _use38, _use39, _use40, _use41, _use42, _use43, _path58, _use44, _use45, _use46, _use47, _use48, _path59, _use49, _use50, _path60, _use51, _use52, _path61, _path62, _use53, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _use54, _path71, _path72, _path73, _path74, _use55, _path75, _path76, _path77, _path78, _path79, _g, _use56, _path80, _use57, _use58, _path81, _use59, _path82, _use60, _path83, _path84, _path85, _path86, _path87, _use61, _path88, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _path89, _use73, _path90, _use74, _use75, _use76, _use77, _path91, _use78, _use79, _use80, _path92, _use81, _path93, _path94, _path95, _path96, _use82, _path97, _path98, _path99, _path100, _use83, _path101, _path102, _path103, _use84, _path104, _use85, _use86, _path105, _use87, _use88, _g2, _path106, _path107, _use89, _path108, _use90, _use91, _use92, _path109, _path110, _use93, _path111, _use94, _use95, _use96, _path112, _use97, _use98, _path113, _path114, _use99, _use100, _use101, _use102, _use103, _use104, _use105, _path115, _use106, _use107, _use108, _use109, _use110, _path116, _use111, _use112, _path117, _g3, _path118, _path119, _use113, _use114, _use115, _use116, _path120, _path121, _path122, _path123, _path124, _use117, _path125, _use118, _path126, _use119, _path127, _use120, _path128, _use121, _path129, _use122, _path130, _use123, _path131, _use124, _use125, _use126, _g4, _use127, _use128, _g5, _use129, _use130, _use131, _use132, _use133, _use134, _use135, _g6, _use136, _use137, _g7, _use138, _use139, _use140, _use141, _use142, _use143, _use144, _use145, _use146, _use147, _use148, _use149, _use150, _use151, _g8, _use152, _use153, _g9, _use154, _use155, _use156, _use157, _use158, _use159, _use160, _use161, _use162, _g10, _g11, _use163, _use164, _use165, _use166, _use167, _use168, _use169, _use170, _use171, _use172, _use173, _use174, _use175, _use176, _use177, _use178, _use179, _use180, _use181, _use182, _g12, _use183, _use184, _use185, _use186, _use187, _use188, _use189, _use190, _use191, _path132, _use192, _use193, _use194, _use195, _use196, _use197, _use198, _path133, _use199, _use200, _use201, _use202, _use203, _use204, _use205, _use206, _use207, _use208, _use209, _use210, _use211, _use212, _g13, _use213, _use214, _g14, _use215, _use216, _use217, _use218, _use219, _use220, _use221, _g15, _use222, _use223, _g16, _use224, _use225, _use226, _use227, _use228, _use229, _use230, _use231, _use232, _use233, _use234, _use235, _use236, _use237, _g17, _use238, _use239, _g18, _use240, _use241, _use242, _use243, _use244, _use245, _use246, _use247, _use248, _path134, _g19, _use249, _use250, _use251, _use252, _use253, _use254, _use255, _use256, _use257, _use258, _use259, _use260, _use261, _use262, _use263, _use264, _use265, _use266, _use267, _use268, _g20, _use269, _use270, _use271, _use272, _use273, _use274, _use275, _use276, _use277, _use278, _use279, _use280, _use281, _use282, _use283, _use284, _use285, _use286, _use287, _use288, _use289, _use290, _use291, _use292, _use293, _use294, _use295, _use296, _use297, _use298, _use299, _use300, _g21, _use301, _use302, _g22, _use303, _use304, _use305, _use306, _use307, _use308, _use309, _g23, _use310, _use311, _g24, _use312, _use313, _use314, _use315, _use316, _use317, _use318, _use319, _use320, _use321, _use322, _use323, _use324, _use325, _g25, _use326, _use327, _g26, _use328, _use329, _use330, _use331, _use332, _use333, _use334, _use335, _use336, _g27, _g28, _use337, _use338, _use339, _use340, _use341, _use342, _use343, _use344, _use345, _use346, _use347, _use348, _use349, _use350, _use351, _use352, _use353, _use354, _use355, _use356, _g29, _use357, _use358, _use359, _use360, _use361, _use362, _use363, _use364, _use365, _use366, _use367, _use368, _use369, _use370, _use371, _use372, _use373, _use374, _use375, _use376, _use377, _use378, _use379, _use380, _use381, _use382, _use383, _use384, _use385, _use386, _use387, _use388, _path135, _use389, _use390, _path136, _path137, _path138, _use391, _use392, _use393, _use394, _path139, _use395, _path140, _path141, _use396, _path142, _path143, _use397, _use398, _use399, _path144, _path145, _use400, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _use401, _use402, _use403, _use404, _path153, _path154, _use405, _path155, _path156, _use406, _use407, _use408, _path157, _use409, _use410, _path158, _path159, _use411, _use412, _path160, _use413, _use414, _use415, _use416, _use417, _path161, _path162, _path163, _use418, _use419, _path164, _use420, _use421, _path165, _use422, _use423, _use424, _use425, _use426, _use427, _path166, _path167, _path168, _path169, _use428, _use429, _use430, _use431, _use432, _use433, _use434, _path170, _path171, _use435, _use436, _path172, _use437, _path173, _path174, _use438, _use439, _path175, _use440, _path176, _use441, _path177, _path178, _path179, _use442, _use443, _use444, _use445, _use446, _use447, _use448, _use449, _path180, _path181, _use450, _path182, _use451, _g30, _use452, _use453, _path183, _path184, _path185, _path186, _path187, _use454, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _use455, _path195, _use456, _use457, _path196, _use458, _use459, _use460, _path197, _path198, _use461, _path199, _use462, _use463, _use464, _use465, _path200, _use466, _use467, _use468, _use469, _use470, _use471, _use472, _use473, _use474, _use475, _use476, _use477, _use478, _use479, _use480, _use481, _use482, _use483, _use484, _use485, _use486, _use487, _use488, _use489, _use490, _use491, _use492, _use493, _use494, _use495, _use496, _path201, _use497, _use498, _use499, _use500, _use501, _use502, _use503, _use504, _use505, _path202, _path203, _path204, _use506, _use507, _use508, _use509, _use510, _path205, _path206, _use511, _use512, _use513, _use514, _path207, _use515, _path208, _path209, _use516, _use517, _use518, _use519, _path210, _use520, _use521, _use522, _use523, _path211, _path212, _path213, _use524, _path214, _path215, _path216, _use525, _use526, _use527, _path217, _path218, _use528, _use529, _use530, _path219, _use531, _use532, _path220, _use533, _path221, _path222, _use534, _use535, _use536, _use537, _use538, _use539, _use540, _path223, _use541, _use542, _use543, _use544, _use545, _use546, _use547, _use548, _use549, _path224, _use550, _use551, _path225, _use552, _use553, _path226, _use554, _path227, _path228, _use555, _use556, _path229, _use557, _use558, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _use559, _use560, _path238, _path239, _path240, _use561, _path241, _path242, _use562, _use563, _path243, _path244, _use564, _use565, _use566, _use567, _path245, _path246, _use568, _use569, _path247, _use570, _path248, _use571, _use572, _use573, _use574, _use575, _use576, _use577, _use578, _use579, _use580, _use581, _use582, _use583, _path249, _path250, _path251, _use584, _use585, _use586, _use587, _use588, _path252, _use589, _use590, _path253, _use591, _use592, _use593, _path254, _use594, _use595, _path255, _use596, _use597, _use598, _use599, _path256, _path257, _path258, _use600, _use601, _path259, _path260, _path261, _path262, _use602, _use603, _use604, _use605, _use606, _use607, _use608, _use609, _path263, _path264, _use610, _path265, _use611, _path266, _path267, _use612, _use613, _path268, _path269, _path270, _path271, _use614, _use615, _use616, _use617, _path272, _path273, _use618, _path274, _use619, _path275, _path276, _path277, _use620, _use621, _path278, _path279, _path280, _path281, _use622, _use623, _use624, _use625, _use626, _use627, _path282, _path283, _use628, _path284, _g31, _path285, _path286, _path287, _use629, _use630, _use631, _use632, _use633, _use634, _path288, _path289, _use635, _use636, _use637, _path290, _path291, _use638, _use639, _use640, _use641, _use642, _use643, _use644, _use645, _path292, _path293, _path294, _use646, _use647, _use648, _path295, _use649, _use650, _use651, _use652, _path296, _use653, _path297, _path298, _use654, _use655, _path299, _path300, _use656, _use657, _path301, _use658, _path302, _path303, _use659, _use660, _use661, _use662, _use663, _use664, _use665, _use666, _path304, _use667, _path305, _path306, _use668, _path307, _use669, _use670, _use671, _path308, _use672, _use673, _path309, _path310, _use674, _use675, _path311, _path312, _path313, _use676, _use677, _use678, _use679, _use680, _use681, _path314, _use682, _path315, _path316, _use683, _use684, _g32, _use685, _use686, _path317, _use687, _path318, _use688, _use689, _use690, _path319, _path320, _path321, _path322, _use691, _use692, _use693, _use694, _g33, _path323, _use695, _path324, _use696, _path325, _use697, _use698, _use699, _path326, _path327, _use700, _use701, _use702, _use703, _use704, _use705, _use706, _use707, _use708, _path328, _use709, _use710, _use711, _use712, _use713, _use714, _use715, _use716, _use717, _use718, _use719, _use720, _path329, _use721, _use722, _use723, _use724, _use725, _use726, _use727, _use728, _use729, _use730, _use731, _use732, _use733, _use734, _use735, _use736, _use737, _use738, _use739, _use740, _use741, _use742, _use743, _use744, _use745, _use746, _use747, _path330, _use748, _use749, _use750, _use751, _use752, _use753, _use754, _use755, _use756, _use757, _path331, _use758, _use759, _use760, _use761, _use762, _use763, _use764, _use765, _use766, _use767, _use768, _use769, _path332, _path333, _use770, _use771, _use772, _use773, _use774, _use775, _use776, _use777, _use778, _use779, _use780, _use781, _path334, _path335, _use782, _use783, _use784, _use785, _use786, _use787, _use788, _use789, _use790, _use791, _path336, _path337, _use792, _use793, _use794, _use795, _use796, _use797, _use798, _use799, _use800, _use801, _use802, _path338, _use803, _use804, _use805, _use806, _use807, _use808, _use809, _use810, _use811, _use812, _use813, _use814, _use815, _use816, _use817, _use818, _use819, _use820, _use821, _use822, _use823, _use824, _use825, _use826, _use827, _use828, _use829, _use830, _use831, _use832, _use833, _path339, _use834, _use835, _use836, _use837, _use838, _use839, _use840, _use841, _use842, _use843, _use844, _use845, _path340, _use846, _use847, _use848, _use849, _use850, _path341, _use851, _use852, _use853, _use854, _use855, _use856, _use857, _use858, _use859, _use860, _use861, _use862, _use863, _use864, _use865, _use866, _use867, _use868, _use869, _path342, _path343, _path344, _use870, _use871, _use872, _use873, _use874, _use875, _use876, _use877, _use878, _use879, _use880, _use881, _use882, _use883, _use884, _use885, _use886, _path345, _path346, _use887, _use888, _use889, _use890, _path347, _path348, _use891, _use892, _use893, _use894, _use895, _use896, _use897, _use898, _use899, _use900, _use901, _use902, _use903, _path349, _path350, _use904, _use905, _use906, _use907, _use908, _use909, _path351, _use910, _use911, _use912, _use913, _path352, _path353, _use914, _use915, _use916, _use917, _use918, _use919, _use920, _use921, _path354, _use922, _use923, _path355, _use924, _use925, _use926, _use927, _use928, _use929, _use930, _use931, _use932, _use933, _use934, _use935, _use936, _use937, _use938, _use939, _use940, _use941, _use942, _use943, _use944, _use945, _use946, _use947, _use948, _use949, _use950, _use951, _use952, _use953, _use954, _use955, _use956, _use957, _use958, _use959, _use960, _use961, _use962, _use963, _use964, _use965, _use966, _use967, _use968, _use969, _path356, _use970, _use971, _path357, _use972, _use973, _use974, _use975, _use976, _use977, _path358, _path359, _use978, _use979, _use980, _use981, _use982, _use983, _use984, _use985, _use986, _use987, _use988, _use989, _use990, _use991, _use992, _use993, _use994, _use995, _path360, _use996, _use997, _use998, _use999, _use1000, _use1001, _use1002, _use1003, _use1004, _path361, _use1005, _use1006, _path362, _use1007, _use1008, _use1009, _use1010, _path363, _use1011, _use1012, _path364, _path365, _use1013, _use1014, _use1015, _path366, _path367, _path368, _use1016, _use1017, _use1018, _use1019, _use1020, _use1021, _use1022, _path369, _path370, _path371, _use1023, _use1024, _path372, _path373, _use1025, _use1026, _use1027, _path374, _use1028, _path375, _path376, _use1029, _use1030, _use1031, _use1032, _use1033, _path377, _use1034, _use1035, _path378, _path379, _use1036, _path380, _use1037, _use1038, _use1039, _use1040, _path381, _path382, _use1041, _use1042, _use1043, _use1044, _use1045, _use1046, _use1047, _use1048, _use1049, _use1050, _path383, _path384, _use1051, _path385, _use1052, _use1053, _use1054, _use1055, _use1056, _path386, _path387, _use1057, _path388, _path389, _use1058, _use1059, _use1060, _use1061, _use1062, _use1063, _path390, _use1064, _path391, _path392, _use1065, _use1066, _use1067, _use1068, _use1069, _use1070, _use1071, _use1072, _use1073, _use1074, _use1075, _use1076, _use1077, _use1078, _use1079, _use1080, _use1081, _use1082, _use1083, _use1084, _use1085, _use1086, _use1087, _use1088, _use1089, _use1090, _use1091, _use1092, _use1093, _use1094, _use1095, _use1096, _path393, _use1097, _path394, _path395, _path396, _path397, _use1098, _use1099, _use1100, _use1101, _use1102, _use1103, _path398, _path399, _path400, _path401, _use1104, _path402, _use1105, _path403, _use1106, _use1107, _use1108, _use1109, _use1110, _use1111, _use1112, _use1113, _use1114, _path404, _path405, _use1115, _use1116, _use1117, _use1118, _use1119, _use1120, _use1121, _use1122, _use1123, _use1124, _use1125, _use1126, _use1127, _use1128, _use1129, _use1130, _use1131, _use1132, _use1133, _use1134, _use1135, _use1136, _use1137, _use1138, _use1139, _use1140, _use1141, _use1142, _use1143, _use1144, _use1145, _use1146, _use1147, _use1148, _use1149, _use1150, _use1151, _use1152, _use1153, _use1154, _use1155, _use1156, _g34, _use1157, _use1158, _use1159, _use1160, _use1161, _use1162, _use1163, _use1164, _use1165, _use1166, _use1167, _use1168, _use1169, _use1170, _use1171, _use1172, _use1173, _use1174, _use1175, _path406, _path407, _use1176, _path408, _path409, _use1177, _use1178, _use1179, _use1180, _use1181, _use1182, _use1183, _use1184, _use1185, _path410, _use1186, _use1187, _path411, _use1188, _use1189, _use1190, _use1191, _use1192, _use1193, _use1194, _use1195, _use1196, _use1197, _use1198, _path412, _path413, _use1199, _use1200, _use1201, _use1202, _use1203, _use1204, _use1205, _use1206, _use1207, _use1208, _use1209, _use1210, _use1211, _use1212, _use1213, _use1214, _use1215, _use1216, _use1217, _path414, _use1218, _use1219, _path415, _use1220, _use1221, _use1222, _path416, _use1223, _use1224, _use1225, _use1226, _path417, _use1227, _g35, _use1228, _use1229, _path418, _path419, _use1230, _path420, _use1231, _use1232, _g36, _use1233, _use1234, _path421, _path422, _path423, _path424, _use1235, _use1236, _use1237, _use1238, _path425, _use1239, _use1240, _use1241, _use1242, _use1243, _use1244, _use1245, _use1246, _use1247, _use1248, _use1249, _use1250, _use1251, _use1252, _use1253, _use1254, _use1255, _use1256, _path426, _path427, _use1257, _use1258, _use1259, _use1260, _use1261, _use1262, _use1263, _use1264, _path428, _use1265, _use1266, _path429, _path430, _use1267, _use1268, _path431, _use1269, _use1270, _use1271, _use1272, _use1273, _use1274, _g37, _use1275, _use1276, _use1277, _use1278, _g38, _use1279, _use1280, _use1281, _use1282, _use1283, _path432, _path433, _path434, _use1284, _use1285, _use1286, _use1287, _use1288, _use1289, _use1290, _use1291, _use1292, _use1293, _use1294, _use1295, _use1296, _use1297, _use1298, _use1299, _use1300, _use1301, _path435, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 514.284,
    height: 512.001,
    viewBox: "0 0 136.071 135.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .B{fill:#242424}.C{fill:#2b2b2b}.D{fill:#7d7d7d}.E{fill:#444}.F{fill:#454545}.G{fill:#f44336}.H{fill:#d2d2d2}.I{fill:#f2f2f2}.J{fill:#f0f0f0}.K{fill:#d0d0d0}.L{fill:#232323}.M{fill:#222}.N{fill:#d1d1d1}.O{fill:#7f7f7f}.P{fill:gray}.Q{fill:#7b7b7b}.R{fill:#7a7a7a}.S{fill:#7e7e7e}.T{fill:#787878}.U{fill:#efefef}.V{fill:#2c2c2c}.W{fill:#f1f1f1}.X{fill:#212121}.Y{fill:#f4f4f4}.Z{fill:#8b8b8b}.a{fill:#383838}.b{fill:#595959}.c{fill:#ebebeb}.d{fill:#fac43c}.e{fill:#f54336}.f{fill:#84b74e}.g{fill:#ececec}.h{fill:#848484}.i{fill:#929292}.j{fill:#f0f2f4}.k{fill:#e6e6e6}.l{fill:#e4e4e4}.m{fill:#4f4f4f}.n{fill:#262626}.o{fill:#585858}.p{fill:#f45a4f}.q{fill-opacity:.875}.r{fill:#ff4040}.s{fill:#8cbc59}.t{fill:#d7d7d7}.u{fill:#cbcbcb}.v{fill:#b8b8b8}.w{fill:#252525}.x{fill:#727272}.y{fill:#a7a7a7}.z{fill:#f5f4f0}.AA{fill:#3687d7}.AB{fill:#272727}.AC{fill:#515151}.AD{fill:#4b4b4b}.AE{fill:#575757}.AF{fill:#bebebe}.AG{fill:#989898}.AH{fill:#accd8a}.AI{fill:#abcd88}.AJ{fill:#f0f2ee}.AK{fill:#86b851}.AL{fill:#f45146}.AM{fill:#f9d57d}.AN{fill:#f2f3f1}.AO{fill:#82b64b}.AP{fill:#8bbc59}.AQ{fill:#f34336}.AR{fill:#636363}.AS{fill:#3e3e3e}.AT{fill:#e5e5e5}.AU{fill:#424242}.AV{fill:#686868}.AW{fill:#bfbfbf}.AX{fill:#565656}.AY{fill:#f6f1e6}.AZ{fill:#71a9e0}.Aa{fill:#3586d7}.Ab{fill:#fac746}.Ac{fill:#313131}.Ad{fill:#b5b5b5}.Ae{fill:#7fb546}.Af{fill:#85b850}.Ag{fill:#eff2ec}.Ah{fill:#7fb446}.Ai{fill:#f45145}.Aj{fill:#f4473a}.Ak{fill:#fbc132}.Al{fill:#f9d57b}.Am{fill:#fbc336}.An{fill:#ff552b}.Ao{fill-opacity:.024}.Ap{fill:#f44335}.Aq{fill:#f3f4f3}.Ar{fill:#f3f4f2}.As{fill:#353535}.At{fill:#dcdcdc}.Au{fill:#c8c8c8}.Av{fill:#363636}.Aw{fill:#f3f3f3}.Ax{fill:#3d3d3d}.Ay{fill:#535353}.Az{fill:#2a2a2a}.BA{fill:#797979}.BB{fill:#767676}.BC{fill:#c4c4c4}.BD{fill:#a0a0a0}.BE{fill:#dadada}.BF{fill:#a2a2a2}.BG{fill:#e2e2e2}.BH{fill:#f5f4f3}.BI{fill:#fac33b}.BJ{fill:#f2f3f4}.BK{fill:#287fd4}.BL{fill:#b3cfea}.BM{fill:#2a80d5}.BN{fill:#f5f4f2}.BO{fill:#fbc747}.BP{fill:#f1f3f4}.BQ{fill:#7cb342}.BR{fill:#fbc02d}.BS{fill:#5e5e5e}.BT{fill:#aeaeae}.BU{fill:#e7e7e7}.BV{fill:#969696}.BW{fill:#d8d8d8}.BX{fill:#2d2d2d}.BY{fill:#9b9b9b}.BZ{fill:#acacac}.Ba{fill:#3f3f3f}.Bb{fill:#95c167}.Bc{fill:#82b64a}.Bd{fill:#82b74b}.Be{fill:#e2ebda}.Bf{fill:#f1f3ef}.Bg{fill:#e3ebdb}.Bh{fill:#e9efe3}.Bi{fill:#f4685e}.Bj{fill:#f48a82}.Bk{fill:#f48981}.Bl{fill:#f44b3f}.Bm{fill:#f4dad8}.Bn{fill:#f5eeee}.Bo{fill:#f4dbd9}.Bp{fill:#f5e4e2}.Bq{fill:#fbc337}.Br{fill:#f44f42}.Bs{fill:#f24336}.Bt{fill-opacity:.075}.Bu{fill-opacity:.953}.Bv{fill:#f34436}.Bw{fill:#ff4d33}.Bx{fill-opacity:.039}.By{fill:#dce7d0}.Bz{fill:#9ac46f}.CA{fill:#d0e1bf}.CB{fill:#83b74d}.CC{fill:#b7d39a}.CD{fill-opacity:.031}.CE{fill:#f1f3f0}.CF{fill-opacity:.925}.CG{fill:#f64236}.CH{fill-opacity:.318}.CI{fill:#cfe0bd}.CJ{fill-opacity:.016}.CK{fill:#dbe7ce}.CL{fill:#bfd8a5}.CM{fill:#a1a1a1}.CN{fill:#dfdfdf}.CO{fill:#737373}.CP{fill:#606060}.CQ{fill:#face5f}.CR{fill:#f7e5b9}.CS{fill:#fac33a}.CT{fill:#fac339}.CU{fill:#f8d98d}.CV{fill:#272521}.CW{fill:#dfac2b}.CX{fill:#1e79d3}.CY{fill:#5096db}.CZ{fill:#277ed4}.Ca{fill:#267ed4}.Cb{fill:#2b80d5}.Cc{fill:#85b4e3}.Cd{fill:#83b3e3}.Ce{fill:#ecf0f3}.Cf{fill:#eff1f4}.Cg{fill:#f5f2ec}.Ch{fill:#fac645}.Ci{fill:#f7e4b5}.Cj{fill:#fac238}.Ck{fill:#ebeff3}.Cl{fill:#3385d6}.Cm{fill:#f6e9ca}.Cn{fill:#e4ebf2}.Co{fill:#237cd4}.Cp{fill:#afccea}.Cq{fill:#257dd3}.Cr{fill:#c5d9ed}.Cs{fill:#6fa8e0}.Ct{fill:#f8de9b}.Cu{fill:#92bce6}.Cv{fill-opacity:.518}.Cw{fill-opacity:.569}.Cx{fill-opacity:.102}.Cy{fill-opacity:.945}.Cz{fill-opacity:.216}.DA{fill-opacity:.608}.DB{fill-opacity:.765}.DC{fill-opacity:.929}.DD{fill-opacity:.451}.DE{fill-opacity:.682}.DF{fill-opacity:.533}.DG{fill-opacity:.816}\n    ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 119.621,
    height: 95.232,
    x: 12.62,
    y: 16.404,
    ry: 6.521,
    className: "k"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m105.623 84.353.037-.11H135.942v.588l-.037.11q-.037.11.046.193l.083.083.018-.018.018-.018-.037.037q-.037.037-.055.092l-.018.055.028-.083.028-.083-.037.11-.037.11v2.94h-.147q-.147 0-.184.11-.037.11.046.193l.083.083.018-.018.018-.018-.037.037q-.037.037-.055.092l-.018.055.028-.083.028-.083-.037.11q-.037.11-.037.257v1.029h-.147q-.147 0-.184.11-.037.11.046.193l.083.083.018-.018.018-.018-.037.037q-.037.037-.055.092l-.018.055.028-.083.028-.083-.037.11q-.037.11-.037.257V91.299h-.147q-.147 0-.184.11-.037.11.046.193l.083.083.018-.018.018-.018-.037.037q-.037.037-.055.092l-.018.055.028-.083.028-.083-.037.11q-.037.11-.037.257V92.475h-.147q-.147 0-.184.11-.037.11.046.193l.083.083.018-.018.018-.018-.037.037q-.037.037-.055.092l-.018.055.028-.083.028-.083-.037.11q-.037.11-.037.257v.147h-.147q-.147 0-.184.11-.037.11.046.193l.083.083.018-.018.018-.018-.037.037q-.037.037-.055.092l-.018.055.028-.083.028-.083-.037.11q-.037.11-.037.257v.147h-.147q-.147 0-.184.11-.037.11.046.193l.083.083.018-.018.018-.018-.037.037q-.037.037-.055.092l-.018.055.028-.083.028-.083-.037.11q-.037.11-.037.257v.147h-.147q-.147 0-.184.11-.037.11.046.193l.083.083.018-.018.018-.018-.037.037q-.037.037-.055.092l-.018.055.028-.083.028-.083-.037.11q-.037.11-.037.257v.147l-.11.037q-.11.037-.147.147-.037.11-.037.257v.147l-.11.037q-.11.037-.147.147-.037.11-.037.257v.147h-.147q-.147 0-.184.11-.037.11.046.193l.083.083.018-.018.018-.018-.037.037q-.037.037-.055.092l-.018.055.028-.083.028-.083-.037.11-.037.11h-.147q-.147 0-.184.11-.037.11.051.188l.087.078.014-.014.014-.014-.028.028q-.028.028-.028.064v.037-.11.146-.11.037q0 .037.028.064l.028.028-.014-.014-.014-.014-.101.083-.101.083.014.014.014.014-.028-.028q-.028-.028-.083-.046l-.055-.018.083.028.083.028-.11-.037q-.11-.037-.11.11V98.943h-.147q-.147 0-.147.147v.147l-.037.11q-.037.11-.147.147-.11.037-.11.184v.147h-.147q-.147 0-.147.147v.147l-.037.11q-.037.11-.147.147-.11.037-.11.184v.147l-.037.11q-.037.11-.147.147-.11.037-.11.184v.147h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.147.147v.147l-.037.11q-.037.11-.147.147-.11.037-.11.184v.147h-.147q-.147 0-.147.147v.147l-.037.11q-.037.11-.147.147-.11.037-.11.184v.147h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.147.147v.147l-.037.11q-.037.11-.147.147-.11.037-.147.147-.037.11-.147.147-.11.037-.147.147-.037.11-.147.147-.11.037-.147.147-.037.11-.147.147-.11.037-.147.147-.037.11-.147.147-.11.037-.147.147-.037.11-.147.147l-.11.037h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.184.11-.037.11-.147.147l-.11.037h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.147.147v.147H123.154q-.147 0-.147.147v.147h-.147q-.147 0-.147.147v.147h-.147q-.147 0-.184.11-.037.11-.147.147l-.11.037h-.147q-.147 0-.147.147v.147H121.39q-.147 0-.147.147v.147h-.147q-.147 0-.184.11-.037.11-.147.147l-.11.037h-.147q-.147 0-.147.147v.147H119.92q-.147 0-.147.147v.147H119.332q-.147 0-.147.147v.147H118.744q-.147 0-.147.147v.147H118.156q-.147 0-.184.11-.037.11-.147.147l-.11.037h-.147q-.147 0-.184.11-.037.11-.147.147l-.11.037H116.686q-.147 0-.184.11-.037.11-.147.147l-.11.037H115.804q-.147 0-.147.147v.147h-.735q-.147 0-.147.147v.147h-.735q-.147 0-.147.147v.147h-1.029q-.147 0-.147.147v.147h-1.029q-.147 0-.184.11-.037.11-.147.147l-.11.037h-1.323q-.147 0-.184.11-.037.11-.147.147l-.11.037H106.102q-.147 0-.147.147v.147H105.073v-.147q0-.147-.147-.147H101.839l-.11-.037q-.11-.037-.147-.147-.037-.11-.184-.11h-1.323l-.11-.037q-.11-.037-.147-.147-.037-.11-.184-.11h-1.029v-.147q0-.147-.147-.147h-1.029v-.147q0-.147-.147-.147h-.735v-.147q0-.147-.147-.147h-.735v-.147q0-.147-.147-.147h-.735v-.147q0-.147-.147-.147H94.195l-.11-.037q-.11-.037-.147-.147-.037-.11-.184-.11h-.147l-.11-.037q-.11-.037-.147-.147-.037-.11-.184-.11H92.725v-.147q0-.147-.147-.147H92.137v-.147q0-.147-.147-.147H91.549v-.147q0-.147-.147-.147h-.147l-.11-.037q-.11-.037-.147-.147-.037-.11-.184-.11h-.147l-.11-.037q-.11-.037-.147-.147-.037-.11-.184-.11h-.147v-.147q0-.147-.147-.147H89.491v-.147q0-.147-.147-.147h-.147l-.11-.037q-.11-.037-.147-.147-.037-.11-.184-.11h-.147v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.147-.147H87.727v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.147-.147h-.147l-.11-.037q-.11-.037-.147-.147-.037-.11-.184-.11h-.147v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.147-.147h-.147l-.11-.037q-.11-.037-.147-.147-.037-.11-.147-.147-.11-.037-.147-.147-.037-.11-.147-.147-.11-.037-.147-.147-.037-.11-.147-.147-.11-.037-.147-.147-.037-.11-.147-.147-.11-.037-.147-.147-.037-.11-.147-.147-.11-.037-.147-.147l-.037-.11v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.11-.184-.11-.037-.147-.147-.037-.11-.147-.147-.11-.037-.147-.147l-.037-.11v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.11-.184-.11-.037-.147-.147l-.037-.11v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.147-.147h-.147v-.147q0-.147-.11-.184-.11-.037-.147-.147l-.037-.11v-.147q0-.147-.147-.147h-.147V99.972q0-.147-.147-.147h-.147v-.147q0-.147-.11-.184-.11-.037-.147-.147l-.037-.11v-.147q0-.147-.11-.184-.11-.037-.147-.147l-.037-.11.11-.037q.11-.037.152-.142l.041-.106-.032.004-.032.004.064-.009q.064-.009.138-.009h.073-.22.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037q.11-.037.152-.142l.041-.106-.032.004-.032.004.064-.009q.064-.009.138-.009h.074-.22.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037q.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037q.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037q.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037q.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037q.11-.037.147-.147m30.023 5.806V89.9v.294-.037m.294-1.764v-.257.294",
    className: "G"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.66 53.815v-.147h.294v.147q0 .147.147.147h1.029l.11.037q.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037.11.037h2.058v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037q.11.037.257.037h1.029v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037q.11.037.257.037H112.716v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037q.11.037.257.037H113.892v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037q.11.037.257.037h.147v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037q.11.037.257.037h.147v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037q.11.037.257.037h.147v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037q.11.037.257.037h.147l.037.11q.037.11.147.147.11.037.257.037h.147v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037.11.037v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037.11.037v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037.11.037v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037.11.037v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037.11.037.037.11q.037.11.147.147l.11.037v.147q0 .147.11.184.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037.11.037v.147q0 .147.11.184.11.037.147.147.037.11.147.147.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037.11.037v.147q0 .147.11.184.11.037.147.147.037.11.147.147.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037.11.037.037.11q.037.11.147.147l.11.037v.147q0 .147.11.184.11.037.147.147.037.11.147.147.11.037.193-.046l.083-.083-.018-.018-.018-.018.037.037q.037.037.092.055l.055.018-.083-.028-.083-.028.11.037.11.037.037.11q.037.11.11.184l.147.147.147.147q.074.073.11.184.037.11.147.147.11.037.147.147.037.11.147.147.11.037.147.147.037.11.147.147.11.037.147.147.037.11.147.147.11.037.184-.037l.074-.073.073.073.147.147.147.147.147.147.147.147.147.147.147.147.147.147.073.073-.073.073q-.073.074-.037.184.037.11.147.147.11.037.147.147.037.11.147.147.11.037.147.147.037.11.147.147.11.037.147.147.037.11.147.147.11.037.184.11l.147.147.147.147q.073.073.184.11l.11.037.037.11.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.147.147.11.037.147.147.037.11.147.147.11.037.184.11.073.074.184.11l.11.037.037.11.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.147.147.11.037.147.147.037.11.184.11h.147l.037.11.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.147.147.11.037.147.147.037.11.184.11h.147l.037.11.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147l.037.11q.037.11.147.147l.11.037v.147q0 .147.037.257.037.11.147.147l.11.037.037.11.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147l.037.11.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147l.037.11.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147l.037.11.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147v.147q0 .147.037.257.037.11.147.147l.11.037v.147q0 .147.037.257l.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147v.147q0 .147.037.257l.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147v.147q0 .147.037.257l.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147v.147q0 .147.037.257l.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147V76.452q0 .147.037.257l.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147V77.628q0 .147.037.257l.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147v1.176l.037.11.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193.037.11.184.11h.147V82.479l.037.11.037.11-.028-.083-.028-.083.018.055q.018.055.055.092l.037.037-.018-.018-.018-.018-.083.083q-.083.083-.046.193l.037.11v1.176H105.66V53.818m22.141 9.499-.018-.018-.055-.055-.055-.055.037.037.073.074.037.037-.018-.018m-1.139-1.139-.055-.055-.018-.018-.018-.018.037.037.073.074.037.037-.055-.055m-20.891-8.507h-.184.293-.11",
    className: "BQ"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.366 53.815v-.147h.294V84.244h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037q-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037q-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037q-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037q-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11h-.147q-.147 0-.257.037-.11.037-.147.147l-.037.11-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.147.147-.037.11-.147.147-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046-.11.037-.147.147-.037.11-.147.147-.11.037-.11.184v.147l-.11.037-.11.037.083-.028.083-.028-.055.018q-.055.018-.092.055l-.037.037.018-.018.018-.018-.083-.083q-.083-.083-.193-.046l-.11.037V97.915q0-.147-.147-.147h-.147V97.327q0-.147-.147-.147h-.147V96.739q0-.147-.11-.184-.11-.037-.147-.147l-.037-.11V95.857q0-.147-.147-.147h-.147V95.269q0-.147-.147-.147h-.147v-.735q0-.147-.147-.147h-.147v-.735q0-.147-.147-.147h-.147v-.735q0-.147-.11-.184-.11-.037-.147-.147l-.037-.11v-.735q0-.147-.147-.147h-.147v-1.029q0-.147-.11-.184-.11-.037-.147-.147l-.037-.11v-1.323q0-.147-.11-.184-.11-.037-.147-.147l-.037-.11V80.422l.037-.11q.037-.11.147-.147.11-.037.11-.184v-1.323l.037-.11q.037-.11.147-.147.11-.037.11-.184v-1.029h.147q.147 0 .147-.147v-1.029h.147q.147 0 .147-.147v-.735h.147q.147 0 .147-.147v-.735h.147q.147 0 .147-.147v-.735h.147q.147 0 .147-.147V72.778l.037-.11q.037-.11.147-.147.11-.037.11-.184V71.896h.147q.147 0 .147-.147V71.308h.147q.147 0 .147-.147v-.147l.037-.11q.037-.11.147-.147.11-.037.11-.184V70.132h.147q.147 0 .147-.147v-.147l.037-.11q.037-.11.147-.147.11-.037.11-.184v-.147l.037-.11q.037-.11.147-.147.11-.037.11-.184v-.147h.147q.147 0 .147-.147V68.074h.147q.147 0 .147-.147v-.147h.147q.147 0 .147-.147V67.192h.147q.147 0 .147-.147V66.9h.147q.147 0 .147-.147V66.312h.147q.147 0 .147-.147v-.147h.147q.147 0 .147-.147v-.147l.037-.11q.037-.11.147-.147.11-.037.11-.184v-.147h.147q.147 0 .147-.147v-.147h.147q.147 0 .147-.147v-.147h.147q.147 0 .147-.147v-.147h.147q.147 0 .147-.147v-.147h.147q.147 0 .147-.147v-.147l.037-.11q.037-.11.147-.147.11-.037.147-.147.037-.11.147-.147.11-.037.147-.147.037-.11.147-.147.11-.037.147-.147.037-.11.147-.147.11-.037.092-.202l-.018-.165.129-.018q.129-.018.202-.092l.147-.147.073-.073-.055.055-.055.055.037-.037q.037-.037.064-.083l.028-.046-.014.023-.014.023.078.078q.078.078.188.041t.147-.147.147-.147.147-.147.147-.147.147-.147q.037-.11.11-.184.073-.074.11-.184l.037-.11.11-.037q.11-.037.147-.147l.037-.11.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.147-.147.037-.11.147-.147.11-.037.11-.184v-.147l.11-.037q.11-.037.147-.147l.037-.11.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037q.11-.037.147-.147l.037-.11.11-.037q.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037q.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037.11-.037.147-.147l.037-.11h.147q.147 0 .257-.037l.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147h.147q.147 0 .257-.037l.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147h.147q.147 0 .257-.037l.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147h.147q.147 0 .257-.037l.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147H97.869q.147 0 .257-.037l.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147H99.045q.147 0 .257-.037l.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147h1.029q.147 0 .257-.037l.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046.11-.037.11-.184v-.147H104.484l.11-.037.11-.037-.083.028-.083.028.055-.018q.055-.018.092-.055l.037-.037-.018.018-.018.018.083.083q.083.083.193.046l.11-.037h.147q.147 0 .147-.147m.331-.147h-.257.293",
    className: "BR"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m71.317 107.706.037-.095-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264-.198.066q.066 0 .124-.008l.058-.008-.029.004-.029.004.004.136q.004.136-.095.169t-.174-.041l-.074-.074-.016.017-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.037-.095",
    className: "H"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    className: "P"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.816 107.735v-.132l.099-.033q.099-.033.174.041l.074.074.016-.017.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132",
    className: "F"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    className: "C"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    className: "AB"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    className: "Ac"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m23.158 107.768-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.016.074-.074q.074-.074.174-.041l.099.033v.264h-.264l-.033-.099",
    fill: "#414141"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#F",
    className: "BS"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -0.794,
    className: "P"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m22.431 107.702-.033-.099h.264v.264l-.099-.033q-.099-.033-.132-.132m.066-.099h-.165.264-.099",
    className: "BT"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G",
    className: "l"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.639 107.5q.037-.095.103-.161l.066-.066.066.066.066.066-.066.066q-.066.066-.165.099l-.099.033.074-.025.074-.025-.05.016q-.05.017-.107.025l-.058.008.029-.004.029-.004.037-.095m.252-.046.05-.05.016-.017.016-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.345 107.471q0-.132.099-.165t.169.037l.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132",
    className: "B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.133 107.471v-.132h.132q.132 0 .132.132v.132h-.264v-.132m.165.132h.165-.264.099",
    className: "M"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m21.839 107.5-.037-.095.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.017.017.016.074-.074q.074-.074.174-.041l.099.033v.264h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095",
    className: "AC"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#H",
    fill: "#9d9d9d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m21.343 107.467.004-.136-.029-.004-.029-.004.058.008q.058.008.124.008h.066-.198.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.017-.074.074q-.075.074-.174.041-.099-.033-.095-.169",
    className: "BU"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    className: "W"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m71.875 107.206.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.016.017-.05.05-.016.016-.016.017.033-.033.066-.066.033-.033-.05.05m.066.198.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m21.31 107.235-.037-.095.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.017.017.016.074-.074q.074-.074.174-.041.099.033.095.169l-.004.136.029.004.029.004-.058-.008q-.058-.008-.124-.008h-.066.198-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095",
    className: "C"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#H",
    x: -0.529,
    y: -0.265,
    fill: "#818181"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m20.822 107.194.012-.145-.021-.012-.021-.012.041.025q.041.025.107.025h.066-.198.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.016-.074.074q-.074.074-.174.041-.099-.033-.087-.178",
    fill: "#e1e1e1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.139 106.942q.066-.066.161-.103l.095-.037.004-.029.004-.029-.008.058q-.008.058-.025.107l-.016.05.025-.074.025-.074-.033.099q-.033.099-.099.165l-.066.066-.066-.066-.066-.066.066-.066m-.016.017-.05.05-.016.016-.016.017.033-.033.066-.066.033-.033-.05.05m.066.198.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033",
    className: "D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m20.777 106.975-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.017.074-.074q.074-.074.174-.041.099.033.099.165v.132h-.132q-.132 0-.165-.099",
    className: "C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m20.579 106.909-.033-.099.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.017.05q.017.05.058.074l.041.025-.021-.012-.021-.012-.112-.021q-.112-.021-.145-.12m.041-.074-.074-.025-.025-.008-.025-.008.05.016.099.033.05.016-.074-.025",
    className: "BV"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m20.248 106.975-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.017.078-.079.078-.079-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.016-.074.074q-.074.074-.174.041-.099-.033-.132-.132m.322-.157-.025-.008-.074-.025-.074-.025.05.017.099.033.05.017-.025-.008",
    className: "I"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.404 106.677v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.016q.05-.017.083-.05l.033-.033-.016.017-.016.016.074.074q.074.074.041.174-.033.099-.169.095l-.136-.004-.004.029-.004.029.008-.058q.008-.058.008-.124v-.066.198-.132",
    className: "H"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.106 106.644q.033-.099.165-.099h.132v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.016q-.05.017-.091.041l-.041.025.021-.012.021-.012-.07-.07q-.07-.07-.037-.169",
    className: "B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m20.281 106.677-.066-.066.074-.074.074-.074-.017-.016-.017-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.099.165v.132l-.099-.033q-.099-.033-.165-.099m.19.107.074.025.025.008.025.008-.05-.017-.099-.033-.05-.017.074.025m-.273-.19.017.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "AD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m19.983 106.71-.033-.099.025.074.025.074-.017-.05q-.017-.05-.041-.091l-.025-.041.012.021.012.021.07-.07.07-.07.066.066.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.078.078-.078.079.017.017.017.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132m.149-.182-.05-.05-.017-.017-.017-.016.033.033.066.066.033.033-.05-.05",
    className: "BW"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    className: "O"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K",
    className: "BX"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m19.752 106.412-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.07.07-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m.347.083-.017-.017-.05-.05-.05-.05.033.033.066.066.033.033-.017-.016m-.232-.232-.05-.05-.017-.016-.017-.017.033.033.066.066.033.033-.05-.05m-.198.066.017.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "Ad"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m72.371 106.115.033-.099h.264v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.016q-.05.017-.083.05l-.033.033.016-.017.016-.016-.074-.074q-.074-.074-.041-.174",
    className: "F"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K",
    x: -0.264,
    y: -0.264,
    className: "B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m19.487 105.883-.066-.066.074-.074.074-.074-.017-.017-.017-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.016-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.017.016.017.017-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.017.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "M"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m19.223 105.883-.066-.066.066-.066.066-.066.066.066.132.132.132.132.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132-.132-.132-.132-.132m.413.413.05.05.017.016.017.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.017-.017-.05-.05-.05-.05.033.033.066.066.033.033-.017-.016m-.496-.496-.05-.05-.017-.016-.017-.017.033.033.066.066.033.033-.05-.05m-.198.066.017.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#a3a3a3"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    className: "C"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M",
    className: "B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m18.958 105.619-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07.07-.07.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.017.016.017.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.017-.017-.05-.05-.05-.05.033.033.066.066.033.033-.017-.016m-.232-.232-.05-.05-.017-.016-.017-.017.033.033.066.066.033.033-.05-.05",
    className: "Ad"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.371 105.387q-.033-.099.041-.174l.074-.074-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.264l-.033-.099",
    className: "F"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M",
    x: -0.265,
    y: -0.265,
    className: "V"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m18.66 105.387-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.017.017.016.078-.078.079-.079-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.066.066-.07.07-.07.07.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.017-.017-.05-.05-.05-.05.033.033.066.066.033.033",
    className: "BW"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N",
    className: "O"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m18.726 105.056-.033-.099h.132q.132 0 .165.099l.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.016-.074.074-.074.074-.066-.066q-.066-.066-.099-.165m.116.182.05.05.017.017.017.016-.033-.033-.066-.066-.033-.033.05.05m-.157-.306.008.025.025.074.025.074-.017-.05-.033-.099-.017-.05.008.025",
    className: "AD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.396 105.123q-.033-.099.041-.174l.074-.074-.017-.017-.017-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.041.091l.025.041-.012-.021-.012-.021-.079.079-.078.079.017.016.017.017-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.322-.091-.025-.074-.008-.025-.008-.025.017.05.033.099.017.05-.025-.074",
    className: "I"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M72.404 104.825v-.132.198-.066q0-.066-.008-.124l-.008-.058.004.029.004.029.136-.004q.136-.004.169.095t-.041.174l-.074.074.016.016.016.017-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132",
    className: "H"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M72.106 104.858q-.033-.099.037-.169l.07-.07-.021-.012-.021-.012.041.025q.041.025.091.041l.05.016-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.132q-.132 0-.165-.099",
    className: "B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m18.474 104.779-.021-.112-.012-.021-.012-.021.025.041q.025.041.074.058l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.099-.033q-.099-.033-.12-.145m.227.203-.008-.025-.025-.074-.025-.074.017.05.033.099.017.05-.008-.025",
    className: "BV"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m72.139 104.56-.066-.066.066-.066.066-.066.066.066q.066.066.099.165l.033.099-.025-.074-.025-.074.016.05q.016.05.025.107l.008.058-.004-.029-.004-.029-.095-.037q-.095-.037-.161-.103m.116-.149-.05-.05-.016-.017-.016-.016.033.033.066.066.033.033-.05-.05m-.198.066.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "Q"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.429 104.56v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.017.017.017.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.099-.165",
    className: "C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.131 104.593q-.033-.099.041-.174l.074-.074-.017-.017-.017-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264-.198.066q0 .066.025.107l.025.041-.012-.021-.012-.021-.145.012q-.145.012-.178-.087",
    fill: "#e0e0e0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m71.875 104.296-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.016.016.016.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.232-.232-.05-.05-.016-.016-.016-.017.033.033.066.066.033.033-.05-.05m-.198.066.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "AE"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    className: "P"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P",
    className: "J"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m71.639 104.002-.037-.095-.029-.004-.029-.004.058.008q.058.008.107.025l.05.017-.074-.025-.074-.025.099.033q.099.033.165.099l.066.066-.066.066-.066.066-.066-.066q-.066-.066-.103-.161m.12.178.05.05.016.017.016.016-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033",
    className: "R"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M71.345 104.031v-.132h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07q-.07.07-.169.037-.099-.033-.099-.165",
    className: "B"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Q",
    className: "C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.867 104.064q-.033-.099.041-.174l.074-.074-.017-.016-.017-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264-.198.066q0 .066.008.124l.008.058-.004-.029-.004-.029-.136.004q-.136.004-.169-.095",
    className: "k"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m71.317 103.796-.037-.095.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.016.074-.074q.074-.074.174-.041.099.033.095.169l-.004.136.029.004.029.004-.058-.008q-.058-.008-.124-.008h-.066.198-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095",
    className: "N"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    className: "S"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70.816 103.767v-.132h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074q-.074.074-.174.041l-.099-.033v-.132",
    className: "E"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    className: "C"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: -0.264,
    y: -0.529,
    fill: "#9d9d9d"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T",
    className: "c"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m23.427 103.531-.037-.095.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.016.074-.074q.074-.074.174-.041l.099.033v.264h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095",
    className: "N"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#H",
    x: 1.587,
    y: -3.969,
    className: "BV"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m22.931 103.498.004-.136-.029-.004-.029-.004.058.008q.058.008.124.008h.066-.198.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074q-.074.074-.174.041-.099-.033-.095-.169",
    className: "E"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U",
    className: "m"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m22.898 103.266-.037-.095.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.07-.07q.07-.07.169-.037.099.033.099.165v.132h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095",
    className: "I"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m22.662 103.237-.066-.066.066-.066.066-.066.066.066q.066.066.103.161l.037.095.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.165-.099m.116-.149-.05-.05-.016-.016-.016-.017.033.033.066.066.033.033-.05-.05m-.198.066.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "BY"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 103.237v-.132h.132q.132 0 .132.132v.132H17.9v-.132m0-.165v.231-.264",
    className: "M"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.602 103.271q-.033-.099.041-.174l.074-.074-.017-.016-.017-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099m.298-.066v-.165.264-.099",
    fill: "#e3e3e3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m22.398 102.973-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.016.016.016.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.232-.232-.05-.05-.016-.016-.016-.017.033.033.066.066.033.033-.05-.05m-.198.066.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "AF"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V",
    className: "n"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m17.668 102.94-.033-.099h.264v.264l-.099-.033q-.099-.033-.132-.132m.232.198v-.231.264",
    className: "BZ"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m22.166 102.675-.033-.099.025.074.025.074-.017-.05q-.017-.05-.025-.107l-.008-.058.004.029.004.029.095.037q.095.037.161.103l.066.066-.066.066-.066.066-.066-.066q-.066-.066-.099-.165m.116.182.05.05.016.016.016.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033",
    fill: "#9c9c9c"
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -5.821,
    y: -5.027,
    className: "O"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W",
    className: "I"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M21.835 102.477q-.033-.099.041-.174l.074-.074-.017-.017-.017-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264-.198.066q0 .066.008.124l.008.058-.004-.029-.004-.029-.136.004q-.136.004-.169-.095",
    className: "F"
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#F",
    x: -5.292,
    y: -5.291,
    fill: "#5d5d5d"
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 3.704,
    y: -2.117,
    className: "AG"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M17.635 102.179v-.132h.264l.033.099q.033.099-.041.174l-.074.074.017.017.017.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132",
    className: "Ba"
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U",
    x: 3.968,
    y: -1.587,
    className: "H"
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -5.821,
    y: -5.82,
    className: "Ac"
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    x: -1.852,
    y: -6.085,
    className: "c"
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    x: -6.085,
    y: -6.085,
    className: "n"
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    x: -4.498,
    y: -17.198,
    fill: "#80b547"
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T",
    x: 29.898,
    y: -16.933,
    className: "Ae"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M66.021 86.337q-.033-.099.041-.174l.074-.074-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.264l-.033-.099",
    fill: "#86b951"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M53.618 86.304v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.017.083-.05l.033-.033-.016.017-.016.016.074.074q.074.074.041.174l-.033.099h-.264v-.132",
    className: "Af"
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X",
    fill: "#97c26a"
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y",
    className: "Bb"
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Z",
    className: "AH"
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    className: "AI"
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#cbdeb8"
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "#caddb6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M66.054 85.246v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.016.016.016.017-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132m0 .033v.165-.264.099",
    className: "Ag"
  })), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    className: "Bc"
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    fill: "#81b649"
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    className: "Ag"
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N",
    x: -6.615,
    y: -20.108,
    fill: "#aece8c"
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    x: -18.521,
    y: -21.432,
    fill: "#aacc87"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M65.789 84.717v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.016.017.016.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132",
    fill: "#eaefe4"
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: -0.264,
    y: -0.529,
    className: "Bd"
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 0.265,
    y: -0.529,
    fill: "#7eb445"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M53.85 84.684q.033-.099.165-.099h.132v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.016q-.05.017-.083.05l-.033.033.016-.017.016-.016-.074-.074q-.074-.074-.041-.174",
    className: "Be"
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    fill: "#b8d49a"
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    fill: "#b2d092"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m65.492 84.22-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.079-.079.079-.079-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132t-.041.174l-.074.074.016.017.016.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033-.033-.099",
    className: "AJ"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m65.26 84.187-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07.07-.07.066.066q.066.066.099.165l.033.099-.099-.033q-.099-.033-.165-.099m.116-.149-.05-.05-.016-.016-.016-.017.033.033.066.066.033.033-.05-.05",
    fill: "#94c066"
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    fill: "#92bf63"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M54.114 84.154q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.017.083-.05l.033-.033-.016.017-.016.016.079.079.079.079.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099-.033.099-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.017-.083.05l-.033.033.016-.017.016-.016-.074-.074q-.074-.074-.041-.174",
    className: "Bf"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m65.26 83.923-.066-.066.07-.07.07-.07-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.016-.079.078-.079.079.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m-.083-.083.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#eaefe4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M54.379 83.89q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.017.091-.041l.041-.025-.021.012-.021.012.07.07.07.07-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.079-.079-.079-.079-.016.017-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.314.017.05-.05.016-.017.016-.016-.033.033-.066.066-.033.033.05-.05",
    className: "Bg"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m64.995 83.658-.066-.066.07-.07.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.07.07-.07.07-.066-.066-.132-.132m.149.149.05.05.016.017.016.016-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#dfe9d5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m64.698 83.691-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.07-.07.07-.07.066.066.132.132.132.132.132.132.066.066-.07.07-.07.07.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132t-.132-.132-.132-.132m.645.314-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.496-.496-.05-.05-.016-.016-.016-.017.033.033.066.066.033.033-.05-.05",
    fill: "#89ba56"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m54.941 83.658.132-.132.066-.066.07.07.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132t-.132.132-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.016-.091.041l-.041.025.021-.012.021-.012-.07-.07-.07-.07.066-.066.132-.132.132-.132m-.281.281-.05.05-.016.016-.016.017.033-.033.066-.066.033-.033-.05.05m.496-.496-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "AK"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m54.677 83.658.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07.07.07-.066.066-.132.132-.066.066-.07-.07-.07-.07-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066m.05.215.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.016-.033.033-.066.066-.033.033.05-.05",
    fill: "#dee8d3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m64.731 83.394-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.079-.078.079-.079-.016-.017-.016-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07-.07.07-.066-.066-.132-.132m.149.149.05.05.016.016.016.017-.033-.033-.066-.066-.033-.033.05.05",
    className: "Bh"
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    fill: "#97c26a"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M55.206 83.394q.066-.066.165-.099l.099-.033-.033.099q-.033.099-.099.165l-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07-.07-.07.066-.066m-.016.016-.05.05-.016.017-.016.016.033-.033.066-.066.033-.033-.05.05",
    fill: "#91be61"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M54.908 83.361q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.017.083-.05l.033-.033-.016.017-.016.016.079.079.079.079.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.066.066-.07-.07-.07-.07-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033",
    className: "Bg"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m64.433 83.162-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.017.074-.074q.074-.074.174-.041.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.079.079-.079.079.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.017.074.025.074.025-.099-.033-.099-.033-.033-.099",
    className: "Bf"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m64.231 83.1-.037-.095-.029-.004-.029-.004.058.008q.058.008.107.025l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.099-.033q-.099-.033-.136-.128",
    fill: "#b3d194"
  })), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    className: "Ah"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m55.706 83.1.037-.095-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198H56v.132q0 .132-.099.165t-.174-.041l-.074-.074-.016.017-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.037-.095",
    fill: "#7eb445"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M55.504 83.162q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.016.107-.025l.058-.008-.029.004-.029.004-.037.095q-.037.095-.136.128l-.099.033.033-.099",
    fill: "#b2d092"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M55.173 83.096q.033-.099.132-.132t.174.041l.074.074.016-.017.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.017-.091.041l-.041.025.021-.012.021-.012-.079-.079-.079-.079-.016.017-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099",
    className: "AJ"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m63.908 82.893-.037-.095.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.017.074-.074q.074-.074.174-.041.099.033.099.165v.132h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095",
    className: "Bg"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m63.701 82.836-.037-.095-.029-.004-.029-.004.058.008q.058.008.107.025l.05.016-.074-.025-.074-.025.099.033q.099.033.136.128l.037.095.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.136-.128",
    fill: "#abcd87"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#81b649"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: -0.529,
    y: -0.264
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.235 82.836.037-.095-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264v.132q0 .132-.099.165t-.174-.041l-.074-.074-.016.017-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.037-.095"
  }))), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: -15.081,
    y: -24.871,
    fill: "#aacc87"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M55.735 82.865q0-.132.099-.165t.174.041l.074.074.016-.016.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132",
    className: "Be"
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    className: "Ag"
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    fill: "#cbdeb7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m62.883 82.596-.004-.128h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.004.128.004.128h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.004-.128m.161.136h.165-.264.099m-.066-.265h-.165.264-.099",
    fill: "#accd89"
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    className: "Bb"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M62.35 82.6v-.132h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074q-.074.074-.174.041l-.099-.033V82.6",
    className: "AK"
  })), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    x: -8.467,
    y: -21.167,
    className: "Ah"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M57.852 82.6v-.132H62.091v.132q0 .132.132.132h.132l.099.033q.099.033.174-.041l.074-.074-.016-.017-.016-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.232.033h.397v.132q0 .132.099.165t.174-.041l.074-.074-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.174-.041l.074-.074-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033.033.099q.033.099.099.165t.099.165q.033.099.132.132t.132.132.132.132q.099.033.165.099t.165.099l.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.016-.074.074q-.074.074-.041.174.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.016-.074.074q-.074.074-.041.174.033.099.165.099h.132v.397q0 .132.033.232l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.016-.074.074q-.074.074-.041.174l.033.099v.132q0 .132.132.132h.132V103.66H53.609V86.701h.132q.132 0 .132-.132v-.132l.033-.099q.033-.099-.041-.174l-.074-.074-.016.016-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099q.033-.099.033-.232v-.397h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.016-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.016-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099.099-.033q.099-.033.165-.099t.165-.099q.099-.033.132-.132t.132-.132.132-.132q.033-.099.099-.165t.099-.165l.033-.099.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.017.083-.05l.033-.033-.016.017-.016.016.074.074q.074.074.174.041.099-.033.099-.165v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.016.083-.05l.033-.033-.016.016-.016.017.074.074q.074.074.174.041.099-.033.099-.165v-.132h.397q.132 0 .232-.033l.099-.033-.074.025-.074.025.05-.017q.05-.016.083-.05l.033-.033-.016.016-.016.017.074.074q.074.074.174.041l.099-.033h.132q.132 0 .132-.132m-4.266 21.034h.231-.264.033m12.634 0h.165-.264.099",
    className: "BQ"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M57.587 82.6v-.132h.264v.132q0 .132-.132.132h-.132V82.6",
    className: "Ah"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m57.289 82.567.033-.099h.264v.264l-.099.033q-.099.033-.174-.041l-.074-.074-.016.016-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099",
    className: "AK"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m57.054 82.596.004-.128h.264l-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.017-.107.025l-.058.008.029-.004.029-.004.004-.128m.103-.128h-.165.264-.099",
    className: "Bb"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m56.798 82.604.004-.128-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264l-.004.128-.004.128.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264l.004-.128m-.037.128h.231-.264.033m.331-.265h-.231.264",
    className: "AI"
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    fill: "#caddb6"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M56.264 82.6q0-.132.099-.165t.174.041l.074.074.016-.016.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.264V82.6m.165.132h.165-.264.099",
    className: "Ag"
  })), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    fill: "#f4483c"
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    fill: "#f4473b"
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X",
    x: -29.633,
    y: -6.085,
    fill: "#f45246"
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y",
    x: -29.633,
    y: -6.086,
    className: "Ai"
  })), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    fill: "#f46a60"
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    className: "Bi"
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    className: "Bj"
  })), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    className: "Bk"
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: -29.634,
    y: -6.35,
    fill: "#f4b8b3"
  })), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: -29.633,
    y: -6.35,
    fill: "#f4b6b2"
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v",
    fill: "#f5ecec"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M36.123 78.929q-.033-.099.041-.174l.074-.074-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099m.298-.066v-.165.264-.099",
    className: "Bl"
  })), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    fill: "#f44a3e"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M23.952 78.863q.033-.099.165-.099h.132v.264l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.016-.083.05l-.033.033.016-.016.016-.017-.074-.074q-.074-.074-.041-.174m.298.198v-.231.264",
    fill: "#f5eceb"
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    fill: "#f58c85"
  })), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    fill: "#f4877f"
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z",
    fill: "#f5e4e3"
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: -0.529,
    y: -1.852,
    fill: "#f54c3f"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24.514 78.367v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.017.083-.05l.033-.033-.016.017-.016.016.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132",
    fill: "#f44639"
  })), _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AA",
    className: "Bm"
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    fill: "#f49b94"
  })), _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    fill: "#f4938c"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m35.858 77.87-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.017.079-.079.079-.079-.021-.012-.021-.012.041.025q.041.025.091.041l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132t-.041.174l-.074.074.016.017.016.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033-.033-.099",
    className: "Bn"
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: -0.264,
    y: -0.265,
    fill: "#f4675c"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M24.779 77.837v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.128-.004.128-.004-.033.099q-.033.099-.132.132l-.099.033v-.132",
    fill: "#f46459"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M24.481 77.804q.033-.099.165-.099h.132v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.017-.083.05l-.033.033.016-.017.016-.016-.074-.074q-.074-.074-.041-.174",
    fill: "#f5efef"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M35.627 77.573v-.132l.099.033q.099.033.165.099l.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.079.079-.079.079.016.016.016.017-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132",
    fill: "#f5e4e3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M24.812 77.606q.033-.099.099-.165l.066-.066.07.07.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099-.033.099-.128.004-.128.004-.004.029-.004.029.008-.058q.008-.058.025-.107l.016-.05-.025.074-.025.074.033-.099m.182-.248-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "Bo"
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: -0.529,
    y: -0.794,
    fill: "#f5d5d3"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m35.131 77.275-.033-.099h.264l.033.099q.033.099.132.132l.099.033v.264l-.099-.033q-.099-.033-.165-.099l-.132-.132q-.066-.066-.099-.165",
    fill: "#f4574b"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M25.308 77.308q.066-.066.165-.099l.099-.033-.033.099q-.033.099-.099.165l-.132.132q-.066.066-.165.099l-.099.033.033-.099q.033-.099.099-.165l.132-.132",
    className: "AL"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m25.043 77.308.132-.132.066-.066.07.07.07.07.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07-.07-.07.066-.066m-.016.017-.05.05-.016.016-.016.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#f5d3d0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m35.064 77.077-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.017.079-.079.079-.079-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066q.066.066.099.165l.033.099h-.264l-.033-.099",
    className: "Bp"
  })), _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: -1.058,
    y: -1.058,
    fill: "#f46a60"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m25.577 77.048.004-.128-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264l-.033.099q-.033.099-.132.132l-.099.033.004-.128",
    fill: "#f46157"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M25.308 77.044q.066-.066.165-.099l.099-.033-.074.025-.074.025.05-.016q.05-.017.107-.025l.058-.008-.029.004-.029.004-.004.128-.004.128-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.016-.091.041l-.041.025.021-.012.021-.012-.07-.07-.07-.07.066-.066m-.016.017-.05.05-.016.016-.016.017.033-.033.066-.066.033-.033-.05.05",
    className: "Bo"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m34.8 76.812-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.016.074-.074q.074-.074.174-.041.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.079.079-.079.079.016.017.016.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033-.033-.099",
    fill: "#f5efef"
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: -1.323,
    y: -1.323,
    fill: "#f4948d"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M34.304 76.779v-.132h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074q-.074.074-.174.041-.099-.033-.099-.165",
    className: "Aj"
  })), _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AD",
    fill: "#f44639"
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 1.323,
    y: -1.323,
    fill: "#f4938c"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M25.573 76.779q0-.132.099-.165t.174.041l.074.074.016-.017.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.264v-.132",
    className: "Bn"
  })), _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AE",
    className: "Bo"
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AF",
    fill: "#f48880"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f44a3e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G",
    x: 11.642,
    y: -31.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.598 76.481.033-.099h.264v.132q0 .132-.099.165t-.174-.041l-.074-.074-.016.017-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.132-.099h-.165.264-.099"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m26.366 76.515.008-.124-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264l-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.017-.107.025l-.058.008.029-.004.029-.004.008-.124m.298-.132h-.231.264",
    fill: "#f4877f"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M26.135 76.548q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.017.107-.025l.058-.008-.029.004-.029.004-.008.124-.008.124.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264l.033-.099",
    className: "Bm"
  })), _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: -29.633,
    y: -6.35,
    fill: "#f5ecec"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m33.506 76.254-.004-.128-.029-.004-.029-.004.058.008q.058.008.107.025l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099h-.264l-.004-.128m-.029.128h.231-.264.033m.198 0h.165-.264.099",
    fill: "#f4b7b3"
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AG",
    fill: "#f48982"
  })), _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AH",
    className: "Bi"
  })), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AI",
    className: "AL"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M32.452 76.25v-.132h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.016-.074.074q-.074.074-.174.041-.099-.033-.099-.165",
    className: "Aj"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M28.218 76.25v-.132H32.457v.132q0 .132.099.165t.174-.041l.074-.074-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.232.033h.662v.132q0 .132.099.165t.174-.041l.074-.074-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.174-.041l.074-.074-.016-.017-.016-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033.033.099q.033.099.132.132l.099.033.033.099q.033.099.099.165l.132.132q.066.066.165.099l.099.033.033.099q.033.099.132.132l.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132v.662q0 .132.033.232l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132V103.671v-.198.066q0 .066.033.099l.033.033-.016-.016-.016-.017-.149.017q-.149.016-.281.016H24.375q-.132 0-.281-.016l-.149-.017-.016.017-.016.016.033-.033q.033-.033.033-.099v-.066.198V80.353h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.017-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099q.033-.099.033-.232v-.662h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.017-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.017-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099.099-.033q.099-.033.132-.132l.033-.099.099-.033q.099-.033.165-.099l.132-.132q.066-.066.099-.165l.033-.099.099-.033q.099-.033.132-.132l.033-.099.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.016.083-.05l.033-.033-.016.016-.016.017.074.074q.074.074.174.041.099-.033.099-.165v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.016.083-.05l.033-.033-.016.016-.016.017.074.074q.074.074.174.041.099-.033.099-.165v-.132h.662q.132 0 .232-.033l.099-.033-.074.025-.074.025.05-.016q.05-.017.083-.05l.033-.033-.016.017-.016.016.074.074q.074.074.174.041.099-.033.099-.165",
    className: "G"
  })), _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AD",
    x: 1.852,
    y: -0.529,
    className: "Aj"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m27.685 76.246.004-.128h.264l-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.016-.107.025l-.058.008.029-.004.029-.004.004-.128m.103-.128h-.165.264-.099",
    className: "AL"
  })), _use94 || (_use94 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AJ",
    className: "Bi"
  })), _use95 || (_use95 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AK",
    className: "Bk"
  })), _use96 || (_use96 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    x: -29.633,
    y: -6.35,
    fill: "#f4b6b2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M26.631 76.25q0-.132.099-.165t.174.041l.074.074.016-.017.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.264v-.132m.165.132h.165-.264.099",
    fill: "#f5eceb"
  })), _use97 || (_use97 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    x: -19.315,
    y: -29.898,
    fill: "#fbc233"
  })), _use98 || (_use98 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T",
    x: 15.082,
    y: -29.633,
    className: "Ak"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M51.204 73.637q-.033-.099.041-.174l.074-.074-.016-.017-.016-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.264h-.264l-.033-.099m.298-.066v-.165.264-.099",
    fill: "#fac43e"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M38.802 73.604v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.016.083-.05l.033-.033-.016.016-.016.017.074.074q.074.074.041.174l-.033.099h-.264v-.132m0-.165v.231-.264",
    className: "d"
  })), _use99 || (_use99 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AL",
    fill: "#facc59"
  })), _use100 || (_use100 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AM",
    fill: "#facb57"
  })), _use101 || (_use101 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Z",
    x: -14.817,
    y: -12.7,
    className: "AM"
  })), _use102 || (_use102 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: -14.816,
    y: -12.7,
    className: "Al"
  })), _use103 || (_use103 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: -14.817,
    y: -12.7,
    fill: "#f7e3b0"
  })), _use104 || (_use104 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: -14.816,
    y: -12.7,
    fill: "#f7e2af"
  })), _use105 || (_use105 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v",
    x: 14.817,
    y: -6.35,
    fill: "#f6f3eb"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M50.939 72.579q-.033-.099.041-.174l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099m.298-.066v-.165.264-.099",
    className: "Am"
  })), _use106 || (_use106 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    x: 14.816,
    y: -6.35,
    fill: "#fbc235"
  })), _use107 || (_use107 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: -14.816,
    y: -12.7,
    fill: "#f6f3ea"
  })), _use108 || (_use108 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    x: 14.817,
    y: -6.35,
    fill: "#f9d67f"
  })), _use109 || (_use109 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    x: 14.816,
    y: -6.35,
    fill: "#f9d47a"
  })), _use110 || (_use110 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z",
    x: 14.817,
    y: -6.35,
    fill: "#f6f0e2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M50.675 72.05q-.033-.099.041-.174l.074-.074-.016-.017-.016-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099",
    className: "Bq"
  })), _use111 || (_use111 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: 15.346,
    y: -8.202,
    fill: "#fbc130"
  })), _use112 || (_use112 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AA",
    x: 14.816,
    y: -6.35,
    fill: "#f5edd7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M43.035 69.9v-.132H47.274v.132q0 .132.132.132h.132l.099.033q.099.033.174-.041l.074-.074-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.232.033h.397v.132q0 .132.099.165t.174-.041l.074-.074-.016-.017-.016-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.174-.041l.074-.074-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033.033.099q.033.099.132.132l.099.033.033.099q.033.099.099.165l.132.132q.066.066.165.099l.099.033.033.099q.033.099.132.132l.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.016-.074.074q-.074.074-.041.174.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.016-.074.074q-.074.074-.041.174.033.099.165.099h.132v.397q0 .132.033.232l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.016-.074.074q-.074.074-.041.174l.033.099v.132q0 .132.132.132h.132V103.68H38.793V74.001h.132q.132 0 .132-.132v-.132l.033-.099q.033-.099-.041-.174l-.074-.074-.016.016-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099q.033-.099.033-.232v-.397h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.016-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.016-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099.099-.033q.099-.033.132-.132l.033-.099h.132q.132 0 .165-.099t.132-.132.132-.132q.033-.099.099-.165t.099-.165l.033-.099.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.017.083-.05l.033-.033-.016.017-.016.016.074.074q.074.074.174.041.099-.033.099-.165v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.016.083-.05l.033-.033-.016.016-.016.017.074.074q.074.074.174.041.099-.033.099-.165v-.132h.397q.132 0 .232-.033l.099-.033-.074.025-.074.025.05-.016q.05-.017.083-.05l.033-.033-.016.017-.016.016.074.074q.074.074.174.041l.099-.033h.132q.132 0 .132-.132m-4.266 33.734h.231-.264.033m12.634 0h.165-.264.099",
    className: "BR"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    x: -48.948,
    y: -36.248
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T",
    x: -6.085,
    y: -35.983
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M21.571 67.287q-.033-.099.041-.174l.074-.074-.017-.017-.017-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.264l-.033-.099",
    className: "F"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M17.635 67.254v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.017q.05-.016.083-.05l.033-.033-.017.016-.017.017.074.074q.074.074.041.174l-.033.099h-.264v-.132",
    className: "E"
  })), _use113 || (_use113 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 3.44,
    y: -37.307,
    className: "O"
  })), _use114 || (_use114 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    className: "D"
  })), _use115 || (_use115 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Q",
    x: 3.44,
    y: -37.306,
    className: "H"
  })), _use116 || (_use116 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AO",
    className: "B"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 66.725v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.017q.05-.016.091-.041l.041-.025-.021.012-.021.012.07.07q.07.07.037.169-.033.099-.165.099H17.9v-.132",
    className: "L"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M17.602 66.692q.033-.099.169-.095l.136.004.004-.029.004-.029-.008.058q-.008.058-.008.124v.066-.198.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.016q-.05.017-.083.05l-.033.033.017-.017.017-.016-.074-.074q-.074-.074-.041-.174",
    className: "K"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m21.339 66.46-.066-.066.066-.066.066-.066.066.066q.066.066.099.165l.033.099-.025-.074-.025-.074.017.05q.017.05.025.107l.008.058-.004-.029-.004-.029-.095-.037q-.095-.037-.161-.103m.116-.149-.05-.05-.017-.016-.017-.017.033.033.066.066.033.033-.05-.05m-.198.066.017.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "Q"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M17.933 66.493q.033-.099.099-.165l.066-.066.066.066.066.066-.066.066q-.066.066-.161.103l-.095.037-.004.029-.004.029.008-.058q.008-.058.025-.107l.017-.05-.025.074-.025.074.033-.099m.248-.05.05-.05.017-.017.017-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "T"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m21.075 66.196-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.017.016.017.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.017-.017-.05-.05-.05-.05.033.033.066.066.033.033-.017-.016m-.232-.232-.05-.05-.017-.016-.017-.017.033.033.066.066.033.033-.05-.05m-.198.066.017.017.05.05.05.05-.033-.033-.066-.066-.033-.033m-2.811.099.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.017.016-.05.05-.017.017-.017.016.033-.033.066-.066.033-.033-.05.05m.066.198.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.017m.232-.232.05-.05.017-.017.017-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "AE"
  })), _use117 || (_use117 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P",
    x: -50.8,
    y: -38.1,
    className: "J"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m20.839 65.902-.037-.095-.029-.004-.029-.004.058.008q.058.008.107.025l.05.016-.074-.025-.074-.025.099.033q.099.033.165.099l.066.066-.066.066-.066.066-.066-.066q-.066-.066-.103-.161m.12.178.05.05.017.016.017.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.017-.017-.05-.05-.05-.05.033.033.066.066.033.033",
    className: "R"
  })), _use118 || (_use118 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AP",
    className: "B"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M18.958 65.931v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.016.083-.05l.033-.033-.017.016-.017.017.074.074q.074.074.174.041l.099-.033h.529l.099.033q.099.033.174-.041l.074-.074-.017-.016-.017-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.169-.037l.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.132.132.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.07.07q-.07.07-.037.17.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.016-.074.074q-.075.074-.041.174l.033.099v.132q0 .132.132.132h.132V101.962q0 .132.033.232l.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.017-.074.074q-.074.074-.041.174.033.099.169.095l.136-.004-.004-.029-.004-.029.008.058q.008.058.025.107l.017.05-.025-.074-.025-.074.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.041.091l.025.041-.012-.021-.012-.021-.07.07q-.07.07-.037.169.033.099.132.132t.132.132.132.132q.099.033.169-.037l.07-.07-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.099.033.099.033-.074-.025-.074-.025.05.016q.05.017.107.025l.058.008-.029-.004-.029-.004-.004.136q-.004.136.095.169t.174-.041l.074-.074-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.232.033h.396-.198.066q.066 0 .099-.033l.033-.033-.016.017-.016.016.149.017q.149.016.281.016H36.304q.132 0 .281-.016l.149-.017-.016-.016-.016-.017.033.033q.033.033.099.033h.066-.198H70.621v.132q0 .132.132.132h.132l.099.033q.099.033.174-.041l.074-.074-.016-.017-.016-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.169-.037l.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.132.132.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.07.07q-.07.07-.037.17.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074q-.074.074-.041.174l.033.099v.529l-.033.099q-.033.099.041.174l.074.074.016-.016.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.132q-.132 0-.165.099t.037.169l.07.07.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.132.132-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07q-.07-.07-.17-.037-.099.033-.099.165v.132l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.016-.083.05l-.033.033.016-.016.016-.017-.074-.074q-.074-.074-.174-.041l-.099.033h-.132q-.132 0-.132.132v.132H23.981v-.132q0-.132-.132-.132h-.396l-.099-.033q-.099-.033-.174.041l-.074.074.016.016.016.017-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033h-.528v-.132q0-.132-.132-.132h-.132l-.099-.033q-.099-.033-.174.041l-.074.074.017.017.017.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033.074.025.074.025-.05-.016q-.05-.017-.107-.025l-.058-.008.029.004.029.004.004-.136q.004-.136-.095-.169t-.174.041l-.074.074.017.016.017.017-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132q0-.132-.099-.165t-.174.041l-.074.074.017.017.017.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132q0-.132-.099-.165t-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132q-.033-.099-.165-.099h-.132l-.033-.099-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.017.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132l-.033-.099-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.017.074-.074q.074-.074.041-.174-.033-.099-.169-.095l-.136.004.004.029.004.029-.008-.058q-.008-.058-.025-.107l-.017-.05.025.074.025.074-.033-.099-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.017.017.016.074-.074q.074-.074.041-.174l-.033-.099v-.132q0-.132-.132-.132h-.132v-.528l-.033-.099-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.017.017.016.074-.074q.074-.074.041-.174l-.033-.099v-.396q0-.132-.132-.132h-.132V67.645h.132q.132 0 .132-.132v-.132l.033-.099q.033-.099-.041-.174l-.074-.074-.017.016-.017.017.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.037-.169l-.07-.07-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066.132-.132.132-.132.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07q.07.07.17.037.099-.033.099-.165m-1.058 37.075v.165-.264.099m.769 1.877.025.074.008.025.008.025-.017-.05-.033-.099-.017-.05.025.074m1.852 1.918.025.008.074.025.074.025-.05-.017-.099-.033-.05-.017.025.008m1.844.802h.231-.264",
    className: "X"
  })), _use119 || (_use119 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AQ",
    className: "L"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M18.429 65.931q.066-.066.165-.099l.099-.033-.074.025-.074.025.05-.017q.05-.016.107-.025l.058-.008-.029.004-.029.004-.037.095q-.037.095-.103.161l-.066.066-.066-.066-.066-.066.066-.066m-.017.016-.05.05-.017.017-.017.016.033-.033.066-.066.033-.033-.05.05m.066.198.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033",
    className: "T"
  })), _use120 || (_use120 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AR",
    className: "U"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m20.517 65.696-.037-.095.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.017.074-.074q.074-.074.174-.041.099.033.095.169l-.004.136.029.004.029.004-.058-.008q-.058-.008-.124-.008h-.066.198-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095",
    className: "N"
  })), _use121 || (_use121 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AS",
    className: "S"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M20.016 65.667v-.132h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.016-.074.074q-.074.074-.174.041l-.099-.033v-.132",
    className: "E"
  })), _use122 || (_use122 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AT",
    className: "C"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "m19.194 65.638.037-.095-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264v.264l-.099.033q-.099.033-.174-.041l-.074-.074-.017.016-.017.017.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.037-.095",
    className: "E"
  })), _use123 || (_use123 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: -52.123,
    y: -42.068,
    className: "D"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M18.698 65.671q-.004-.136.095-.169t.174.041l.074.074.017-.017.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264.198-.066q-.066 0-.124.008l-.058.008.029-.004.029-.004-.004-.136",
    className: "K"
  })), _use124 || (_use124 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AU",
    className: "H"
  })), _use125 || (_use125 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AV",
    className: "P"
  })), _use126 || (_use126 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AW",
    className: "F"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 47.982,
    y: -59.184
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    x: 75.499,
    y: -59.184
  }))), _use127 || (_use127 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AX",
    className: "F"
  })), _use128 || (_use128 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AS",
    x: 78.409,
    y: -17.116,
    className: "O"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "H"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AY"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AU",
    x: -25.4
  }))), _use129 || (_use129 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AV",
    x: -25.4,
    className: "P"
  })), _use130 || (_use130 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AW",
    x: -25.4,
    className: "F"
  })), _use131 || (_use131 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AT",
    x: 73.382,
    y: -17.116,
    className: "C"
  })), _use132 || (_use132 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AX",
    x: -6.35,
    className: "F"
  })), _use133 || (_use133 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AS",
    x: 72.059,
    y: -17.116,
    className: "O"
  })), _use134 || (_use134 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AY",
    x: -6.35,
    className: "H"
  })), _use135 || (_use135 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AZ",
    className: "D"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aa"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ab"
  }))), _use136 || (_use136 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ac",
    className: "Q"
  })), _use137 || (_use137 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AZ",
    x: -25.4,
    className: "D"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aa",
    x: -25.4
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ab",
    x: -6.35
  }))), _use138 || (_use138 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ac",
    x: -6.35,
    className: "Q"
  })), _use139 || (_use139 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    x: 47.982,
    y: -59.184,
    className: "W"
  })), _use140 || (_use140 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ad",
    className: "b"
  })), _use141 || (_use141 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ae",
    className: "o"
  })), _use142 || (_use142 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V",
    x: 75.499,
    y: -54.951,
    className: "J"
  })), _use143 || (_use143 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    x: 22.582,
    y: -59.184,
    className: "W"
  })), _use144 || (_use144 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ad",
    x: -25.4,
    className: "b"
  })), _use145 || (_use145 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ae",
    x: -6.35,
    className: "o"
  })), _use146 || (_use146 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V",
    x: 69.149,
    y: -54.951,
    className: "J"
  })), _use147 || (_use147 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Af",
    className: "D"
  })), _use148 || (_use148 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ag",
    className: "R"
  })), _use149 || (_use149 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Af",
    x: -25.4,
    className: "D"
  })), _use150 || (_use150 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ag",
    x: -6.35,
    className: "R"
  })), _use151 || (_use151 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ah",
    className: "H"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ai"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aj"
  }))), _use152 || (_use152 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ak",
    className: "N"
  })), _use153 || (_use153 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ah",
    x: -25.4,
    className: "H"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ai",
    x: -25.4
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aj",
    x: -6.35
  }))), _use154 || (_use154 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ak",
    x: -6.35,
    className: "N"
  })), _use155 || (_use155 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 102.751,
    y: -19.762,
    className: "P"
  })), _use156 || (_use156 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 79.203,
    y: -57.068,
    className: "S"
  })), _use157 || (_use157 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 77.351,
    y: -19.762,
    className: "P"
  })), _use158 || (_use158 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 72.853,
    y: -57.068,
    className: "S"
  })), _use159 || (_use159 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Al",
    className: "F"
  })), _use160 || (_use160 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Am",
    className: "E"
  })), _use161 || (_use161 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Al",
    x: -25.4,
    className: "F"
  })), _use162 || (_use162 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Am",
    x: -6.35,
    className: "E"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "V"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 96.93,
    y: -61.036
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 71.53,
    y: -61.036
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 96.93,
    y: -61.301
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: 24.963,
    y: -59.185
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 71.53,
    y: -61.301
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: 18.613,
    y: -59.185
  }))), _use163 || (_use163 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#An",
    className: "F"
  })), _use164 || (_use164 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ao",
    className: "E"
  })), _use165 || (_use165 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#An",
    x: -25.4,
    className: "F"
  })), _use166 || (_use166 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ao",
    x: -6.35,
    className: "E"
  })), _use167 || (_use167 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 102.222,
    y: -58.391,
    className: "O"
  })), _use168 || (_use168 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 79.732,
    y: -21.085,
    className: "D"
  })), _use169 || (_use169 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 76.822,
    y: -58.391,
    className: "O"
  })), _use170 || (_use170 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 73.382,
    y: -21.085,
    className: "D"
  })), _use171 || (_use171 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ap",
    className: "H"
  })), _use172 || (_use172 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AO",
    x: 98.782,
    y: -21.084,
    className: "B"
  })), _use173 || (_use173 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aq",
    className: "L"
  })), _use174 || (_use174 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ar",
    className: "K"
  })), _use175 || (_use175 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ap",
    x: -25.4,
    className: "H"
  })), _use176 || (_use176 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AO",
    x: 73.382,
    y: -21.084,
    className: "B"
  })), _use177 || (_use177 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aq",
    x: -6.35,
    className: "L"
  })), _use178 || (_use178 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ar",
    x: -6.35,
    className: "K"
  })), _use179 || (_use179 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#As",
    className: "Q"
  })), _use180 || (_use180 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#At",
    className: "T"
  })), _use181 || (_use181 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#As",
    x: -25.4,
    className: "Q"
  })), _use182 || (_use182 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#At",
    x: -6.35,
    className: "T"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "AE"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Au"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Au",
    x: -25.4
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    x: -6.35
  }))), _use183 || (_use183 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P",
    x: 47.982,
    y: -59.184,
    className: "J"
  })), _use184 || (_use184 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aw",
    className: "R"
  })), _use185 || (_use185 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AP",
    x: 98.782,
    y: -21.084,
    className: "B"
  })), _use186 || (_use186 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AQ",
    x: 79.732,
    y: -21.084,
    className: "L"
  })), _use187 || (_use187 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ax",
    className: "T"
  })), _use188 || (_use188 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AR",
    x: 79.732,
    y: -21.084,
    className: "U"
  })), _use189 || (_use189 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P",
    x: 22.582,
    y: -59.184,
    className: "J"
  })), _use190 || (_use190 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aw",
    x: -25.4,
    className: "R"
  })), _use191 || (_use191 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AP",
    x: 73.382,
    y: -21.084,
    className: "B"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M92.34 44.847v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.017.017-.017.017.074.074q.074.074.174.041l.099-.033h.529l.099.033q.099.033.174-.041l.074-.074-.017-.017-.017-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.169-.037l.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.132.132.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.07.07q-.07.07-.037.17.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.017-.074.074q-.074.074-.041.174l.033.099v.528l-.033.099q-.033.099.041.174l.074.074.017-.017.017-.017-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099h-.132q-.132 0-.165.099t.037.169l.07.07.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.132.132-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07q-.07-.07-.17-.037-.099.033-.099.165v.132l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074q-.074-.074-.174-.041l-.099.033h-.529l-.099-.033q-.099-.033-.174.041l-.074.074.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132q0-.132-.099-.165t-.169.037l-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132-.132-.132-.132-.132-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07q.07-.07.037-.17-.033-.099-.165-.099h-.132l-.033-.099-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.017.017.017.074-.074q.074-.074.041-.174l-.033-.099v-.529l.033-.099q.033-.099-.041-.174l-.074-.074-.017.017-.017.017.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.037-.169l-.07-.07-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066.132-.132.132-.132.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07q.07.07.17.037.099-.033.099-.165",
    className: "X"
  })), _use192 || (_use192 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AQ",
    x: 73.382,
    y: -21.084,
    className: "L"
  })), _use193 || (_use193 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ax",
    x: -6.35,
    className: "T"
  })), _use194 || (_use194 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AR",
    x: 73.382,
    y: -21.084,
    className: "U"
  })), _use195 || (_use195 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ay",
    className: "N"
  })), _use196 || (_use196 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 47.982,
    y: -59.185,
    className: "S"
  })), _use197 || (_use197 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Az",
    className: "E"
  })), _use198 || (_use198 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    x: 47.982,
    y: -59.185,
    className: "C"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M99.484 44.582v-.132H118.563v.132q0 .132.132.132h.132l.099.033q.099.033.174-.041l.074-.074-.017-.017-.017-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.169-.037l.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.132.132.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.07.07q-.07.07-.037.17.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.017-.074.074q-.074.074-.041.174l.033.099v.528l-.033.099q-.033.099.041.174l.074.074.017-.017.017-.017-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099h-.132q-.132 0-.165.099t.037.169l.07.07.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.132.132-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07q-.07-.07-.17-.037-.099.033-.099.165v.132l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074q-.074-.074-.174-.041l-.099.033h-.132q-.132 0-.132.132v.132H99.483v-.132q0-.132-.132-.132h-.132l-.099-.033q-.099-.033-.174.041l-.074.074.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132q0-.132-.099-.165t-.169.037l-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132-.132-.132-.132-.132-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07q.07-.07.037-.17-.033-.099-.165-.099h-.132l-.033-.099-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.017.017.017.074-.074q.074-.074.041-.174l-.033-.099v-.529l.033-.099q.033-.099-.041-.174l-.074-.074-.017.017-.017.017.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.037-.169l-.07-.07-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066.132-.132.132-.132.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07q.07.07.17.037.099-.033.099-.165v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.017.017-.017.017.074.074q.074.074.174.041l.099-.033h.132q.132 0 .132-.132",
    className: "X"
  })), _use199 || (_use199 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T",
    x: 75.499,
    y: -58.92,
    className: "C"
  })), _use200 || (_use200 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BA",
    className: "E"
  })), _use201 || (_use201 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    className: "D"
  })), _use202 || (_use202 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BC",
    className: "K"
  })), _use203 || (_use203 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ay",
    x: -25.4,
    className: "N"
  })), _use204 || (_use204 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 22.582,
    y: -59.185,
    className: "S"
  })), _use205 || (_use205 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Az",
    x: -25.4,
    className: "E"
  })), _use206 || (_use206 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AT",
    x: 73.382,
    y: -21.085,
    className: "C"
  })), _use207 || (_use207 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BA",
    x: -6.35,
    className: "E"
  })), _use208 || (_use208 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    x: -6.35,
    className: "D"
  })), _use209 || (_use209 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BC",
    x: -6.35,
    className: "K"
  })), _use210 || (_use210 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BD",
    className: "H"
  })), _use211 || (_use211 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    x: 20.373,
    y: -4.498,
    className: "P"
  })), _use212 || (_use212 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BE",
    className: "F"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 47.982,
    y: -67.651
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    x: 75.499,
    y: -67.651
  }))), _use213 || (_use213 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BF",
    className: "F"
  })), _use214 || (_use214 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 27.609,
    y: -63.683,
    className: "O"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "H"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BG"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BD",
    x: -25.4
  }))), _use215 || (_use215 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    x: -5.027,
    y: -4.498,
    className: "P"
  })), _use216 || (_use216 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BE",
    x: -25.4,
    className: "F"
  })), _use217 || (_use217 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AT",
    x: 73.382,
    y: -25.583,
    className: "C"
  })), _use218 || (_use218 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BF",
    x: -6.35,
    className: "F"
  })), _use219 || (_use219 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 21.259,
    y: -63.683,
    className: "O"
  })), _use220 || (_use220 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BG",
    x: -6.35,
    className: "H"
  })), _use221 || (_use221 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BH",
    className: "D"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aa",
    y: -8.467
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ab",
    y: -8.466
  }))), _use222 || (_use222 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BI",
    className: "Q"
  })), _use223 || (_use223 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BH",
    x: -25.4,
    className: "D"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aa",
    x: -25.4,
    y: -8.467
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ab",
    x: -6.35,
    y: -8.466
  }))), _use224 || (_use224 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BI",
    x: -6.35,
    className: "Q"
  })), _use225 || (_use225 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    x: 47.982,
    y: -67.651,
    className: "W"
  })), _use226 || (_use226 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    x: 21.961,
    y: -5.557,
    className: "b"
  })), _use227 || (_use227 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Au",
    x: -21.961,
    y: -5.557,
    className: "o"
  })), _use228 || (_use228 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V",
    x: 75.499,
    y: -63.418,
    className: "J"
  })), _use229 || (_use229 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    x: 22.582,
    y: -67.651,
    className: "W"
  })), _use230 || (_use230 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    x: -3.439,
    y: -5.557,
    className: "b"
  })), _use231 || (_use231 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Au",
    x: -28.311,
    y: -5.557,
    className: "o"
  })), _use232 || (_use232 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V",
    x: 69.149,
    y: -63.418,
    className: "J"
  })), _use233 || (_use233 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BJ",
    className: "D"
  })), _use234 || (_use234 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BK",
    className: "R"
  })), _use235 || (_use235 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BJ",
    x: -25.4,
    className: "D"
  })), _use236 || (_use236 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BK",
    x: -6.35,
    className: "R"
  })), _use237 || (_use237 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BL",
    className: "H"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BM"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W",
    x: 75.499,
    y: -63.418
  }))), _use238 || (_use238 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BN",
    className: "N"
  })), _use239 || (_use239 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BL",
    x: -25.4,
    className: "H"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BM",
    x: -25.4
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W",
    x: 69.149,
    y: -63.418
  }))), _use240 || (_use240 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BN",
    x: -6.35,
    className: "N"
  })), _use241 || (_use241 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 102.751,
    y: -28.228,
    className: "P"
  })), _use242 || (_use242 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 79.203,
    y: -65.535,
    className: "S"
  })), _use243 || (_use243 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 77.351,
    y: -28.228,
    className: "P"
  })), _use244 || (_use244 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 72.853,
    y: -65.535,
    className: "S"
  })), _use245 || (_use245 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Al",
    y: -8.467,
    className: "F"
  })), _use246 || (_use246 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Am",
    y: -8.467,
    className: "E"
  })), _use247 || (_use247 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Al",
    x: -25.4,
    y: -8.467,
    className: "F"
  })), _use248 || (_use248 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Am",
    x: -6.35,
    y: -8.467,
    className: "E"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M120.386 38.232V38.1h.264v.264h-.264v-.132m-25.4 0V38.1h.264v.264h-.264v-.132",
    className: "V"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 96.93,
    y: -69.767
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: 24.963,
    y: -67.651
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 71.53,
    y: -69.767
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: 18.613,
    y: -67.651
  }))), _use249 || (_use249 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#An",
    y: -8.467,
    className: "F"
  })), _use250 || (_use250 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ao",
    y: -8.467,
    className: "E"
  })), _use251 || (_use251 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#An",
    x: -25.4,
    y: -8.467,
    className: "F"
  })), _use252 || (_use252 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ao",
    x: -6.35,
    y: -8.467,
    className: "E"
  })), _use253 || (_use253 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 102.222,
    y: -66.857,
    className: "O"
  })), _use254 || (_use254 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 79.732,
    y: -29.551,
    className: "D"
  })), _use255 || (_use255 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 76.822,
    y: -66.857,
    className: "O"
  })), _use256 || (_use256 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 73.382,
    y: -29.551,
    className: "D"
  })), _use257 || (_use257 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ap",
    y: -8.467,
    className: "H"
  })), _use258 || (_use258 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BO",
    className: "B"
  })), _use259 || (_use259 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aq",
    y: -8.467,
    className: "L"
  })), _use260 || (_use260 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ar",
    y: -8.467,
    className: "K"
  })), _use261 || (_use261 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ap",
    x: -25.4,
    y: -8.467,
    className: "H"
  })), _use262 || (_use262 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BO",
    x: -25.4,
    className: "B"
  })), _use263 || (_use263 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aq",
    x: -6.35,
    y: -8.467,
    className: "L"
  })), _use264 || (_use264 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ar",
    x: -6.35,
    y: -8.467,
    className: "K"
  })), _use265 || (_use265 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#As",
    y: -8.467,
    className: "Q"
  })), _use266 || (_use266 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#At",
    y: -8.466,
    className: "T"
  })), _use267 || (_use267 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#As",
    x: -25.4,
    y: -8.467,
    className: "Q"
  })), _use268 || (_use268 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#At",
    x: -6.35,
    y: -8.466,
    className: "T"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "AE"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Au",
    y: -8.467
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    y: -8.467
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Au",
    x: -25.4,
    y: -8.467
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    x: -6.35,
    y: -8.467
  }))), _use269 || (_use269 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P",
    x: 47.982,
    y: -67.651,
    className: "J"
  })), _use270 || (_use270 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aw",
    y: -8.467,
    className: "R"
  })), _use271 || (_use271 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AP",
    x: 98.782,
    y: -29.551,
    className: "B"
  })), _use272 || (_use272 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AQ",
    x: 79.732,
    y: -29.551,
    className: "L"
  })), _use273 || (_use273 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ax",
    y: -8.467,
    className: "T"
  })), _use274 || (_use274 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AR",
    x: 79.732,
    y: -29.551,
    className: "U"
  })), _use275 || (_use275 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P",
    x: 22.582,
    y: -67.651,
    className: "J"
  })), _use276 || (_use276 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aw",
    x: -25.4,
    y: -8.467,
    className: "R"
  })), _use277 || (_use277 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AP",
    x: 73.382,
    y: -29.551,
    className: "B"
  })), _use278 || (_use278 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BP",
    className: "X"
  })), _use279 || (_use279 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AQ",
    x: 73.382,
    y: -29.551,
    className: "L"
  })), _use280 || (_use280 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ax",
    x: -6.35,
    y: -8.467,
    className: "T"
  })), _use281 || (_use281 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AR",
    x: 73.382,
    y: -29.551,
    className: "U"
  })), _use282 || (_use282 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ay",
    y: -8.466,
    className: "N"
  })), _use283 || (_use283 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 47.982,
    y: -67.651,
    className: "S"
  })), _use284 || (_use284 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Az",
    y: -8.466,
    className: "E"
  })), _use285 || (_use285 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    x: 47.982,
    y: -67.651,
    className: "C"
  })), _use286 || (_use286 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BQ",
    className: "X"
  })), _use287 || (_use287 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T",
    x: 75.499,
    y: -67.386,
    className: "C"
  })), _use288 || (_use288 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BA",
    y: -8.466,
    className: "E"
  })), _use289 || (_use289 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    y: -8.466,
    className: "D"
  })), _use290 || (_use290 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BC",
    y: -8.466,
    className: "K"
  })), _use291 || (_use291 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ay",
    x: -25.4,
    y: -8.466,
    className: "N"
  })), _use292 || (_use292 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 22.582,
    y: -67.651,
    className: "S"
  })), _use293 || (_use293 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Az",
    x: -25.4,
    y: -8.466,
    className: "E"
  })), _use294 || (_use294 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AT",
    x: 73.382,
    y: -29.551,
    className: "C"
  })), _use295 || (_use295 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BA",
    x: -6.35,
    y: -8.466,
    className: "E"
  })), _use296 || (_use296 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    x: -6.35,
    y: -8.466,
    className: "D"
  })), _use297 || (_use297 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BC",
    x: -6.35,
    y: -8.466,
    className: "K"
  })), _use298 || (_use298 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BD",
    y: -8.466,
    className: "H"
  })), _use299 || (_use299 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    x: 20.373,
    y: -12.964,
    className: "P"
  })), _use300 || (_use300 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BE",
    y: -8.466,
    className: "F"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 47.982,
    y: -76.117
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    x: 75.499,
    y: -76.117
  }))), _use301 || (_use301 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BF",
    y: -8.466,
    className: "F"
  })), _use302 || (_use302 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 27.609,
    y: -72.149,
    className: "O"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "H"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BG",
    y: -8.466
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BD",
    x: -25.4,
    y: -8.466
  }))), _use303 || (_use303 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    x: -5.027,
    y: -12.964,
    className: "P"
  })), _use304 || (_use304 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BE",
    x: -25.4,
    y: -8.466,
    className: "F"
  })), _use305 || (_use305 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AT",
    x: 73.382,
    y: -34.049,
    className: "C"
  })), _use306 || (_use306 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BF",
    x: -6.35,
    y: -8.466,
    className: "F"
  })), _use307 || (_use307 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 21.259,
    y: -72.149,
    className: "O"
  })), _use308 || (_use308 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BG",
    x: -6.35,
    y: -8.466,
    className: "H"
  })), _use309 || (_use309 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BH",
    y: -8.467,
    className: "D"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aa",
    y: -16.934
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ab",
    y: -16.933
  }))), _use310 || (_use310 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BI",
    y: -8.467,
    className: "Q"
  })), _use311 || (_use311 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BH",
    x: -25.4,
    y: -8.467,
    className: "D"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aa",
    x: -25.4,
    y: -16.934
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ab",
    x: -6.35,
    y: -16.933
  }))), _use312 || (_use312 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BI",
    x: -6.35,
    y: -8.467,
    className: "Q"
  })), _use313 || (_use313 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    x: 47.982,
    y: -76.117,
    className: "W"
  })), _use314 || (_use314 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    x: 21.961,
    y: -14.023,
    className: "b"
  })), _use315 || (_use315 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Au",
    x: -21.961,
    y: -14.023,
    className: "o"
  })), _use316 || (_use316 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V",
    x: 75.499,
    y: -71.884,
    className: "J"
  })), _use317 || (_use317 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    x: 22.582,
    y: -76.117,
    className: "W"
  })), _use318 || (_use318 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    x: -3.439,
    y: -14.023,
    className: "b"
  })), _use319 || (_use319 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Au",
    x: -28.311,
    y: -14.023,
    className: "o"
  })), _use320 || (_use320 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V",
    x: 69.149,
    y: -71.884,
    className: "J"
  })), _use321 || (_use321 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BJ",
    y: -8.467,
    className: "D"
  })), _use322 || (_use322 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BK",
    y: -8.467,
    className: "R"
  })), _use323 || (_use323 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BJ",
    x: -25.4,
    y: -8.467,
    className: "D"
  })), _use324 || (_use324 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BK",
    x: -6.35,
    y: -8.467,
    className: "R"
  })), _use325 || (_use325 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BL",
    y: -8.467,
    className: "H"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BM",
    y: -8.467
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W",
    x: 75.499,
    y: -71.885
  }))), _use326 || (_use326 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BN",
    y: -8.466,
    className: "N"
  })), _use327 || (_use327 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BL",
    x: -25.4,
    y: -8.467,
    className: "H"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BM",
    x: -25.4,
    y: -8.467
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W",
    x: 69.149,
    y: -71.885
  }))), _use328 || (_use328 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BN",
    x: -6.35,
    y: -8.466,
    className: "N"
  })), _use329 || (_use329 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 102.751,
    y: -36.695,
    className: "P"
  })), _use330 || (_use330 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 79.203,
    y: -74.001,
    className: "S"
  })), _use331 || (_use331 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 77.351,
    y: -36.695,
    className: "P"
  })), _use332 || (_use332 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 72.853,
    y: -74.001,
    className: "S"
  })), _use333 || (_use333 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Al",
    y: -16.934,
    className: "F"
  })), _use334 || (_use334 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Am",
    y: -16.934,
    className: "E"
  })), _use335 || (_use335 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Al",
    x: -25.4,
    y: -16.934,
    className: "F"
  })), _use336 || (_use336 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Am",
    x: -6.35,
    y: -16.934,
    className: "E"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "V"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 96.93,
    y: -77.969
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 71.53,
    y: -77.969
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 96.93,
    y: -78.234
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: 24.963,
    y: -76.118
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 71.53,
    y: -78.234
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: 18.613,
    y: -76.118
  }))), _use337 || (_use337 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#An",
    y: -16.933,
    className: "F"
  })), _use338 || (_use338 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ao",
    y: -16.933,
    className: "E"
  })), _use339 || (_use339 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#An",
    x: -25.4,
    y: -16.933,
    className: "F"
  })), _use340 || (_use340 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ao",
    x: -6.35,
    y: -16.933,
    className: "E"
  })), _use341 || (_use341 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 102.222,
    y: -75.324,
    className: "O"
  })), _use342 || (_use342 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 79.732,
    y: -38.018,
    className: "D"
  })), _use343 || (_use343 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    x: 76.822,
    y: -75.324,
    className: "O"
  })), _use344 || (_use344 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AN",
    x: 73.382,
    y: -38.018,
    className: "D"
  })), _use345 || (_use345 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ap",
    y: -16.934,
    className: "H"
  })), _use346 || (_use346 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AO",
    x: 98.782,
    y: -38.018,
    className: "B"
  })), _use347 || (_use347 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aq",
    y: -16.934,
    className: "L"
  })), _use348 || (_use348 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ar",
    y: -16.934,
    className: "K"
  })), _use349 || (_use349 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ap",
    x: -25.4,
    y: -16.934,
    className: "H"
  })), _use350 || (_use350 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AO",
    x: 73.382,
    y: -38.018,
    className: "B"
  })), _use351 || (_use351 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aq",
    x: -6.35,
    y: -16.934,
    className: "L"
  })), _use352 || (_use352 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ar",
    x: -6.35,
    y: -16.934,
    className: "K"
  })), _use353 || (_use353 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#As",
    y: -16.933,
    className: "Q"
  })), _use354 || (_use354 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#At",
    y: -16.933,
    className: "T"
  })), _use355 || (_use355 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#As",
    x: -25.4,
    y: -16.933,
    className: "Q"
  })), _use356 || (_use356 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#At",
    x: -6.35,
    y: -16.933,
    className: "T"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "AE"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Au",
    y: -16.934
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    y: -16.934
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Au",
    x: -25.4,
    y: -16.934
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    x: -6.35,
    y: -16.934
  }))), _use357 || (_use357 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P",
    x: 47.982,
    y: -76.117,
    className: "J"
  })), _use358 || (_use358 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aw",
    y: -16.933,
    className: "R"
  })), _use359 || (_use359 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AP",
    x: 98.782,
    y: -38.017,
    className: "B"
  })), _use360 || (_use360 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AQ",
    x: 79.732,
    y: -38.017,
    className: "L"
  })), _use361 || (_use361 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ax",
    y: -16.933,
    className: "T"
  })), _use362 || (_use362 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AR",
    x: 79.732,
    y: -38.017,
    className: "U"
  })), _use363 || (_use363 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P",
    x: 22.582,
    y: -76.117,
    className: "J"
  })), _use364 || (_use364 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Aw",
    x: -25.4,
    y: -16.933,
    className: "R"
  })), _use365 || (_use365 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AP",
    x: 73.382,
    y: -38.017,
    className: "B"
  })), _use366 || (_use366 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BP",
    y: -8.466,
    className: "X"
  })), _use367 || (_use367 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AQ",
    x: 73.382,
    y: -38.017,
    className: "L"
  })), _use368 || (_use368 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ax",
    x: -6.35,
    y: -16.933,
    className: "T"
  })), _use369 || (_use369 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AR",
    x: 73.382,
    y: -38.017,
    className: "U"
  })), _use370 || (_use370 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ay",
    y: -16.933,
    className: "N"
  })), _use371 || (_use371 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 47.982,
    y: -76.118,
    className: "S"
  })), _use372 || (_use372 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Az",
    y: -16.933,
    className: "E"
  })), _use373 || (_use373 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    x: 47.982,
    y: -76.118,
    className: "C"
  })), _use374 || (_use374 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BQ",
    y: -8.467,
    className: "X"
  })), _use375 || (_use375 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T",
    x: 75.499,
    y: -75.853,
    className: "C"
  })), _use376 || (_use376 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BA",
    y: -16.933,
    className: "E"
  })), _use377 || (_use377 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    y: -16.933,
    className: "D"
  })), _use378 || (_use378 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BC",
    y: -16.933,
    className: "K"
  })), _use379 || (_use379 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ay",
    x: -25.4,
    y: -16.933,
    className: "N"
  })), _use380 || (_use380 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 22.582,
    y: -76.118,
    className: "S"
  })), _use381 || (_use381 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Az",
    x: -25.4,
    y: -16.933,
    className: "E"
  })), _use382 || (_use382 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AT",
    x: 73.382,
    y: -38.018,
    className: "C"
  })), _use383 || (_use383 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BA",
    x: -6.35,
    y: -16.933,
    className: "E"
  })), _use384 || (_use384 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    x: -6.35,
    y: -16.933,
    className: "D"
  })), _use385 || (_use385 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BC",
    x: -6.35,
    y: -16.933,
    className: "K"
  })), _use386 || (_use386 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BR",
    fill: "#f5f1f1"
  })), _use387 || (_use387 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BS",
    fill: "#f5bfbb"
  })), _use388 || (_use388 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BT",
    fill: "#f57f77"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M15.611 63.103q0-.132.099-.165t.174.041l.074.074.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099h-.264v-.132m-.033.132h.231-.264.033m.198 0h.165-.264.099",
    className: "Br"
  })), _use389 || (_use389 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BU",
    fillOpacity: 0.937,
    className: "G"
  })), _use390 || (_use390 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BV",
    fill: "#f54436",
    fillOpacity: 0.667
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m11.084 63.132-.037-.095.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.083-.083.083-.083-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095",
    fill: "#f54138",
    fillOpacity: 0.306
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m10.881 63.07-.033-.099.025.074.025.074-.017-.05q-.017-.05-.058-.074l-.041-.025.021.012.021.012.112.021q.112.021.149.116l.037.095.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132",
    className: "An Ao"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m16.901 62.806.033-.099h.264v.132q0 .132-.099.165t-.174-.041l-.074-.074-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099m.132-.099h-.165.264-.099",
    fill: "#f5e9e8"
  })), _use391 || (_use391 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BW",
    fill: "#f49c95"
  })), _use392 || (_use392 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BX",
    className: "AL"
  })), _use393 || (_use393 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BU",
    x: -0.794,
    y: -0.265,
    fillOpacity: 0.922,
    className: "G"
  })), _use394 || (_use394 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BV",
    x: -0.793,
    y: -0.264,
    fill: "#f34337",
    fillOpacity: 0.51
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m10.319 62.839-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.079-.079.078-.079-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264l-.099-.033q-.099-.033-.165-.099",
    className: "Bs Bt"
  })), _use395 || (_use395 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BR",
    x: 1.059,
    y: -0.529,
    className: "Bn"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M17.227 62.603q.037-.095.136-.128l.099-.033-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.016-.107.025l-.058.008.029-.004.029-.004.037-.095",
    fill: "#f49a94"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M16.934 62.574q0-.132.099-.165t.174.041l.074.074.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008H17h.198-.264v-.132",
    fill: "#f44c3f"
  })), _use396 || (_use396 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BY",
    className: "e Bu"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M10.055 62.574v-.132h.264l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.079.079-.079.079.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132",
    className: "Bv Cv"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m9.79 62.574-.066-.066.074-.074.074-.074-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264l-.099-.033q-.099-.033-.165-.099m-.083-.083.017.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "Bw Bx"
  })), _use397 || (_use397 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BS",
    x: 1.587,
    y: -0.794,
    fill: "#f5c1bd"
  })), _use398 || (_use398 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BX",
    x: 1.058,
    y: -0.529,
    className: "p"
  })), _use399 || (_use399 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BY",
    x: -0.529,
    y: -0.265,
    fillOpacity: 0.878,
    className: "G"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m9.525 62.309-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.078-.079.079-.079-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.017.016.017.016-.033-.033-.066-.066-.033-.033.05.05",
    fill: "#f54235",
    fillOpacity: 0.302
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m18.224 62.012.033-.099.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.091-.041l.041-.025-.021.012-.021.012.074.074.074.074.012-.021.012-.021-.025.041q-.025.041-.041.091l-.017.05.025-.074.025-.074-.033.099q-.033.099-.132.132t-.174-.041l-.074-.074-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099",
    fill: "#f5f0ef"
  })), _use400 || (_use400 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: -6.522,
    y: -16.057,
    className: "Bj"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m9.228 62.078-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.083-.083.083-.083-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.079.079-.078.079.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.016.074.025.074.025-.099-.033-.099-.033-.033-.099m.008.091.025.008.074.025.074.025-.05-.016-.099-.033-.05-.016.025.008",
    fill: "#f44337",
    className: "Cw"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m9.029 62.012-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.107.025q.107.025.141.124l.033.099-.099-.033q-.099-.033-.132-.132m.157.141.074.025.025.008.025.008-.05-.016-.099-.033-.05-.016.074.025",
    fill: "#ff4924",
    fillOpacity: 0.027
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m18.521 61.78.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.074-.074-.074-.074-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066m.281-.016.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "Bp"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M18.29 61.813q.033-.099.099-.165l.066-.066.066.066.066.066-.066.066q-.066.066-.165.099l-.099.033.033-.099m.248-.05.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#f4675d"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m8.988 61.789.008-.141h.132q.132 0 .165.099l.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.083.083-.083.083.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.107-.025-.107-.025.008-.141",
    fillOpacity: 0.804,
    className: "Ap"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m8.732 61.78-.066-.066.074-.074.074-.074-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033-.008.141-.008.141.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.165-.099m-.083-.083.017.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#f5453b",
    className: "Cx"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m18.786 61.516.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.066.198.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.016m.232-.232.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05M19 61.301l-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#f5dad8"
  })), _use401 || (_use401 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ad",
    x: -101.336,
    y: 13.494,
    fill: "#f45a4e"
  })), _use402 || (_use402 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BY",
    x: -1.587,
    y: -1.058,
    fill: "#f54436",
    fillOpacity: 0.859
  })), _use403 || (_use403 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BZ",
    fill: "#f84435",
    fillOpacity: 0.133
  })), _use404 || (_use404 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ba",
    className: "Aq"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "m55.559 61.247.004-.128h.264l-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.107.025l-.058.008.029-.004.029-.004.004-.128m.302-.128h-.231.264-.033m-.198 0h-.165.264-.099",
    className: "By"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M55.298 61.251v-.132h.264l-.004.128-.004.128.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132m.298-.132h-.231.264",
    fill: "#bfd8a6"
  })), _use405 || (_use405 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bb",
    className: "AH"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M54.802 61.284q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.107-.025l.058-.008-.029.004-.029.004-.004.128-.004.128h-.264l.033-.099m.132.099h.165-.264.099",
    fill: "#9ac36e"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M54.505 61.251v-.132l.099-.033q.099-.033.174.041l.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.264v-.132",
    fill: "#8cbc5a"
  })), _use406 || (_use406 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 30.784,
    y: -46.484,
    className: "f"
  })), _use407 || (_use407 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AT",
    x: 34.224,
    y: -4.416,
    className: "Ae"
  })), _use408 || (_use408 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 29.99,
    y: -46.484,
    className: "f"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "m53.149 61.284-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074q.074-.074.174-.041l.099.033v.264h-.264l-.033-.099",
    fill: "#8cbc5a"
  })), _use409 || (_use409 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bc",
    className: "Bz"
  })), _use410 || (_use410 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bd",
    className: "AH"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m52.392 61.247-.004-.128h.264v.264h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.004-.128m.095-.128h-.165.264-.099",
    fill: "#bfd7a5"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "m52.156 61.218-.033-.099h.264l.004.128.004.128.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.265-.099h-.231.264-.033m-.198 0h-.165.264-.099",
    className: "By"
  })), _use411 || (_use411 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Be",
    className: "Aq"
  })), _use412 || (_use412 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ad",
    x: -100.807,
    y: 13.229,
    className: "Bm"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m18.786 61.251.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.066.198.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.016m.232-.232.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05M19 61.036l-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#f45246"
  })), _use413 || (_use413 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BY",
    x: -1.852,
    y: -1.323,
    fillOpacity: 0.914,
    className: "G"
  })), _use414 || (_use414 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BZ",
    x: -0.265,
    y: -0.265,
    fill: "#f24134",
    fillOpacity: 0.153
  })), _use415 || (_use415 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ba",
    x: 0.794,
    y: -0.265,
    fill: "#f2f4f1"
  })), _use416 || (_use416 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BW",
    x: 39.688,
    y: -1.852,
    className: "CA"
  })), _use417 || (_use417 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BT",
    x: 40.217,
    y: -2.116,
    fill: "#a5ca7f"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M55.827 60.987q0-.132.099-.165t.174.041l.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.264v-.132m.165.132h.165-.264.099",
    className: "f"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m51.826 61.02-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074q.074-.074.174-.041.099.033.099.165v.132h-.264l-.033-.099m0 .099h.231-.264",
    className: "CB"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m51.594 60.987-.008-.124-.029-.004-.029-.004.058.008q.058.008.107.025l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.008-.124m.165.132h.165-.264.099",
    fill: "#a5c97e"
  })), _use418 || (_use418 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bf",
    fill: "#d0e1be"
  })), _use419 || (_use419 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Be",
    x: -0.794,
    y: -0.264,
    className: "AN"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m19.315 60.987.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.074.074.074.074.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.066.198.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033",
    className: "Bp"
  })), _use420 || (_use420 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ad",
    x: -100.807,
    y: 12.965,
    className: "p"
  })), _use421 || (_use421 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BY",
    x: -2.116,
    y: -1.588,
    className: "G q"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "m7.971 60.953-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.141-.008.141-.008.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.074.074-.074.074-.066-.066q-.066-.066-.099-.165m.116.182.05.05.017.016.017.016-.033-.033-.066-.066-.033-.033.05.05",
    fill: "#f5453b",
    className: "Cx"
  })), _use422 || (_use422 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bg",
    fill: "#edf1e9"
  })), _use423 || (_use423 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AV",
    x: -62.177,
    y: 12.171,
    fill: "#b8d49b"
  })), _use424 || (_use424 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bh",
    className: "AK"
  })), _use425 || (_use425 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bi",
    className: "Af"
  })), _use426 || (_use426 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AS",
    x: 30.519,
    y: -4.945,
    className: "CC"
  })), _use427 || (_use427 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bj",
    fill: "#ecf0e8"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "m19.546 60.689.033-.099.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.074.074q.074.074.041.174-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.091.041l-.041.025.021-.012.021-.012-.074-.074-.074-.074-.012.021-.012.021.025-.041q.025-.041.041-.091l.017-.05-.025.074-.025.074.033-.099",
    fill: "#f5f0ef"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M19.315 60.722q.066-.066.165-.099l.099-.033-.033.099q-.033.099-.099.165l-.066.066-.066-.066-.066-.066.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.066.198.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033",
    fill: "#f4675d"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M7.963 60.763q.041-.107.141-.141.099-.033.099.099v.132l-.141.008-.141.008.041-.107",
    fillOpacity: 0.808,
    className: "G"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "m7.706 60.689-.033-.099.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.083.083.083.083.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.041.107-.041.107.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m-.041-.124.008.025.025.074.025.074-.017-.05-.033-.099-.017-.05.008.025",
    className: "r CD"
  })), _use428 || (_use428 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bg",
    x: 0.53,
    y: -0.265,
    className: "AJ"
  })), _use429 || (_use429 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AV",
    x: -61.648,
    y: 11.906,
    className: "CC"
  })), _use430 || (_use430 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bh",
    x: 0.529,
    y: -0.265,
    className: "AO"
  })), _use431 || (_use431 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bi",
    x: -0.529,
    y: -0.265,
    className: "Bd"
  })), _use432 || (_use432 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AS",
    x: 29.99,
    y: -5.21,
    fill: "#b6d398"
  })), _use433 || (_use433 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bj",
    x: -0.529,
    y: -0.265,
    className: "AJ"
  })), _use434 || (_use434 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: -4.934,
    y: -17.645,
    fill: "#f58f88"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "m7.64 60.49-.033-.099.025.074.025.074-.017-.05q-.017-.05-.041-.091l-.025-.041.012.021.012.021.078-.079.079-.079-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.066.132t-.132.132l-.099.033-.033-.099m.008.025.025.074.008.025.008.025-.017-.05-.033-.099-.017-.05.025.074",
    fillOpacity: 0.592,
    className: "Bv"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M57.973 60.222q.037-.095.136-.128l.099-.033-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.107.025l-.058.008.029-.004.029-.004.037-.095",
    fill: "#d1e2c0"
  })), _use435 || (_use435 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bh",
    x: 1.059,
    y: -0.529,
    className: "s"
  })), _use436 || (_use436 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bi",
    x: -1.058,
    y: -0.529,
    fill: "#8bbb58"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "m49.775 60.16-.033-.099.099.033q.099.033.136.128l.037.095.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132",
    className: "CA"
  })), _use437 || (_use437 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bk",
    fill: "#f5c1bd"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "m7.409 60.193-.066-.066.074-.074.074-.074-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.079.079-.079.079.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m-.083-.083.017.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#f54437",
    fillOpacity: 0.31
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m58.44 59.895.033-.099.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.091-.041l.041-.025-.021.012-.021.012.079.079.079.079.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132t-.174-.041l-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099",
    className: "CE"
  })), _use438 || (_use438 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 33.695,
    y: -18.174,
    className: "AH"
  })), _use439 || (_use439 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: 13.586,
    y: -18.174,
    fill: "#b1d090"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "m49.18 59.961-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.079-.079.079-.079-.021-.012-.021-.012.041.025q.041.025.091.041l.05.016-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074q-.074.074-.174.041-.099-.033-.132-.132",
    className: "CE"
  })), _use440 || (_use440 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bl",
    fill: "#f5edec"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M19.877 59.961q.033-.099.132-.132l.099-.033v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.124.008-.124.008-.004.029-.004.029.008-.058q.008-.058.025-.107l.017-.05-.025.074-.025.074.033-.099",
    fill: "#f4584d"
  })), _use441 || (_use441 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BY",
    x: -2.91,
    y: -2.646,
    className: "G q"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m7.177 59.895-.033-.099h.264l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.074.074-.074.074-.066-.066q-.066-.066-.099-.165m.116.182.05.05.017.016.017.016-.033-.033-.066-.066-.033-.033.05.05",
    className: "Bw Bx"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m58.738 59.664.132-.132.066-.066.074.074.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.079-.079-.079-.079-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066m.215-.215-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "Bh"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M58.506 59.697q.033-.099.099-.165l.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07.07.07-.066.066q-.066.066-.165.099l-.099.033.033-.099m.248-.05.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05",
    fill: "#95c067"
  })), _use442 || (_use442 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bm",
    fill: "#94c065"
  })), _use443 || (_use443 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bn",
    fill: "#e9eee3"
  })), _use444 || (_use444 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: -4.405,
    y: -18.438,
    fill: "#f49a94"
  })), _use445 || (_use445 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bo",
    fillOpacity: 0.525,
    className: "Ap"
  })), _use446 || (_use446 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    fill: "#e3ebda"
  })), _use447 || (_use447 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bq",
    className: "AP"
  })), _use448 || (_use448 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Br",
    fill: "#8dbd5c"
  })), _use449 || (_use449 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bs",
    fill: "#e5ecdd"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M20.373 59.399v-.132l.128-.004.128-.004.004-.029.004-.029-.008.058q-.008.058-.025.107l-.017.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033V59.4m0-.165v.231-.264",
    fill: "#f5e7e6"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M20.076 59.366q.033-.099.165-.099h.132v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074q-.074-.074-.041-.174",
    className: "Bl"
  })), _use450 || (_use450 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BY",
    x: -3.175,
    y: -3.175,
    className: "e Bu"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m6.913 59.366-.033-.099h.264l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.079.079-.078.079.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066q-.066-.066-.099-.165",
    className: "Bs Bt"
  })), _use451 || (_use451 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: 0.265,
    y: -0.265,
    className: "Be"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "#86b951"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bt"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bu"
  }))), _use452 || (_use452 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bs",
    x: -0.265,
    y: -0.264,
    fill: "#e3ebda"
  })), _use453 || (_use453 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: -33.245,
    y: -26.641,
    fill: "#f49c95"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88 59.134v-.132.198-.066q0-.066-.025-.107l-.025-.041.012.021.012.021.145-.012.145-.012v.264H6.88v-.132",
    fill: "#f34237",
    fillOpacity: 0.514
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m59.532 58.87.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.079.079.079.079.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074-.074-.074.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05",
    className: "Bh"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M59.234 58.837q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.091-.041l.041-.025-.021.012-.021.012.07.07.07.07-.066.066-.132.132-.066.066-.074-.074-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05",
    className: "s"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "m48.419 58.87-.066-.066.07-.07.07-.07-.021-.012-.021-.012.041.025q.041.025.091.041l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "AP"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m48.121 58.903-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.079-.079.079-.079-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.066.066-.074.074-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033",
    fill: "#e9eee3"
  })), _use454 || (_use454 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bl",
    x: 0.529,
    y: -1.058,
    fill: "#f5f1f1"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M20.406 58.903q.033-.099.132-.132l.099-.033v.264l-.128.004-.128.004-.004.029-.004.029.008-.058q.008-.058.025-.107l.017-.05-.025.074-.025.074.033-.099m.232.132v-.231.264",
    className: "AL"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m6.834 58.915-.021-.112.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.083-.083.083-.083-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.099.165v.132L7 59.01l-.145.012-.021-.112",
    className: "G CF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m6.648 58.837-.033-.099.025.074.025.074-.017-.05q-.017-.05-.025-.107l-.008-.058.004.029.004.029.095.037q.095.037.116.149l.021.112.012.021.012.021-.025-.041q-.025-.041-.074-.058l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132",
    className: "An Ao"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m59.763 58.572.033-.099.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.074.074q.074.074.041.174-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.079-.079-.079-.079-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099",
    className: "CE"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M59.532 58.605q.066-.066.165-.099l.099-.033-.033.099q-.033.099-.099.165l-.066.066-.07-.07-.07-.07-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066m.05.215.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033",
    fill: "#95c067"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "m48.188 58.572-.033-.099.099.033q.099.033.165.099l.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.07.07-.07.07-.066-.066q-.066-.066-.099-.165m.116.182.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05",
    fill: "#93c064"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M47.857 58.638q-.033-.099.041-.174l.074-.074-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.079.079-.079.079.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132",
    className: "Bf"
  })), _use455 || (_use455 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bk",
    x: 0.794,
    y: -1.588,
    fill: "#f5bfbb"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M6.615 58.605v-.132h.264l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.083.083-.083.083.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132",
    className: "CG CH"
  })), _use456 || (_use456 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 35.282,
    y: -19.761,
    fill: "#b0cf8f"
  })), _use457 || (_use457 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: 11.999,
    y: -19.761,
    fill: "#adce8b"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M20.671 58.374q.033-.099.132-.132l.099-.033v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.124.008-.124.008-.004.029-.004.029.008-.058q.008-.058.025-.107l.017-.05-.025.074-.025.074.033-.099m.232-.066v-.165.264-.099",
    fill: "#f57f77"
  })), _use458 || (_use458 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bo",
    x: -0.529,
    y: -1.323,
    fill: "#f54237",
    fillOpacity: 0.678
  })), _use459 || (_use459 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bv",
    fill: "#d1e2c0"
  })), _use460 || (_use460 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bw",
    className: "CI"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M20.902 58.076v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132m0-.165v.231-.264",
    fill: "#f5f3f3"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M20.605 58.043q.033-.099.165-.099h.132v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074q-.074-.074-.041-.174m.298.198v-.231.264-.033m0-.198v-.165.264-.099",
    fill: "#f44e42"
  })), _use461 || (_use461 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BY",
    x: -3.704,
    y: -4.498,
    className: "G Cy"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "m6.383 58.043-.033-.099h.264l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.079.079-.079.079.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066q-.066-.066-.099-.165",
    className: "r CJ"
  })), _use462 || (_use462 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bx",
    fill: "#eff2ed"
  })), _use463 || (_use463 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#By",
    fill: "#8abb57"
  })), _use464 || (_use464 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bz",
    className: "AP"
  })), _use465 || (_use465 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CA",
    className: "AJ"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M20.902 57.812v-.132l.128-.004.128-.004.004-.029.004-.029-.008.058q-.008.058-.025.107l-.017.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033v-.132m0 .033v.165-.264.099m0-.198v.231-.264",
    fill: "#f5d1cf"
  })), _use466 || (_use466 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -49.923,
    fill: "#f64138",
    className: "Cz"
  })), _use467 || (_use467 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    x: -12.079,
    y: -48.866,
    className: "CC"
  })), _use468 || (_use468 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N",
    x: -25.043,
    y: -47.542,
    fill: "#b5d297"
  })), _use469 || (_use469 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: -3.083,
    y: -22.143,
    fill: "#f4a6a1"
  })), _use470 || (_use470 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -50.188,
    fillOpacity: 0.447,
    className: "G"
  })), _use471 || (_use471 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bx",
    x: 0.265,
    y: -0.53,
    fill: "#ecf0e7"
  })), _use472 || (_use472 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#By",
    x: 0.264,
    y: -0.529,
    className: "Bc"
  })), _use473 || (_use473 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bz",
    x: -0.264,
    y: -0.53,
    className: "Bd"
  })), _use474 || (_use474 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CA",
    x: -0.265,
    y: -0.53,
    fill: "#ecf0e8"
  })), _use475 || (_use475 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CB",
    fill: "#f48b83"
  })), _use476 || (_use476 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -50.453,
    className: "AQ DA"
  })), _use477 || (_use477 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    x: -11.814,
    y: -49.395,
    fill: "#b8d49b"
  })), _use478 || (_use478 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N",
    x: -25.308,
    y: -48.071,
    fill: "#b7d399"
  })), _use479 || (_use479 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CB",
    y: -0.264,
    fill: "#f56f66"
  })), _use480 || (_use480 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -50.717,
    className: "e DB"
  })), _use481 || (_use481 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CC",
    fill: "#f2f4f1"
  })), _use482 || (_use482 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#By",
    x: 0.529,
    y: -1.058,
    className: "AK"
  })), _use483 || (_use483 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bz",
    x: -0.529,
    y: -1.059,
    fill: "#85b84f"
  })), _use484 || (_use484 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CD",
    className: "AN"
  })), _use485 || (_use485 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CE",
    className: "p"
  })), _use486 || (_use486 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -50.982,
    className: "G q"
  })), _use487 || (_use487 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    x: 36.605,
    y: -22.142,
    className: "CA"
  })), _use488 || (_use488 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    x: 10.676,
    y: -22.142,
    fill: "#cee0bc"
  })), _use489 || (_use489 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CF",
    className: "Ai"
  })), _use490 || (_use490 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -51.246,
    className: "G DC"
  })), _use491 || (_use491 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CG",
    fill: "#a5ca7f"
  })), _use492 || (_use492 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CH",
    fill: "#a3c87c"
  })), _use493 || (_use493 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CC",
    x: 0.264,
    y: -0.794,
    className: "Aq"
  })), _use494 || (_use494 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CI",
    className: "CB"
  })), _use495 || (_use495 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CJ",
    className: "AO"
  })), _use496 || (_use496 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CD",
    x: -0.265,
    y: -0.793,
    className: "Ar"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M20.869 55.993q-.033-.099.041-.174l.074-.074-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.529l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074q-.074-.074-.041-.174.033-.099 0-.198",
    fill: "#f4483c"
  })), _use497 || (_use497 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: -66.054,
    y: -49.66,
    fillOpacity: 0.976,
    className: "G"
  })), _use498 || (_use498 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AM",
    x: 22.317,
    y: -17.645,
    fill: "#dde8d1"
  })), _use499 || (_use499 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AL",
    x: -4.67,
    y: -17.644,
    className: "CK"
  })), _use500 || (_use500 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CK",
    className: "Ai"
  })), _use501 || (_use501 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -52.04,
    className: "G DC"
  })), _use502 || (_use502 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: 37.134,
    y: -24.26,
    fill: "#bfd8a6"
  })), _use503 || (_use503 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    x: 10.147,
    y: -24.26,
    fill: "#bed7a5"
  })), _use504 || (_use504 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CL",
    className: "p"
  })), _use505 || (_use505 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -52.305,
    className: "G q"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M61.119 55.166v-.132h.264v.264h-.264v-.132m0 .033v.165-.264.099m.265.132V55.1v.264",
    fill: "#adce8a"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M46.567 55.166v-.132l.128.004.128.004-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.264v-.132m0 .033v.165-.264.099m.265.132V55.1v.264-.033M46.567 55v.231-.264",
    className: "AI"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M20.902 55.166v-.132h.264v.264h-.264v-.132m0 .033v.165-.264.099m.265.132V55.1v.264-.033m0-.198v-.166.264-.099M20.902 55v.231-.264",
    fill: "#f56f66"
  })), _use506 || (_use506 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -52.569,
    className: "e DB"
  })), _use507 || (_use507 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CF",
    x: 40.216,
    y: -1.588,
    className: "Bz"
  })), _use508 || (_use508 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CM",
    fill: "#99c36c"
  })), _use509 || (_use509 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CB",
    y: -2.381,
    className: "Bj"
  })), _use510 || (_use510 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -52.834,
    fillOpacity: 0.612,
    className: "G"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "m61.086 54.603.033-.099h.264v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074q-.074-.074-.041-.174",
    className: "s"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M46.567 54.637v-.132h.264l.033.099q.033.099-.041.174l-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132",
    className: "AP"
  })), _use511 || (_use511 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    x: -15.518,
    y: -24.788,
    fill: "#f4a6a0"
  })), _use512 || (_use512 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -53.098,
    className: "Ap DD"
  })), _use513 || (_use513 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 37.663,
    y: -53.363,
    className: "Af"
  })), _use514 || (_use514 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 23.111,
    y: -53.363,
    className: "f"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M20.902 54.372v-.132l.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.017.05q.017.05.025.107l.008.058-.004-.029-.004-.029-.128-.004-.128-.004v-.132m0 .033v.165-.264.099m0-.198v.231-.264",
    fill: "#f5d1ce"
  })), _use515 || (_use515 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -17.106,
    y: -53.363,
    fill: "#f64437",
    fillOpacity: 0.22
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M20.902 54.107v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132m0 .033v.165-.264.099",
    fill: "#f5f3f3"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M20.605 54.14q-.033-.099.041-.174l.074-.074-.017-.017-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099m.298.132v-.231.264-.033m0-.198v-.165.264-.099",
    fill: "#f44e42"
  })), _use516 || (_use516 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CN",
    className: "G Cy"
  })), _use517 || (_use517 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CO",
    className: "r CJ"
  })), _use518 || (_use518 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: -11.285,
    y: -51.776,
    fill: "#80b547"
  })), _use519 || (_use519 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: -25.837,
    y: -51.776,
    className: "Ae"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m20.671 53.81-.033-.099.025.074.025.074-.017-.05q-.017-.05-.025-.107l-.008-.058.004.029.004.029.124.008.124.008-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264l-.099-.033q-.099-.033-.132-.132m.232.198v-.231.264",
    fill: "#f57f76"
  })), _use520 || (_use520 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CP",
    className: "AQ DE"
  })), _use521 || (_use521 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 37.663,
    y: -54.157,
    className: "Af"
  })), _use522 || (_use522 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 23.111,
    y: -54.157,
    className: "f"
  })), _use523 || (_use523 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CQ",
    fill: "#f5bebb"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M6.615 53.578v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.083.083.083.083.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099h-.264v-.132",
    fill: "#f34435",
    fillOpacity: 0.322
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M61.086 53.347q-.033-.099.041-.174l.074-.074-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.264l-.033-.099",
    className: "s"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M46.567 53.314v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.074.074q.074.074.041.174l-.033.099h-.264v-.132",
    className: "AP"
  })), _use524 || (_use524 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CR",
    fill: "#f5f1f0"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "m20.406 53.281-.033-.099.025.074.025.074-.017-.05q-.017-.05-.025-.107l-.008-.058.004.029.004.029.128.004.128.004v.264l-.099-.033q-.099-.033-.132-.132m.232 0v-.165.264-.099",
    className: "Ai"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "m6.834 53.268.021-.112.145.012.145.012v.132q0 .132-.099.165l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.083-.083-.083-.083-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.021-.112",
    className: "G CF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M6.648 53.347q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.074-.058l.025-.041-.012.021-.012.021-.021.112q-.021.112-.116.149l-.095.037-.004.029-.004.029.008-.058q.008-.058.025-.107l.017-.05-.025.074-.025.074.033-.099",
    className: "An Ao"
  })), _use525 || (_use525 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X",
    x: -4.935,
    y: -32.99,
    className: "Bz"
  })), _use526 || (_use526 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CS",
    fill: "#99c36c"
  })), _use527 || (_use527 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    x: -16.047,
    y: -26.641,
    fill: "#f49b94"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88 53.049v-.132h.264v.264l-.145-.012-.145-.012-.012.021-.012.021.025-.041q.025-.041.025-.107v-.066.198-.132",
    fillOpacity: 0.522,
    className: "AQ"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M61.119 52.784v-.132h.264v.264l-.128-.004-.128-.004.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132m.265.165v-.231.264",
    className: "AH"
  })), _use528 || (_use528 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CL",
    x: 25.665,
    y: -2.646,
    fill: "#abcd87"
  })), _use529 || (_use529 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CT",
    className: "I"
  })), _use530 || (_use530 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CE",
    x: -0.529,
    y: -3.969,
    fill: "#7c6e6d"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M20.076 52.818q-.033-.099.041-.174l.074-.074-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099",
    fill: "#ea4135"
  })), _use531 || (_use531 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CN",
    x: 0.529,
    y: -1.322,
    className: "e Bu"
  })), _use532 || (_use532 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CO",
    x: 0.53,
    y: -1.322,
    className: "Bs Bt"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M61.119 52.52v-.132l.128.004.128.004-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.264v-.132m0-.165v.231-.264",
    fill: "#bfd7a5"
  })), _use533 || (_use533 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 22.582,
    y: -26.905,
    className: "CL"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "m20.902 52.52.132-.132.066-.066.074.074.074.074.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.079-.079-.079-.079-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066m.215-.215-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "g"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M20.671 52.553q.033-.099.099-.165l.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07.07.07-.066.066q-.066.066-.165.099l-.099.033.033-.099m.248-.05.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05",
    className: "AR"
  })), _use534 || (_use534 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: -15.782,
    y: -25.582,
    fill: "#8e332c"
  })), _use535 || (_use535 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CP",
    x: 0.529,
    y: -1.323,
    fill: "#f44436",
    className: "DF"
  })), _use536 || (_use536 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: -4.935,
    y: -33.255,
    className: "By"
  })), _use537 || (_use537 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: -7.051,
    y: -33.255,
    fill: "#dae6cd"
  })), _use538 || (_use538 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CU",
    className: "l"
  })), _use539 || (_use539 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CV",
    className: "m"
  })), _use540 || (_use540 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CR",
    x: -0.529,
    y: -1.059,
    fill: "#2b2322"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "m19.877 52.222-.033-.099.025.074.025.074-.017-.05q-.017-.05-.025-.107l-.008-.058.004.029.004.029.124.008.124.008-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264l-.099-.033q-.099-.033-.132-.132",
    fill: "#db3f34"
  })), _use541 || (_use541 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CN",
    x: 0.794,
    y: -1.852,
    className: "G q"
  })), _use542 || (_use542 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CW",
    className: "Bw Bx"
  })), _use543 || (_use543 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CJ",
    x: 14.287,
    y: -3.968,
    className: "Aq"
  })), _use544 || (_use544 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CD",
    x: 14.022,
    y: -4.762,
    className: "CB"
  })), _use545 || (_use545 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CC",
    x: -14.023,
    y: -4.762,
    className: "AO"
  })), _use546 || (_use546 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CI",
    x: -14.287,
    y: -3.968,
    className: "Ar"
  })), _use547 || (_use547 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CU",
    x: 0.265,
    y: -0.264,
    className: "t"
  })), _use548 || (_use548 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CX",
    className: "AS"
  })), _use549 || (_use549 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CQ",
    x: -0.794,
    y: -1.587,
    fill: "#612b27"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "m7.409 51.991.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.078.079.079.079.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074-.074-.074.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05",
    className: "CG CH"
  })), _use550 || (_use550 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    x: 24.699,
    y: -26.905,
    fill: "#a5c97e"
  })), _use551 || (_use551 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AM",
    x: 8.03,
    y: -21.614,
    fill: "#a3c87b"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "m21.696 51.726.132-.132.066-.066.07.07.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.017.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.017-.083.05l-.033.033.017-.016.017-.017-.074-.074-.074-.074.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.232-.232-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "u"
  })), _use552 || (_use552 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CX",
    x: 0.265,
    y: -0.265,
    className: "As"
  })), _use553 || (_use553 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: -16.311,
    y: -26.376,
    fill: "#9c352d"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "m7.64 51.693.033-.099h.264v.132q0 .132-.099.165l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.079-.079-.078-.079-.012.021-.012.021.025-.041q.025-.041.041-.091l.017-.05-.025.074-.025.074.033-.099",
    fill: "#f34335",
    fillOpacity: 0.6
  })), _use554 || (_use554 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CH",
    x: 14.023,
    y: -4.762,
    fill: "#d0e1be"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M46.832 51.462v-.132.198-.066q0-.066-.008-.124l-.008-.058.004.029.004.029.136-.004.136-.004v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.128.004-.128.004v-.132m0 .033v.165-.264.099m.265-.066v-.165.264-.099",
    fill: "#cee0bb"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "m21.961 51.462.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07-.07-.07.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.298-.033.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "v"
  })), _use555 || (_use555 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CX",
    x: 0.529,
    y: -0.53,
    className: "C"
  })), _use556 || (_use556 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CR",
    x: -1.058,
    y: -1.852,
    fill: "#272221"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "m19.348 51.428-.033-.099.128.004.128.004-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264l-.099-.033q-.099-.033-.132-.132",
    fill: "#ca3c31"
  })), _use557 || (_use557 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CN",
    x: 1.323,
    y: -2.645,
    className: "G DG"
  })), _use558 || (_use558 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CW",
    x: 0.529,
    y: -0.793,
    className: "r CD"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M60.855 51.197v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.091-.041l.041-.025-.021.012-.021.012.083.074.083.074.012-.012.012-.012-.025.025q-.025.025-.025.058v.033-.1.066q0 .066-.074.141l-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132m0 .033v.165-.264.099",
    className: "AN"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M60.557 51.23q-.033-.099.041-.174l.074-.074-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099",
    fill: "#80b34b"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M47.096 51.197v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132",
    fill: "#77aa41"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "m46.799 51.23-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.074-.074.074-.074-.021-.012-.021-.012.041.025q.041.025.091.041l.05.016-.074-.025-.074-.025.099.033.099.033v.264l-.136.004-.136.004.004.029.004.029-.008-.058q-.008-.058-.025-.107l-.016-.05.025.074.025.074-.033-.099m.298.132v-.231.264",
    fill: "#b8b9b7"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "m22.225 51.197.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.016.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.066.198.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#a6a6a6"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M21.928 51.164q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.074.074.074.074-.066.066-.132.132-.066.066-.074-.074-.074-.074-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099m.083.248.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.016m.232-.232.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05",
    className: "w"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m19.282 51.23-.033-.099.025.074.025.074-.017-.05q-.017-.05-.041-.091l-.025-.041.012.021.012.021.07-.07.07-.07.066.066q.066.066.099.165l.033.099-.025-.074-.025-.074.017.05q.017.05.025.107l.008.058-.004-.029-.004-.029-.128-.004-.128-.004-.033-.099m.149-.182-.05-.05-.017-.016-.017-.016.033.033.066.066.033.033-.05-.05",
    fill: "#392523"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "m19.05 51.197-.066-.066.066-.066.066-.066.066.066q.066.066.099.165l.033.099-.099-.033q-.099-.033-.165-.099m.116-.149-.05-.05-.017-.016-.017-.016.033.033.066.066.033.033-.05-.05m-.198.066.017.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#dd4034"
  })), _use559 || (_use559 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CN",
    x: 1.588,
    y: -2.91,
    className: "G q"
  })), _use560 || (_use560 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CY",
    fill: "#f64239",
    fillOpacity: 0.106
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m61.119 50.932.132-.132.066-.066.074.074.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.074.041l-.025.025.012-.012.012-.012-.083-.074-.083-.074-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066m.215-.215-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "Y"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m60.85 50.928-.004-.136-.029.004-.029.004.058-.008q.058-.008.107-.025l.05-.016-.074.025-.074.025.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.091-.041l.041-.025-.021.012-.021.012.07.07.07.07-.066.066q-.066.066-.165.099l-.099.033-.004-.136m.285-.012.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05",
    className: "h"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m60.623 50.899-.033-.099.025.074.025.074-.016-.05q-.016-.05-.025-.107l-.008-.058.004.029.004.029.128.004.128.004h-.198.066q.066 0 .124-.008l.058-.008-.029.004-.029.004.004.136.004.136-.099-.033q-.099-.033-.132-.132",
    fill: "#506c32"
  })), _use561 || (_use561 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bv",
    x: -12.965,
    y: -7.144,
    fill: "#516d32"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m46.832 50.932-.066-.066.066-.066q.066-.066.132-.066h.066-.1.033q.033 0 .058-.025l.025-.025-.012.012-.012.012.079.087.079.087.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099-.099-.033q-.099-.033-.165-.099m-.083-.083.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "B"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m46.567 50.932-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.074.074-.074.074.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m.116-.149-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05m-.198.066.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "i"
  })), _use562 || (_use562 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CZ",
    className: "Y"
  })), _use563 || (_use563 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ca",
    className: "Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M22.192 50.899q.033-.099.132-.132t.165.033l.066.066-.066.066-.132.132-.066.066-.074-.074-.074-.074-.017.016-.017.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05",
    className: "M"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "m19.05 50.932-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.07.07-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m.347.083-.017-.016-.05-.05-.05-.05.033.033.066.066.033.033-.017-.016m-.232-.232-.05-.05-.017-.016-.017-.016.033.033.066.066.033.033-.05-.05m-.198.066.017.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#402624"
  })), _use564 || (_use564 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ae",
    x: -79.11,
    y: 2.91,
    fill: "#e24034"
  })), _use565 || (_use565 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CN",
    x: 1.852,
    y: -3.175,
    fill: "#f44236",
    fillOpacity: 0.918
  })), _use566 || (_use566 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CY",
    x: 0.264,
    y: -0.265,
    fill: "#f24633",
    fillOpacity: 0.157
  })), _use567 || (_use567 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: 2.382,
    y: -8.731,
    className: "g"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "m61.119 50.668.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07.07.07-.066.066-.132.132-.066.066-.07-.07-.07-.07-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066m.05.215.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05",
    fill: "#696969"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M60.59 50.668v-.132h.132q.132 0 .132.132v.132l-.128-.004-.128-.004.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132",
    fill: "#282c23"
  })), _use568 || (_use568 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CA",
    x: 12.964,
    y: -7.144,
    fill: "#78ac40"
  })), _use569 || (_use569 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bx",
    x: -12.964,
    y: -7.144,
    fill: "#78ad41"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M47.063 50.635q.033-.099.165-.099h.132v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.079-.087-.079-.087-.012.012-.012.012.025-.025q.025-.025.041-.074l.016-.05-.025.074-.025.074.033-.099",
    fill: "#282c24"
  })), _use570 || (_use570 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cb",
    fill: "#666"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "m46.005 50.701-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074.074-.074.066.066.132.132.066.066-.074.074-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.017-.016-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.232-.232-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05",
    className: "c"
  })), _use571 || (_use571 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cc",
    className: "I"
  })), _use572 || (_use572 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ca",
    x: 0.265,
    y: -0.264,
    className: "x"
  })), _use573 || (_use573 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ae",
    x: -79.11,
    y: 2.646,
    fill: "#412624"
  })), _use574 || (_use574 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ae",
    x: -79.375,
    y: 2.646,
    fill: "#da3f33"
  })), _use575 || (_use575 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CN",
    x: 2.117,
    y: -3.439,
    fillOpacity: 0.863,
    className: "e"
  })), _use576 || (_use576 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CY",
    x: 0.529,
    y: -0.529,
    fill: "#f04233",
    fillOpacity: 0.137
  })), _use577 || (_use577 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: 2.646,
    y: -8.996,
    className: "At"
  })), _use578 || (_use578 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bq",
    x: 2.646,
    y: -8.996,
    fill: "#494949"
  })), _use579 || (_use579 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N",
    x: -12.079,
    y: -54.686,
    fill: "#506d32"
  })), _use580 || (_use580 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    x: -25.043,
    y: -56.01,
    fill: "#516e32"
  })), _use581 || (_use581 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Br",
    x: -2.91,
    y: -8.996,
    className: "E"
  })), _use582 || (_use582 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cd",
    fill: "#d5d5d5"
  })), _use583 || (_use583 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: -35.718,
    y: -8.996,
    className: "g"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "m23.019 50.403.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07.07.07-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.066.198.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.231.05-.05.016-.017.016-.016-.033.033-.066.066-.033.033.05-.05",
    className: "AR"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "m18.521 50.403-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.074-.074.074-.074-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.017.016.017.016-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.017-.016-.05-.05-.05-.05.033.033.066.066.033.033",
    fill: "#372524"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "m18.29 50.37-.033-.099.099.033q.099.033.165.099l.066.066-.066.066-.066.066-.066-.066q-.066-.066-.099-.165m.116.182.05.05.017.016.017.016-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.017-.016-.05-.05-.05-.05.033.033.066.066.033.033",
    fill: "#cb3c32"
  })), _use584 || (_use584 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CN",
    x: 2.381,
    y: -3.704,
    className: "G DG"
  })), _use585 || (_use585 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CY",
    x: 0.794,
    y: -0.794,
    fill: "#f64037",
    fillOpacity: 0.11
  })), _use586 || (_use586 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ce",
    className: "Au"
  })), _use587 || (_use587 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bt",
    x: 2.646,
    y: -8.995,
    className: "Av"
  })), _use588 || (_use588 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bz",
    x: 12.7,
    y: -7.673,
    fill: "#252823"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M60.028 50.172q-.033-.099.041-.174l.074-.074-.016-.017-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.132q-.132 0-.165-.099",
    fill: "#71a23e"
  })), _use589 || (_use589 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bx",
    x: -12.7,
    y: -7.673,
    fill: "#70a13e"
  })), _use590 || (_use590 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#By",
    x: -12.7,
    y: -7.672,
    fill: "#252723"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "m45.773 50.139-.066-.066.074-.074.074-.074-.016-.017-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "BX"
  })), _use591 || (_use591 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cf",
    className: "Ad"
  })), _use592 || (_use592 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: -35.454,
    y: -9.26,
    className: "l"
  })), _use593 || (_use593 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bq",
    x: -35.454,
    y: -9.26,
    className: "m"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "m18.224 50.172-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.074-.074q.074-.074.174-.041.099.033.132.132l.033.099-.025-.074-.025-.074.017.05q.017.05.041.091l.025.041-.012-.021-.012-.021-.074.074-.074.074.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.016.074.025.074.025-.099-.033-.099-.033-.033-.099",
    fill: "#2a2322"
  })), _use594 || (_use594 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: -17.899,
    y: -27.963,
    fill: "#a7372e"
  })), _use595 || (_use595 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CT",
    x: -11.377,
    y: -2.645,
    fill: "#f44337",
    className: "Cw"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M8.996 50.139q.066-.066.165-.099l.099-.033v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074-.074-.074.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05",
    className: "r CD"
  })), _use596 || (_use596 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cg",
    className: "y"
  })), _use597 || (_use597 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ch",
    className: "AB"
  })), _use598 || (_use598 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: -5.464,
    y: -34.578,
    fill: "#3c4d2b"
  })), _use599 || (_use599 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: -6.523,
    y: -34.578,
    fill: "#3e502c"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "m45.509 49.874-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07q.07-.07.17-.037.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05",
    className: "L"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "m45.277 49.841-.033-.099.099.033q.099.033.165.099l.066.066-.066.066-.066.066-.066-.066q-.066-.066-.099-.165m.116.182.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033",
    className: "Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "m44.946 49.907-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.079-.079.079-.079-.021-.012-.021-.012.041.025q.041.025.091.041l.05.016-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07q-.07.07-.169.037-.099-.033-.132-.132",
    className: "I"
  })), _use600 || (_use600 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: -35.189,
    y: -9.525,
    className: "t"
  })), _use601 || (_use601 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bt",
    x: -35.454,
    y: -9.26,
    className: "AS"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "m17.732 49.87-.004-.128.099.033q.099.033.132.132l.033.099h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.004-.128",
    fill: "#632c28"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "m17.496 49.841-.033-.099h.264l.004.128.004.128.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132",
    fill: "#de4237"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "m9.782 49.866-.008-.141.107-.025.107-.025-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.083.083.083.083.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099q-.033.099-.165.099H9.79l-.008-.141",
    fillOpacity: 0.886,
    className: "G"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M9.525 49.874q.066-.066.165-.099l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.008.141.008.141-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.079-.079-.079-.079-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066",
    fillOpacity: 0.314,
    className: "e"
  })), _use602 || (_use602 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cc",
    x: 39.688,
    y: -1.059,
    className: "Aw"
  })), _use603 || (_use603 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ca",
    x: 39.952,
    y: -1.323,
    className: "D"
  })), _use604 || (_use604 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: 23.905,
    y: -28.493,
    fill: "#567634"
  })), _use605 || (_use605 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 23.376,
    y: -28.492,
    fill: "#577835"
  })), _use606 || (_use606 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bm",
    x: -4.233,
    y: -10.055,
    fill: "#5b5b5b"
  })), _use607 || (_use607 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bn",
    x: -4.233,
    y: -10.054,
    className: "AT"
  })), _use608 || (_use608 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ce",
    x: -37.836,
    y: -0.53,
    className: "u"
  })), _use609 || (_use609 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bt",
    x: -35.189,
    y: -9.525,
    className: "As"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M17.761 49.643q.033-.099.099-.165l.066-.066.074.066.074.066.008-.016.008-.016-.017.033q-.017.033-.017.066v.033-.1.066q0 .066-.074.141l-.074.074.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033.033-.099m.182-.248-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "AU"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "m17.43 49.643-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.074-.074q.074-.074.141-.074h.066-.1.033q.033 0 .058-.025l.025-.025-.012.012-.012.012.074.083.074.083.012-.021.012-.021-.025.041q-.025.041-.041.091l-.017.05.025-.074.025-.074-.033.099-.033.099h-.264l-.033-.099",
    fill: "#dcd4d3"
  })), _use610 || (_use610 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: -18.693,
    y: -28.493,
    fill: "#f49790"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M16.934 49.609v-.132h.264l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.074.074q-.074.074-.174.041-.099-.033-.099-.165",
    className: "Bl"
  })), _use611 || (_use611 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CN",
    x: 3.704,
    y: -4.497,
    fillOpacity: 0.957,
    className: "G"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "m10.021 49.576.033-.099.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.091-.041l.041-.025-.021.012-.021.012.079.079.078.079.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.083-.083-.083-.083-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099m.107-.124-.074.025-.025.008-.025.008.05-.016.099-.033.05-.016-.074.025",
    fill: "#f44436",
    className: "DF"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M9.823 49.643q.033-.099.132-.132l.099-.033-.033.099q-.033.099-.141.124l-.107.025-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099m.256-.174-.025.008-.074.025-.074.025.05-.016.099-.033.05-.016-.025.008",
    fill: "#ea4040",
    fillOpacity: 0.047
  })), _use612 || (_use612 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: 3.969,
    y: -10.054,
    fill: "#e9e9e9"
  })), _use613 || (_use613 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ci",
    className: "BS"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "m59.763 49.378-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.079-.079.079-.079-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132t-.041.174l-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033-.033-.099",
    fill: "#232522"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "m59.532 49.345-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07.07-.07.066.066q.066.066.099.165l.033.099-.099-.033q-.099-.033-.165-.099m.116-.149-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05",
    fill: "#6a963b"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M48.188 49.378q.033-.099.099-.165l.066-.066.07.07.07.07.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066q-.066.066-.165.099l-.099.033.033-.099m.182-.248-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#6b983c"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M47.857 49.312q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.079.079.079.079.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099-.033.099-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074q-.074-.074-.041-.174",
    fill: "#242622"
  })), _use614 || (_use614 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Br",
    x: -4.233,
    y: -10.054,
    className: "Ax"
  })), _use615 || (_use615 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cd",
    x: -1.323,
    y: -1.058,
    fill: "#cdcdcd"
  })), _use616 || (_use616 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cg",
    x: -37.835,
    y: -0.529,
    className: "v"
  })), _use617 || (_use617 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bt",
    x: -34.925,
    y: -9.789,
    className: "C"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "m17.992 49.345.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.05.066l-.017.033.008-.016.008-.016-.074-.066-.074-.066.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.298-.033.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "Ay"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M17.694 49.312q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.074.074.074.074-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.074-.083-.074-.083-.012.012-.012.012.025-.025q.025-.025.041-.074l.017-.05-.025.074-.025.074.033-.099m.314.016.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05",
    className: "k"
  })), _use618 || (_use618 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bc",
    x: -35.983,
    y: -11.906,
    fill: "#f5e7e6"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "m16.673 49.341-.004-.128h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.004.128.004.128h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.004-.128m.161.136H17h-.264.099m-.066-.265h-.165.264-.099",
    fill: "#f49993"
  })), _use619 || (_use619 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    x: -46.209,
    y: -33.255,
    fill: "#f45044"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "m10.836 49.332-.012-.145.112-.021.112-.021-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.083.083.083.083.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099q-.033.099-.165.099h-.132l-.012-.145",
    className: "G CF"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M10.584 49.345v-.132h.264-.198.066q.066 0 .107-.025l.041-.025-.021.012-.021.012.012.145.012.145h-.264v-.132",
    className: "Bv Cv"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M10.319 49.345q.066-.066.165-.099l.099-.033v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.079-.079-.079-.079-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066",
    fill: "#f34931",
    fillOpacity: 0.082
  })), _use620 || (_use620 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ce",
    x: 1.323,
    y: -1.059,
    fill: "#d9d9d9"
  })), _use621 || (_use621 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bq",
    x: 4.233,
    y: -10.319,
    fill: "#464646"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "m59.532 49.08-.066-.066.074-.074.074-.074-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.079.079-.079.079.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m-.083-.083.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#2b3125"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "m59.234 49.113-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074.074-.074.066.066.132.132.066.066-.07.07-.07.07.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.232-.232-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05",
    fill: "#72a33f"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "m48.419 49.08.132-.132.066-.066.074.074.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.091.041l-.041.025.021-.012.021-.012-.07-.07-.07-.07.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#70a13e"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M48.121 49.047q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.074.074.074.074-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.079-.079-.079-.079-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.314.016.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05",
    fill: "#2b3125"
  })), _use622 || (_use622 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cj",
    className: "Az"
  })), _use623 || (_use623 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cf",
    x: -1.323,
    y: -1.059,
    fill: "#aaa"
  })), _use624 || (_use624 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ca",
    x: 2.117,
    y: -1.852,
    className: "CM"
  })), _use625 || (_use625 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bt",
    x: -34.66,
    y: -10.054,
    className: "B"
  })), _use626 || (_use626 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ad",
    x: -101.6,
    y: 1.058,
    className: "AV"
  })), _use627 || (_use627 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CX",
    x: -3.175,
    y: -2.911,
    className: "U"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "m16.371 49.113-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.074-.074q.074-.074.174-.041.099.033.099.165v.132h-.264l-.033-.099",
    fill: "#f5f1f0"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "m16.14 49.08-.008-.124-.029-.004-.029-.004.058.008q.058.008.107.025l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.008-.124",
    fill: "#f5bdb9"
  })), _use628 || (_use628 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bf",
    x: -35.455,
    y: -11.906,
    fill: "#f57c74"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M15.611 49.08v-.132h.264l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.074.074q-.074.074-.174.041-.099-.033-.099-.165m.298-.132h-.231.264",
    fill: "#f44c40"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.907 49.08v-.132h.528l.099.033q.099.033.174-.041l.074-.074-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.198 0l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.074.074q.074.074.174.041l.099-.033h.528l.099.033q.099.033.174-.041l.074-.074-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.232.033h.927v.132q0 .132.099.165t.174-.041l.074-.074-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.232.033h.132l.033.099q.033.099.132.132t.232.033h.132v.132q0 .132.099.165t.174-.041l.074-.074-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033.033.099q.033.099.132.132t.232.033h.132l.033.099q.033.099.132.132l.099.033.033.099q.033.099.099.165l.132.132.132.132.132.132.132.132.132.132q.066.066.165.099l.099.033.033.099q.033.099.132.132l.099.033.033.099q.033.099.132.132l.099.033v.132q0 .132.033.232.033.099.132.132l.099.033.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.074.074q-.074.074-.041.174.033.099.165.099h.132v.132q0 .132.033.232.033.099.132.132l.099.033v.132q0 .132.033.232l.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.074.074q-.074.074-.041.174.033.099.165.099h.132V55.564l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.074.074q-.074.074-.041.174.033.099 0 .198t.041.174l.074.074.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099V57.95h-.132q-.132 0-.165.099t.041.174l.074.074.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099q-.033.099-.033.232v.132l-.099.033q-.099.033-.132.132t-.033.232v.132h-.132q-.132 0-.165.099t.041.174l.074.074.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099-.099.033q-.099.033-.132.132t-.033.232v.132l-.099.033q-.099.033-.132.132l-.033.099-.099.033q-.099.033-.165.099l-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132q-.066.066-.099.165l-.033.099-.099.033q-.099.033-.132.132l-.033.099h-.132q-.132 0-.232.033-.099.033-.132.132l-.033.099-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132h-.132q-.132 0-.232.033-.099.033-.132.132l-.033.099h-.132q-.132 0-.232.033l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132h-.927q-.132 0-.232.033l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074q-.074-.074-.174-.041l-.099.033h-.529l-.099-.033q-.099-.033-.174.041l-.074.074.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.198 0l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074q-.074-.074-.174-.041l-.099.033h-.264l-.099-.033q-.099-.033-.132-.132t-.165-.099h-.396l-.099-.033q-.099-.033-.132-.132t-.165-.099h-.396v-.132q0-.132-.132-.132h-.396v-.132q0-.132-.132-.132H9.79l-.099-.033q-.099-.033-.132-.132t-.132-.132-.132-.132q-.033-.099-.165-.099h-.132v-.132q0-.132-.132-.132h-.132v-.132q0-.132-.132-.132H8.47v-.132q0-.132-.132-.132h-.132v-.132q0-.132-.099-.099l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.083-.083-.083-.083-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099q.033-.099-.066-.132t-.132-.132l-.033-.099v-.132q0-.132-.132-.132h-.132v-.396q0-.132-.132-.132h-.132v-.396q0-.132-.099-.165t-.132-.132l-.033-.099v-.396q0-.132-.132-.132H6.62V54.262h.132q.132 0 .132-.132v-.396l.033-.099q.033-.099.132-.132t.099-.165v-.396h.132q.132 0 .132-.132v-.396h.132q.132 0 .132-.132v-.132l.033-.099q.033-.099.132-.132t.099-.165v-.132h.132q.132 0 .132-.132v-.132h.132q.132 0 .132-.132v-.132H8.6q.132 0 .132-.132v-.132h.132q.132 0 .132-.132v-.132h.132q.132 0 .132-.132v-.132h.132q.132 0 .165-.099t.132-.132l.099-.033h.132q.132 0 .165-.099t.132-.132l.099-.033h.132q.132 0 .132-.132v-.132h.396q.132 0 .165-.099t.132-.132l.099-.033h.396q.132 0 .132-.132m3.605 14.155h.165-.264.099m5.391-5.259v-.231.264-.033m0-3.638v-.165.264-.099"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CN",
    x: 5.027,
    y: -5.027,
    fillOpacity: 0.949
  }))), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M11.377 49.08v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.091-.041l.041-.025-.021.012-.021.012.078.079.079.079.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099h-.264v-.132",
    className: "AQ DE"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "m11.084 49.051.037-.095-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.083-.083-.083-.083-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.037-.095",
    className: "CG CH"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M10.881 49.113q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.107-.025l.058-.008-.029.004-.029.004-.037.095q-.037.095-.149.116l-.112.021-.021.012-.021.012.041-.025q.041-.025.058-.074l.017-.05-.025.074-.025.074.033-.099",
    className: "An Ao"
  })), _use629 || (_use629 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cg",
    x: 1.323,
    y: -1.058,
    className: "AW"
  })), _use630 || (_use630 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bt",
    x: 4.234,
    y: -10.318,
    className: "Ac"
  })), _use631 || (_use631 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bu",
    x: 10.583,
    y: -10.318,
    fill: "#2e3726"
  })), _use632 || (_use632 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bs",
    x: 10.318,
    y: -10.583,
    fill: "#74a73f"
  })), _use633 || (_use633 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: -10.318,
    y: -10.583,
    fill: "#75a740"
  })), _use634 || (_use634 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bt",
    x: -10.583,
    y: -10.318,
    fill: "#2f3826"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "m43.954 48.783-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.107.025q.108.025.174.091l.066.066-.066.066-.066.066-.066-.066q-.066-.066-.099-.165m.116.182.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033",
    className: "h"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "m43.624 48.849-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.079-.079.079-.079-.021-.012-.021-.012.041.025q.041.025.091.041l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07q-.07.07-.169.037-.099-.033-.132-.132",
    className: "I"
  })), _use635 || (_use635 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ca",
    x: 2.381,
    y: -2.116,
    className: "Z"
  })), _use636 || (_use636 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ch",
    x: -37.306,
    y: -1.058,
    className: "M"
  })), _use637 || (_use637 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ad",
    x: -101.336,
    y: 0.794,
    className: "BA"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M18.224 48.783q.033-.099.132-.132t.165.033l.066.066-.066.066-.132.132-.066.066-.074-.074-.074-.074-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099m.083.248.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.016m.232-.232.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05",
    className: "I"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "m15.578 48.849-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.074-.074q.074-.074.174-.041.099.033.099.165v.132h-.264l-.033-.099m0 .099h.231-.264",
    fill: "#f5f2f2"
  })), _use638 || (_use638 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    x: -47.797,
    y: -33.784,
    fill: "#f5cecc"
  })), _use639 || (_use639 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AG",
    x: -18.163,
    y: -27.434,
    fill: "#f5a59f"
  })), _use640 || (_use640 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ck",
    className: "Bk"
  })), _use641 || (_use641 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AH",
    x: -18.428,
    y: -27.434,
    fill: "#f56e64"
  })), _use642 || (_use642 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    x: -48.326,
    y: -33.784,
    className: "p"
  })), _use643 || (_use643 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cl",
    className: "Br"
  })), _use644 || (_use644 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -9.697,
    y: -58.919,
    fill: "#f4473b"
  })), _use645 || (_use645 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -9.962,
    y: -58.919,
    className: "Aj"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "m13.196 48.783.033-.099h.264v.264l-.099.033q-.099.033-.174-.041l-.074-.074-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099",
    className: "Br"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M12.965 48.807v-.124h.264l-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.099.016h-.05.05v-.124m.099-.124h-.165.264-.099",
    className: "p"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "m12.733 48.783-.033-.099h.264v.248h.05-.05q-.05 0-.099-.016l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.265-.099h-.231.264",
    fill: "#f56e64"
  })), _use646 || (_use646 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cl",
    x: -1.587,
    className: "AQ DA"
  })), _use647 || (_use647 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -11.285,
    y: -58.919,
    className: "Ap DD"
  })), _use648 || (_use648 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: -11.549,
    y: -58.919,
    fill: "#f64138",
    className: "Cz"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M11.642 48.816q.066-.066.165-.099l.099-.033v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.079-.079-.078-.079-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066",
    className: "r CJ"
  })), _use649 || (_use649 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ca",
    x: 41.275,
    y: -2.381,
    className: "BY"
  })), _use650 || (_use650 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ch",
    x: 1.587,
    y: -1.323,
    className: "B"
  })), _use651 || (_use651 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bu",
    x: 10.318,
    y: -10.583,
    fill: "#2f3726"
  })), _use652 || (_use652 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cd",
    x: 12.965,
    y: -1.852,
    fill: "#71a13e"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "m48.948 48.551.132-.132.066-.066.07.07.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074-.074-.075.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#709f3e"
  })), _use653 || (_use653 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bt",
    x: -10.318,
    y: -10.583,
    fill: "#2d3525"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "m43.657 48.551-.066-.066.074-.074.074-.074-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.091.174l-.008.141.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.165-.099m-.083-.083.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "AC"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "m43.359 48.584-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.07-.07.07-.07.066.066.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.079.079-.079.079.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.149-.182-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05",
    className: "CN"
  })), _use654 || (_use654 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cc",
    x: 2.381,
    y: -2.117,
    className: "I"
  })), _use655 || (_use655 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ca",
    x: 2.646,
    y: -2.381,
    className: "x"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "m19.05 48.551.132-.132.066-.066.074.074.074.074.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099q-.033.099-.132.132t-.165-.033l-.066-.066.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.232-.232-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "M"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "m18.786 48.551.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.066.198.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.016m.232-.232.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05M19 48.336l-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "AG"
  })), _use656 || (_use656 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cc",
    x: 41.275,
    y: -2.381,
    className: "W"
  })), _use657 || (_use657 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ca",
    x: 41.54,
    y: -2.645,
    className: "BB"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "m58.738 48.287-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.079-.079.079-.079-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05",
    fill: "#2b3025"
  })), _use658 || (_use658 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    x: -5.993,
    y: -35.108,
    fill: "#6a973b"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M49.213 48.287q.066-.066.165-.099l.099-.033-.033.099q-.033.099-.099.165l-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07-.07-.07.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05",
    fill: "#6b983c"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M48.915 48.253q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.079.079.079.079.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.066.066-.074-.074-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033",
    fill: "#2b3124"
  })), _use659 || (_use659 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bu",
    x: -5.292,
    y: -10.847,
    className: "Av"
  })), _use660 || (_use660 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cf",
    x: -2.382,
    y: -1.852,
    className: "BC"
  })), _use661 || (_use661 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: -33.337,
    y: -11.112,
    className: "g"
  })), _use662 || (_use662 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ci",
    x: -37.307,
    y: -1.058,
    className: "AR"
  })), _use663 || (_use663 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CU",
    x: -1.852,
    y: -3.968,
    className: "w"
  })), _use664 || (_use664 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ad",
    x: -100.807,
    y: 0.265,
    className: "y"
  })), _use665 || (_use665 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: 5.557,
    y: -11.377,
    className: "BU"
  })), _use666 || (_use666 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ci",
    x: 1.587,
    y: -1.323,
    fill: "#5a5a5a"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "m58.44 48.055-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.087-.079.087-.079-.012-.012-.012-.012.025.025q.025.025.074.041l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.079.079-.079.079.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.016.074.025.074.025-.099-.033-.099-.033-.033-.099",
    fill: "#252723"
  })), _use667 || (_use667 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: 22.318,
    y: -30.08,
    fill: "#5b7e36"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M49.477 48.022v-.132.198-.066q0-.066-.008-.124l-.008-.058.004.029.004.029.136-.004.136-.004-.033.099q-.033.099-.132.132l-.099.033v-.132",
    fill: "#577636"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "m49.18 47.989.033-.099h.264v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.091.041l-.041.025.021-.012.021-.012-.079-.079-.079-.079-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099",
    fill: "#242622"
  })), _use668 || (_use668 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cj",
    x: -1.323,
    y: -1.058,
    className: "n"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "m42.863 48.022-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.232-.232-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05m-.198.066.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "BD"
  })), _use669 || (_use669 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: -33.072,
    y: -11.377,
    className: "l"
  })), _use670 || (_use670 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bq",
    x: -33.073,
    y: -11.377,
    className: "m"
  })), _use671 || (_use671 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CU",
    x: -1.587,
    y: -4.233,
    className: "V"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "m19.315 48.022.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07.07.07-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.066.198.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.016m.232-.232.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05",
    className: "AF"
  })), _use672 || (_use672 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ce",
    x: 2.91,
    y: -2.382,
    fill: "#d3d3d3"
  })), _use673 || (_use673 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bq",
    x: 5.821,
    y: -11.642,
    className: "Ba"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M58.209 47.757q0-.132.099-.165l.099-.033-.074.025-.074.025.05-.016q.05-.016.091-.041l.041-.025-.021.012-.021.012.083.074.083.074.012-.012.012-.012-.025.025q-.025.025-.025.058v.033-.1.132-.1.033q0 .033.025.058l.025.025-.012-.012-.012-.012-.087.079-.087.079.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132",
    fill: "#393939"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "m57.977 47.724-.033-.099.145.012.145.012.012-.021.012-.021-.025.041q-.025.041-.025.107v.066-.198.264l-.099-.033q-.099-.033-.132-.132m.066-.099h-.165.264-.099",
    fill: "#b3c4a1"
  })), _use674 || (_use674 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Be",
    x: 5.821,
    y: -13.494,
    fill: "#8abb57"
  })), _use675 || (_use675 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ba",
    x: -5.82,
    y: -13.494,
    fill: "#8abb56"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "m49.746 47.753.004-.136-.029-.004-.029-.004.058.008q.058.008.124.008h.066-.198.264l-.033.099q-.033.099-.132.132l-.099.033.004-.136m.294-.128h-.231.264",
    className: "CI"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "m49.444 47.79-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.079-.079.079-.079-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033-.074-.025-.074-.025.05.016q.05.016.107.025l.058.008-.029-.004-.029-.004-.004.136-.004.136-.136.004-.136.004.004.029.004.029-.008-.058q-.008-.058-.025-.107l-.016-.05.025.074.025.074-.033-.099",
    className: "AW"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "m49.18 47.79-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074.074-.074.066.066q.066.066.099.165l.033.099h-.264l-.033-.099m.149-.182-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05",
    fill: "#323232"
  })), _use676 || (_use676 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cb",
    x: -3.704,
    y: -2.911,
    className: "x"
  })), _use677 || (_use677 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CZ",
    x: -3.968,
    y: -3.175,
    fill: "#eee"
  })), _use678 || (_use678 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bp",
    x: -32.808,
    y: -11.642,
    className: "t"
  })), _use679 || (_use679 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bt",
    x: -33.073,
    y: -11.377,
    className: "AS"
  })), _use680 || (_use680 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CU",
    x: -1.323,
    y: -4.498,
    className: "a"
  })), _use681 || (_use681 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CV",
    x: -1.323,
    y: -4.498,
    className: "K"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "m65.088 47.493.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07-.07-.07.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.298-.033.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#b6b6b6"
  })), _use682 || (_use682 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cm",
    className: "C"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "m58.473 47.493.132-.132.066-.066.07.07.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.074.041l-.025.025.012-.012.012-.012-.083-.074-.083-.074-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066m.215-.215-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#4e4e4e"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M58.221 47.505q-.012-.145.087-.178l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.017-.016.017.074.074.074.074-.066.066q-.066.066-.165.099l-.099.033.074-.025.074-.025-.05.016q-.05.016-.074.058l-.025.041.012-.021.012-.021-.012-.145m.269-.029.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05",
    className: "CN"
  })), _use683 || (_use683 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bi",
    x: 6.615,
    y: -13.229,
    fill: "#eff2ed"
  })), _use684 || (_use684 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AS",
    x: 37.134,
    y: -18.174,
    fill: "#b5d297"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "Bc"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bj",
    x: 6.614,
    y: -13.229
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bg",
    x: -6.614,
    y: -13.229
  }))), _use685 || (_use685 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AV",
    x: -68.792,
    y: -1.058,
    fill: "#b4d195"
  })), _use686 || (_use686 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bh",
    x: -6.614,
    y: -13.229,
    fill: "#eff1ec"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "m49.213 47.493-.066-.066.074-.074.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.079.079-.079.079.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m-.083-.083.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "At"
  })), _use687 || (_use687 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cn",
    fill: "#4c4c4c"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "m42.334 47.493-.066-.066.074-.074.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07-.07.07-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#4d4d4d"
  })), _use688 || (_use688 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cn",
    x: -6.879,
    fill: "#ddd"
  })), _use689 || (_use689 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ce",
    x: -35.454,
    y: -2.646,
    className: "u"
  })), _use690 || (_use690 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cm",
    x: -38.629,
    className: "As"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "m20.109 47.493.132-.132.066-.066.07.07.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.017.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074-.074-.074.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.232-.232-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "AU"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M19.811 47.46q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.017-.017.017.074.074.074.074-.066.066-.132.132-.066.066-.074-.074-.074-.074-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099m.083.248.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.016m.232-.232.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05",
    className: "BE"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "m65.352 47.228.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.016.017-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.066.198.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "i"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M65.055 47.195q.033-.099.132-.132t.165.033l.066.066-.066.066-.132.132-.066.066-.074-.074-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05",
    className: "B"
  })), _use691 || (_use691 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Co",
    fill: "#6e6e6e"
  })), _use692 || (_use692 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cp",
    fill: "#eee"
  })), _use693 || (_use693 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cq",
    fill: "#ecf0e7"
  })), _use694 || (_use694 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#H",
    x: 35.282,
    y: -60.243,
    fill: "#b7d399"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "#85b84f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: -7.316,
    y: -35.901
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bg",
    x: -6.085,
    y: -13.494
  }))), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M50.829 47.257q.037-.095.136-.128l.099-.033-.074.025-.074.025.05-.017q.05-.017.107-.025l.058-.008-.029.004-.029.004-.037.095q-.037.095-.136.128l-.099.033.074-.025.074-.025-.05.016q-.05.016-.107.025l-.058.008.029-.004.029-.004.037-.095",
    fill: "#b6d398"
  })), _use695 || (_use695 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cr",
    fill: "#ebf0e6"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "m48.948 47.228-.066-.066.066-.066q.066-.066.165-.033t.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "J"
  })), _use696 || (_use696 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cs",
    className: "BB"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "m42.069 47.228-.066-.066.074-.074.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#333"
  })), _use697 || (_use697 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cs",
    x: -6.879,
    className: "AW"
  })), _use698 || (_use698 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Co",
    x: -32.015,
    className: "v"
  })), _use699 || (_use699 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cp",
    x: -32.014,
    className: "C"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "m20.373 47.228.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07-.07-.07.066-.066m-.017.017-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.298-.033.05-.05.017-.017.017-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "Ay"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M20.076 47.195q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.017.017-.017.017.074.074.074.074-.066.066-.132.132-.066.066-.074-.074-.074-.074-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099m.083.248.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.016m.232-.232.05-.05.017-.017.017-.017-.033.033-.066.066-.033.033.05-.05",
    className: "k"
  })), _use700 || (_use700 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    className: "J"
  })), _use701 || (_use701 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    className: "CO"
  })), _use702 || (_use702 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: -6.615,
    className: "L"
  })), _use703 || (_use703 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    className: "i"
  })), _use704 || (_use704 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    className: "Y"
  })), _use705 || (_use705 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cx",
    className: "AN"
  })), _use706 || (_use706 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cy",
    className: "CI"
  })), _use707 || (_use707 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AF",
    x: 22.053,
    y: -29.55,
    fill: "#a3c87c"
  })), _use708 || (_use708 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cz",
    className: "AO"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M52.123 46.964v-.132h.793l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041l.099-.033h1.056l.099.033q.099.033.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033h.793v.132q0 .132.099.165t.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.232.033h.132v.132q0 .132.099.165t.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.174-.041l.074-.074-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.174-.041l.074-.074-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033.033.099q.033.099.132.132l.099.033.033.099q.033.099.099.165t.099.165q.033.099.132.132t.132.132.132.132.132.132.132.132q.099.033.165.099t.165.099l.099.033.033.099q.033.099.132.132l.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074q-.074.074-.041.174.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074q-.074.074-.041.174.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074q-.074.074-.041.174.033.099.165.099h.132v.132q0 .132.033.232l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074q-.074.074-.041.174.033.099.165.099h.132v.661q0 .132.033.232l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074q-.074.074-.041.174l.033.099v1.057l-.033.099q-.033.099.041.174l.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099v.794h-.132q-.132 0-.165.099t.041.174l.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.033.232v.132h-.132q-.132 0-.165.099t.041.174l.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.132q-.132 0-.165.099t.041.174l.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.132q-.132 0-.165.099t.041.174l.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099-.099.033q-.099.033-.132.132l-.033.099-.099.033q-.099.033-.165.099t-.165.099q-.099.033-.132.132t-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165t-.099.165l-.033.099-.099.033q-.099.033-.132.132l-.033.099-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132h-.132q-.132 0-.232.033l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132h-.661q-.132 0-.232.033l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074q-.074-.074-.174-.041l-.099.033h-1.057l-.099-.033q-.099-.033-.174.041l-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.232-.033h-.661v-.132q0-.132-.099-.165t-.174.041l-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.232-.033h-.132v-.132q0-.132-.099-.165t-.174.041l-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132q0-.132-.099-.165t-.174.041l-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132q0-.132-.099-.165t-.174.041l-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033-.033-.099q-.033-.099-.132-.132l-.099-.033-.033-.099q-.033-.099-.099-.165t-.099-.165q-.033-.099-.132-.132t-.132-.132-.132-.132-.132-.132-.132-.132q-.099-.033-.165-.099t-.165-.099l-.099-.033-.033-.099q-.033-.099-.132-.132l-.099-.033-.033-.099-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.016.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132l-.033-.099-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132l-.033-.099-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132v-.132q0-.132-.033-.232l-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132v-.662q0-.132-.033-.232l-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074q.074-.074.041-.174l-.033-.099v-1.057l.033-.099q.033-.099-.041-.174l-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099v-.794h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099q.033-.099.033-.232v-.132h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099.099-.033q.099-.033.132-.132l.033-.099.099-.033q.099-.033.165-.099t.165-.099q.099-.033.132-.132t.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165t.099-.165l.033-.099.099-.033q.099-.033.132-.132l.033-.099.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.074.074q.074.074.174.041.099-.033.099-.165v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.074.074q.074.074.174.041.099-.033.099-.165v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041.099-.033.099-.165v-.132h.132q.132 0 .232-.033l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041.099-.033.099-.165",
    className: "BQ"
  })), _use709 || (_use709 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DA",
    className: "AO"
  })), _use710 || (_use710 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DB",
    fill: "#a3c87b"
  })), _use711 || (_use711 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DC",
    fill: "#cee0bc"
  })), _use712 || (_use712 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DD",
    className: "AN"
  })), _use713 || (_use713 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DE",
    className: "BF"
  })), _use714 || (_use714 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DF",
    className: "AB"
  })), _use715 || (_use715 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DG",
    className: "B"
  })), _use716 || (_use716 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DH",
    className: "i"
  })), _use717 || (_use717 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DF",
    x: -6.879,
    className: "Y"
  })), _use718 || (_use718 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -32.014,
    className: "CM"
  })), _use719 || (_use719 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    className: "B"
  })), _use720 || (_use720 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    x: -77.258,
    y: 1.852,
    className: "AV"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M20.34 46.931q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.017.017-.017.017.074.074.074.074-.066.066-.132.132-.066.066-.074-.074-.074-.074-.017.017-.017.017.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099m.083.248.017-.017.05-.05.05-.05-.033.033-.066.066-.033.033.017-.017m.232-.232.05-.05.017-.017.017-.017-.033.033-.066.066-.033.033.05-.05",
    className: "U"
  })), _use721 || (_use721 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    className: "BG"
  })), _use722 || (_use722 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    className: "AC"
  })), _use723 || (_use723 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -6.614,
    className: "V"
  })), _use724 || (_use724 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: -6.35,
    y: -0.265,
    className: "v"
  })), _use725 || (_use725 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cx",
    x: -0.794,
    y: -0.265,
    className: "Ar"
  })), _use726 || (_use726 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    x: -7.58,
    y: -35.901,
    className: "CK"
  })), _use727 || (_use727 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bd",
    x: 2.646,
    y: -14.552,
    className: "CL"
  })), _use728 || (_use728 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 31.578,
    y: -61.036,
    className: "AI"
  })), _use729 || (_use729 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CK",
    x: 33.866,
    y: -8.996,
    fill: "#99c36d"
  })), _use730 || (_use730 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DL",
    className: "s"
  })), _use731 || (_use731 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 30.784,
    y: -61.036,
    className: "f"
  })), _use732 || (_use732 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 30.519,
    y: -61.036,
    className: "Ae"
  })), _use733 || (_use733 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 30.255,
    y: -61.036,
    className: "Ah"
  })), _use734 || (_use734 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 29.99,
    y: -61.036,
    className: "f"
  })), _use735 || (_use735 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DM",
    className: "s"
  })), _use736 || (_use736 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CS",
    x: 6.35,
    y: -6.35,
    fill: "#99c36d"
  })), _use737 || (_use737 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 29.196,
    y: -61.036,
    className: "AI"
  })), _use738 || (_use738 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bb",
    x: -2.646,
    y: -14.552,
    className: "CL"
  })), _use739 || (_use739 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DN",
    className: "CK"
  })), _use740 || (_use740 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DD",
    x: 0.794,
    y: -0.265,
    className: "Ar"
  })), _use741 || (_use741 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DO",
    className: "Au"
  })), _use742 || (_use742 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DP",
    className: "a"
  })), _use743 || (_use743 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DE",
    x: -7.144,
    y: -0.265,
    fill: "#666"
  })), _use744 || (_use744 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DQ",
    className: "c"
  })), _use745 || (_use745 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -31.75,
    y: -0.265,
    className: "Z"
  })), _use746 || (_use746 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: -31.75,
    y: -0.265,
    className: "M"
  })), _use747 || (_use747 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    x: -76.994,
    y: 1.587,
    className: "BA"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M20.605 46.666q.033-.099.132-.132t.165.033l.066.066-.066.066-.132.132-.066.066-.074-.074-.074-.074-.017.017-.017.017.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099m.083.248.017-.017.05-.05.05-.05-.033.033-.066.066-.033.033.017-.017m.232-.232.05-.05.017-.017.017-.017-.033.033-.066.066-.033.033.05-.05",
    className: "I"
  })), _use748 || (_use748 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DR",
    className: "u"
  })), _use749 || (_use749 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 39.423,
    y: -0.53,
    className: "a"
  })), _use750 || (_use750 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DR",
    x: -6.615,
    className: "Ax"
  })), _use751 || (_use751 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: -6.35,
    y: -0.265,
    className: "K"
  })), _use752 || (_use752 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DS",
    className: "BG"
  })), _use753 || (_use753 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DT",
    className: "AX"
  })), _use754 || (_use754 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DO",
    x: -7.144,
    y: -0.265,
    className: "E"
  })), _use755 || (_use755 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DP",
    x: -7.144,
    y: -0.264,
    fill: "#d5d5d5"
  })), _use756 || (_use756 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: -38.1,
    y: -0.53,
    className: "I"
  })), _use757 || (_use757 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -31.485,
    y: -0.53,
    className: "x"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "m21.432 46.434.132-.132.066-.066.074.074.074.074.017-.017.017-.017-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099q-.033.099-.132.132t-.165-.033l-.066-.066.066-.066m-.017.017-.05.05-.017.017-.017.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.017.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "M"
  })), _use758 || (_use758 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Av",
    x: -76.729,
    y: 1.322,
    className: "AG"
  })), _use759 || (_use759 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    fill: "#b1b1b1"
  })), _use760 || (_use760 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 39.688,
    y: -0.794,
    className: "C"
  })), _use761 || (_use761 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: -6.614,
    className: "AX"
  })), _use762 || (_use762 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 33.073,
    y: -0.794,
    className: "AT"
  })), _use763 || (_use763 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DV",
    className: "I"
  })), _use764 || (_use764 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DW",
    className: "D"
  })), _use765 || (_use765 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DX",
    className: "M"
  })), _use766 || (_use766 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DS",
    x: -7.144,
    y: -0.264,
    className: "BX"
  })), _use767 || (_use767 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DT",
    x: -7.143,
    y: -0.264,
    className: "Ad"
  })), _use768 || (_use768 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -38.1,
    y: -0.529,
    className: "g"
  })), _use769 || (_use769 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: -37.835,
    y: -0.794,
    className: "AR"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "m21.696 46.17.132-.132.066-.066.074.074.074.074.017-.017.017-.017-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.017-.017.017-.017-.074-.074-.074-.074.066-.066m-.017.017-.05.05-.017.017-.017.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.017.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "w"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "m21.432 46.17.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.017.017-.05.05-.017.017-.017.017.033-.033.066-.066.033-.033-.05.05m.066.198.017-.017.05-.05.05-.05-.033.033-.066.066-.033.033.017-.017m.232-.232.05-.05.017-.017.017-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.017-.05.05-.05.05.033-.033.066-.066.033-.033-.017.017",
    className: "y"
  })), _use770 || (_use770 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: 1.323,
    y: -1.059,
    className: "Y"
  })), _use771 || (_use771 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 7.938,
    y: -1.059,
    className: "h"
  })), _use772 || (_use772 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: 7.937,
    y: -1.059,
    className: "M"
  })), _use773 || (_use773 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 1.323,
    y: -1.059,
    className: "x"
  })), _use774 || (_use774 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: 1.323,
    y: -1.059,
    className: "J"
  })), _use775 || (_use775 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DY",
    className: "BT"
  })), _use776 || (_use776 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DZ",
    className: "C"
  })), _use777 || (_use777 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DV",
    x: -7.143,
    y: -0.265,
    className: "L"
  })), _use778 || (_use778 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DW",
    x: -7.144,
    y: -0.265,
    className: "Z"
  })), _use779 || (_use779 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DX",
    x: -7.144,
    y: -0.265,
    className: "I"
  })), _use780 || (_use780 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -37.835,
    y: -0.794,
    className: "l"
  })), _use781 || (_use781 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: -37.836,
    y: -0.794,
    className: "m"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "m21.961 45.905.132-.132.066-.066.074.074.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.017-.017.017-.017-.074-.074-.074-.074.066-.066m-.017.017-.05.05-.017.017-.017.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.017.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "V"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "m21.696 45.905.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07.07.07-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.017.017-.05.05-.017.017-.017.017.033-.033.066-.066.033-.033-.05.05m.066.198.017-.017.05-.05.05-.05-.033.033-.066.066-.033.033.017-.017m.232-.232.05-.05.017-.017.017-.017-.033.033-.066.066-.033.033.05-.05",
    className: "AF"
  })), _use782 || (_use782 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: 1.323,
    y: -1.058,
    className: "g"
  })), _use783 || (_use783 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: 1.588,
    y: -1.323,
    fill: "#696969"
  })), _use784 || (_use784 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: -5.027,
    y: -1.323,
    className: "B"
  })), _use785 || (_use785 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 1.588,
    y: -1.323,
    className: "BD"
  })), _use786 || (_use786 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DO",
    x: -1.323,
    y: -1.058,
    className: "N"
  })), _use787 || (_use787 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DP",
    x: -1.323,
    y: -1.058,
    fill: "#404040"
  })), _use788 || (_use788 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DY",
    x: -7.144,
    y: -0.264,
    fill: "#5b5b5b"
  })), _use789 || (_use789 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DZ",
    x: -7.144,
    y: -0.264,
    className: "AT"
  })), _use790 || (_use790 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -37.571,
    y: -1.058,
    className: "t"
  })), _use791 || (_use791 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 1.588,
    y: -1.323,
    className: "AS"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "m22.225 45.641.132-.132.066-.066.074.074.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074-.074-.074.066-.066m-.016.017-.05.05-.017.017-.017.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "a"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M21.928 45.608q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.017.017-.017.017.074.074.074.074-.066.066-.132.132-.066.066-.07-.07-.07-.07-.012.021-.012.021.025-.041q.025-.041.041-.091l.017-.05-.025.074-.025.074.033-.099m.083.248.017-.017.05-.05.05-.05-.033.033-.066.066-.033.033.017-.017m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05",
    className: "K"
  })), _use792 || (_use792 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: 1.588,
    y: -1.323,
    className: "At"
  })), _use793 || (_use793 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: 1.587,
    y: -1.323,
    fill: "#494949"
  })), _use794 || (_use794 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -5.027,
    y: -1.323,
    fill: "#2e2e2e"
  })), _use795 || (_use795 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: -4.762,
    y: -1.588,
    fill: "#bbb"
  })), _use796 || (_use796 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DS",
    x: -1.323,
    y: -1.058,
    fill: "#e8e8e8"
  })), _use797 || (_use797 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DT",
    x: -1.323,
    y: -1.058,
    className: "CP"
  })), _use798 || (_use798 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DO",
    x: -8.467,
    y: -1.323,
    className: "Ax"
  })), _use799 || (_use799 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DP",
    x: -8.467,
    y: -1.323,
    fill: "#cdcdcd"
  })), _use800 || (_use800 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Da",
    className: "u"
  })), _use801 || (_use801 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 1.852,
    y: -1.588,
    className: "As"
  })), _use802 || (_use802 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Da",
    x: -6.35,
    className: "AU"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M22.192 45.343q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074.074.074-.066.066-.132.132-.066.066-.074-.074-.074-.074-.017.017-.017.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05",
    className: "BE"
  })), _use803 || (_use803 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DR",
    x: 1.587,
    y: -1.322,
    className: "Au"
  })), _use804 || (_use804 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 41.011,
    y: -1.853,
    className: "Av"
  })), _use805 || (_use805 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DR",
    x: -5.027,
    y: -1.322,
    fill: "#434343"
  })), _use806 || (_use806 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: -4.763,
    y: -1.588,
    className: "t"
  })), _use807 || (_use807 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DG",
    x: 4.497,
    y: -1.852,
    className: "Aw"
  })), _use808 || (_use808 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DH",
    x: 4.498,
    y: -1.852,
    className: "h"
  })), _use809 || (_use809 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DF",
    x: -2.381,
    y: -1.852,
    className: "M"
  })), _use810 || (_use810 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DG",
    x: -2.382,
    y: -1.852,
    className: "Az"
  })), _use811 || (_use811 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DT",
    x: -8.466,
    y: -1.322,
    fill: "#aaa"
  })), _use812 || (_use812 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: -37.57,
    y: -1.058,
    className: "v"
  })), _use813 || (_use813 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 2.117,
    y: -1.853,
    className: "C"
  })), _use814 || (_use814 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: -43.92,
    y: -1.058,
    className: "Ay"
  })), _use815 || (_use815 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: -4.233,
    y: -1.853,
    className: "k"
  })), _use816 || (_use816 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: 1.588,
    y: -1.323,
    className: "y"
  })), _use817 || (_use817 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: 9.26,
    y: -2.117,
    className: "AB"
  })), _use818 || (_use818 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: -5.027,
    y: -1.323,
    className: "CP"
  })), _use819 || (_use819 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 34.661,
    y: -2.117,
    fill: "#eaeaea"
  })), _use820 || (_use820 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DE",
    x: -2.646,
    y: -2.117,
    fill: "#b3b3b3"
  })), _use821 || (_use821 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DQ",
    x: 4.498,
    y: -1.852,
    className: "V"
  })), _use822 || (_use822 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DH",
    x: -2.646,
    y: -2.117,
    className: "h"
  })), _use823 || (_use823 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DF",
    x: -9.525,
    y: -2.117,
    className: "I"
  })), _use824 || (_use824 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -29.633,
    y: -2.117,
    className: "CM"
  })), _use825 || (_use825 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 2.381,
    y: -2.117,
    className: "B"
  })), _use826 || (_use826 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -35.983,
    y: -2.117,
    className: "AV"
  })), _use827 || (_use827 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: -3.969,
    y: -2.117,
    className: "U"
  })), _use828 || (_use828 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: 2.91,
    y: -2.382,
    className: "Aw"
  })), _use829 || (_use829 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 9.525,
    y: -2.382,
    className: "D"
  })), _use830 || (_use830 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 2.911,
    y: -2.382,
    className: "h"
  })), _use831 || (_use831 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: 2.91,
    y: -2.382,
    className: "I"
  })), _use832 || (_use832 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DO",
    x: -2.646,
    y: -2.117,
    className: "BW"
  })), _use833 || (_use833 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DP",
    x: -2.646,
    y: -2.117,
    fill: "#484848"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "m38.63 44.582-.066-.066.07-.07.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.017.017.016.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.017m-.43-.165.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "AX"
  })), _use834 || (_use834 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DP",
    x: -9.525,
    y: -2.117,
    fill: "#e3e3e3"
  })), _use835 || (_use835 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -29.368,
    y: -2.382,
    className: "Z"
  })), _use836 || (_use836 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: -29.369,
    y: -2.382,
    className: "M"
  })), _use837 || (_use837 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -35.718,
    y: -2.382,
    className: "BA"
  })), _use838 || (_use838 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: -35.719,
    y: -2.382,
    className: "I"
  })), _use839 || (_use839 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: 2.911,
    y: -2.381,
    fill: "#e9e9e9"
  })), _use840 || (_use840 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: 3.175,
    y: -2.646,
    className: "BS"
  })), _use841 || (_use841 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: -3.44,
    y: -2.646,
    className: "n"
  })), _use842 || (_use842 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 3.175,
    y: -2.646,
    className: "BF"
  })), _use843 || (_use843 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DG",
    x: 3.439,
    y: -2.646,
    className: "c"
  })), _use844 || (_use844 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DT",
    x: -2.645,
    y: -2.116,
    fill: "#6b6b6b"
  })), _use845 || (_use845 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DO",
    x: -9.79,
    y: -2.381,
    className: "Av"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "m38.1 44.318-.066-.066.07-.07.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.066.066-.07.07-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m.347.083-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.017m-.43-.165.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    className: "BC"
  })), _use846 || (_use846 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DA",
    x: -15.082,
    y: -2.646,
    className: "BH"
  })), _use847 || (_use847 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Db",
    fill: "#f6eacc"
  })), _use848 || (_use848 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AJ",
    x: 8.823,
    y: -31.932,
    fill: "#f7dd9d"
  })), _use849 || (_use849 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ck",
    x: 21.167,
    y: -4.498,
    className: "AM"
  })), _use850 || (_use850 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AK",
    x: 8.559,
    y: -31.932,
    fill: "#f9cd5f"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M35.488 44.351q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.107-.025l.058-.008-.029.004-.029.004-.004.128-.004.128h-.264l.033-.099m.132.099h.165-.264.099",
    fill: "#fbc748"
  })), _use851 || (_use851 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dc",
    className: "BI"
  })), _use852 || (_use852 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AT",
    x: 15.174,
    y: -21.349,
    className: "Ak"
  })), _use853 || (_use853 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dd",
    className: "BI"
  })), _use854 || (_use854 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#De",
    fill: "#fbc748"
  })), _use855 || (_use855 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AG",
    x: 0.622,
    y: -31.932,
    className: "CQ"
  })), _use856 || (_use856 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ck",
    x: 18.785,
    y: -4.498,
    className: "AM"
  })), _use857 || (_use857 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AH",
    x: 0.357,
    y: -31.932,
    fill: "#f7dd9c"
  })), _use858 || (_use858 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Df",
    fill: "#f6eacb"
  })), _use859 || (_use859 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cz",
    x: -23.018,
    y: -2.646,
    className: "BH"
  })), _use860 || (_use860 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: -35.719,
    y: -2.646,
    className: "I"
  })), _use861 || (_use861 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -29.104,
    y: -2.646,
    className: "x"
  })), _use862 || (_use862 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: -42.069,
    y: -2.646,
    className: "M"
  })), _use863 || (_use863 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -35.454,
    y: -2.646,
    className: "AG"
  })), _use864 || (_use864 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Da",
    x: 40.481,
    y: -1.323,
    fill: "#d9d9d9"
  })), _use865 || (_use865 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: 3.175,
    y: -2.646,
    fill: "#464646"
  })), _use866 || (_use866 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -3.439,
    y: -2.646,
    fill: "#343434"
  })), _use867 || (_use867 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: -3.175,
    y: -2.911,
    className: "BC"
  })), _use868 || (_use868 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DH",
    x: 3.175,
    y: -2.911,
    className: "i"
  })), _use869 || (_use869 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DF",
    x: -3.704,
    y: -2.911,
    className: "B"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "m38.133 44.02-.033-.099h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.017.05.05.083l.033.033-.016-.017-.016-.017-.074.074-.074.074-.066-.066q-.066-.066-.099-.165m.116.182.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05",
    className: "n"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "m37.869 44.02-.033-.099.136-.004.136-.004-.004-.029-.004-.029.008.058q.008.058.025.107l.016.05-.025-.074-.025-.074.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07-.07.07-.066-.066q-.066-.066-.099-.165m.116.182.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05",
    className: "BD"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "m37.538 44.02.033-.099h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07q-.07.07-.136.07t-.141-.074l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.132-.099h-.165.264-.099",
    fill: "#f5f4f1"
  })), _use870 || (_use870 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DB",
    x: -14.287,
    y: -2.911,
    className: "CR"
  })), _use871 || (_use871 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DC",
    x: -14.288,
    y: -2.911,
    fill: "#f9d271"
  })), _use872 || (_use872 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DD",
    x: -14.288,
    y: -2.911,
    className: "CS"
  })), _use873 || (_use873 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cx",
    x: -23.812,
    y: -2.911,
    className: "CT"
  })), _use874 || (_use874 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cy",
    x: -23.813,
    y: -2.911,
    fill: "#f9d270"
  })), _use875 || (_use875 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AF",
    x: -1.759,
    y: -32.461,
    fill: "#f7e5b8"
  })), _use876 || (_use876 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cz",
    x: -23.812,
    y: -2.911,
    className: "z"
  })), _use877 || (_use877 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -35.719,
    y: -2.646,
    className: "g"
  })), _use878 || (_use878 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: -35.454,
    y: -2.911,
    className: "AR"
  })), _use879 || (_use879 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -42.069,
    y: -2.646,
    className: "w"
  })), _use880 || (_use880 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -35.189,
    y: -2.911,
    className: "y"
  })), _use881 || (_use881 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: 2.911,
    y: -2.381,
    className: "AW"
  })), _use882 || (_use882 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 42.598,
    y: -3.175,
    className: "Ac"
  })), _use883 || (_use883 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Da",
    x: 34.131,
    y: -1.587,
    className: "AD"
  })), _use884 || (_use884 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: -3.175,
    y: -2.91,
    fill: "#dedede"
  })), _use885 || (_use885 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DE",
    x: -3.969,
    y: -3.175,
    className: "AW"
  })), _use886 || (_use886 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DQ",
    x: 3.175,
    y: -2.91,
    fill: "#323232"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "m38.104 43.793.004-.128-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264v.264H38.1l.004-.128",
    fill: "#312d22"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M37.869 43.822q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.107-.025l.058-.008-.029.004-.029.004-.004.128-.004.128v-.198.066q0 .066.008.124l.008.058-.004-.029-.004-.029-.136.004-.136.004.033-.099",
    fill: "#8e7027"
  })), _use887 || (_use887 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dg",
    fill: "#efb932"
  })), _use888 || (_use888 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cq",
    x: -25.135,
    y: -3.439,
    className: "d"
  })), _use889 || (_use889 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: -39.331,
    y: -59.978,
    fill: "#f8da8f"
  })), _use890 || (_use890 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dh",
    className: "AY"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "m30.692 43.789.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.074.083.074.083.012-.012.012-.012-.025.025q-.025.025-.041.074l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074-.074-.074.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05",
    className: "l"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M30.394 43.756q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.074-.041l.025-.025-.012.012-.012.012.079.07.079.07-.066.066-.132.132-.066.066-.07-.07-.07-.07-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05",
    className: "m"
  })), _use891 || (_use891 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -41.804,
    y: -2.91,
    className: "V"
  })), _use892 || (_use892 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: -41.54,
    y: -3.175,
    className: "AF"
  })), _use893 || (_use893 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 10.848,
    y: -3.44,
    className: "BY"
  })), _use894 || (_use894 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: 10.848,
    y: -3.44,
    className: "B"
  })), _use895 || (_use895 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: -3.439,
    y: -2.646,
    fill: "#656565"
  })), _use896 || (_use896 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 36.248,
    y: -3.44,
    className: "c"
  })), _use897 || (_use897 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DO",
    x: -3.969,
    y: -3.175,
    className: "At"
  })), _use898 || (_use898 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DP",
    x: -3.969,
    y: -3.175,
    className: "AD"
  })), _use899 || (_use899 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Di",
    fill: "#292722"
  })), _use900 || (_use900 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dj",
    fill: "#907227"
  })), _use901 || (_use901 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cr",
    x: -12.436,
    y: -3.704,
    fill: "#f0b82d"
  })), _use902 || (_use902 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cq",
    x: -25.664,
    y: -3.704,
    className: "Bq"
  })), _use903 || (_use903 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dk",
    className: "CU"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "m30.924 43.491.033-.099h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.141.074h-.066.1-.033q-.033 0-.058.025l-.025.025.012-.012.012-.012-.074-.083-.074-.083-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099",
    fill: "#d9d7d1"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M30.626 43.524q0-.066.074-.141l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033-.033.099q-.033.099-.099.165l-.066.066-.079-.07-.079-.07-.012.012-.012.012.025-.025q.025-.025.025-.058v-.033.1-.066m.116.215.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033",
    className: "AS"
  })), _use904 || (_use904 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -41.539,
    y: -3.175,
    className: "a"
  })), _use905 || (_use905 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: -41.54,
    y: -3.175,
    className: "K"
  })), _use906 || (_use906 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: 4.498,
    y: -3.705,
    className: "W"
  })), _use907 || (_use907 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 11.113,
    y: -3.705,
    className: "BB"
  })), _use908 || (_use908 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: -2.117,
    y: -3.705,
    className: "M"
  })), _use909 || (_use909 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 4.498,
    y: -3.705,
    className: "Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M63.203 43.226q.033-.099.132-.132t.165.033l.066.066-.066.066-.132.132-.066.066-.074-.074-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.231-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05",
    className: "Y"
  })), _use910 || (_use910 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DG",
    x: 2.116,
    y: -3.705,
    className: "J"
  })), _use911 || (_use911 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DT",
    x: -3.968,
    y: -3.175,
    className: "BB"
  })), _use912 || (_use912 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dl",
    fill: "#614f24"
  })), _use913 || (_use913 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dm",
    fill: "#dfab2b"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "m30.952 43.264-.004-.128-.029-.004-.029-.004.058.008q.058.008.107.025l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099h-.264l-.004-.128",
    fill: "#e2af2e"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "m30.725 43.226-.033-.099h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.004.128.004.128-.099-.033q-.099-.033-.132-.132",
    fill: "#635125"
  })), _use914 || (_use914 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Da",
    x: -3.969,
    y: -2.117,
    className: "AU"
  })), _use915 || (_use915 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: -2.116,
    y: -3.705,
    className: "BE"
  })), _use916 || (_use916 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: 4.498,
    y: -3.704,
    className: "BU"
  })), _use917 || (_use917 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: 4.763,
    y: -3.969,
    fill: "#5a5a5a"
  })), _use918 || (_use918 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -2.116,
    y: -3.704,
    className: "Az"
  })), _use919 || (_use919 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: -1.852,
    y: -3.969,
    className: "BZ"
  })), _use920 || (_use920 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DE",
    x: -5.027,
    y: -3.969,
    className: "BF"
  })), _use921 || (_use921 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DF",
    x: -5.027,
    y: -3.969,
    className: "AB"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "m39.39 42.962.033-.099.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.091-.041l.041-.025-.021.012-.021.012.074.074.074.074.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132t-.174-.041l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099",
    className: "CV"
  })), _use922 || (_use922 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 14.645,
    y: -35.107,
    fill: "#a48028"
  })), _use923 || (_use923 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: -5.463,
    y: -35.107,
    fill: "#9d7b28"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "m30.13 43.028-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.074-.074.074-.074-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.174.041-.099-.033-.132-.132",
    className: "CV"
  })), _use924 || (_use924 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: -41.539,
    y: -3.175,
    className: "Ay"
  })), _use925 || (_use925 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: -1.852,
    y: -3.969,
    className: "k"
  })), _use926 || (_use926 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DR",
    x: 4.498,
    y: -3.704,
    fill: "#d3d3d3"
  })), _use927 || (_use927 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: 4.762,
    y: -3.969,
    className: "Ba"
  })), _use928 || (_use928 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -1.852,
    y: -3.969,
    fill: "#393939"
  })), _use929 || (_use929 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: -1.853,
    y: -3.969,
    fill: "#ccc"
  })), _use930 || (_use930 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DO",
    x: -5.028,
    y: -3.969,
    className: "Au"
  })), _use931 || (_use931 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DP",
    x: -5.027,
    y: -3.969,
    className: "a"
  })), _use932 || (_use932 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dn",
    fill: "#373122"
  })), _use933 || (_use933 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Do",
    fill: "#cfa02b"
  })), _use934 || (_use934 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dp",
    fill: "#d0a02a"
  })), _use935 || (_use935 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dq",
    fill: "#383223"
  })), _use936 || (_use936 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -33.602,
    y: -4.234,
    className: "AV"
  })), _use937 || (_use937 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: -1.587,
    y: -4.234,
    className: "U"
  })), _use938 || (_use938 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: 4.498,
    y: -3.704,
    fill: "#b6b6b6"
  })), _use939 || (_use939 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 44.186,
    y: -4.498,
    className: "C"
  })), _use940 || (_use940 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DR",
    x: -1.852,
    y: -3.968,
    fill: "#4e4e4e"
  })), _use941 || (_use941 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 37.571,
    y: -4.498,
    className: "CN"
  })), _use942 || (_use942 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DS",
    x: -5.027,
    y: -3.968,
    className: "BG"
  })), _use943 || (_use943 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DT",
    x: -5.027,
    y: -3.968,
    className: "AX"
  })), _use944 || (_use944 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -19.05,
    y: -4.498,
    fill: "#423923"
  })), _use945 || (_use945 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: -25.929,
    y: -4.498,
    className: "CW"
  })), _use946 || (_use946 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DE",
    x: -18.521,
    y: -4.498,
    fill: "#ddaa2c"
  })), _use947 || (_use947 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DH",
    x: -11.906,
    y: -4.498,
    fill: "#3e3723"
  })), _use948 || (_use948 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -33.337,
    y: -4.498,
    className: "BA"
  })), _use949 || (_use949 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: -33.338,
    y: -4.498,
    className: "I"
  })), _use950 || (_use950 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DA",
    x: 27.252,
    y: -4.763,
    className: "BJ"
  })), _use951 || (_use951 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Db",
    x: 42.333,
    y: -2.117,
    fill: "#c8dbee"
  })), _use952 || (_use952 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AJ",
    x: 51.157,
    y: -34.049,
    fill: "#94bde5"
  })), _use953 || (_use953 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ck",
    x: 63.5,
    y: -6.615,
    className: "AZ"
  })), _use954 || (_use954 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dr",
    fill: "#5095da"
  })), _use955 || (_use955 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CF",
    x: 56.885,
    y: -14.288,
    fill: "#3787d7"
  })), _use956 || (_use956 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dc",
    x: 42.333,
    y: -2.117,
    className: "BK"
  })), _use957 || (_use957 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AT",
    x: 57.507,
    y: -23.466,
    className: "CX"
  })), _use958 || (_use958 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dd",
    x: 42.333,
    y: -2.117,
    className: "BK"
  })), _use959 || (_use959 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#F",
    x: 53.538,
    y: -65.534,
    fill: "#3787d7"
  })), _use960 || (_use960 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ds",
    className: "CY"
  })), _use961 || (_use961 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dt",
    className: "AZ"
  })), _use962 || (_use962 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AH",
    x: 42.69,
    y: -34.049,
    fill: "#93bce5"
  })), _use963 || (_use963 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Df",
    x: 42.334,
    y: -2.117,
    fill: "#c7dbee"
  })), _use964 || (_use964 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cz",
    x: 19.315,
    y: -4.763,
    className: "BJ"
  })), _use965 || (_use965 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 12.436,
    y: -4.763,
    className: "i"
  })), _use966 || (_use966 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: 12.435,
    y: -4.763,
    className: "B"
  })), _use967 || (_use967 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: -1.852,
    y: -3.969,
    fill: "#6e6e6e"
  })), _use968 || (_use968 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 37.836,
    y: -4.763,
    fill: "#eee"
  })), _use969 || (_use969 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DV",
    x: -5.027,
    y: -3.969,
    className: "W"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "m42.367 42.168-.033-.099.099.033q.099.033.165.099l.066.066-.066.066-.066.066-.066-.066q-.066-.066-.099-.165m.116.182.05.05.016.017.017.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033",
    className: "D"
  })), _use970 || (_use970 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DX",
    x: -5.027,
    y: -3.969,
    className: "M"
  })), _use971 || (_use971 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -18.785,
    y: -4.763,
    fill: "#413923"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M39.919 42.168q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.091-.041l.041-.025-.021.012-.021.012.07.07.07.07-.066.066-.132.132-.066.066-.07-.07-.07-.07-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05m-10.6.022-.066-.066.07-.07.07-.07-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07-.07.07-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#e8b22c"
  })), _use972 || (_use972 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DH",
    x: -12.171,
    y: -4.763,
    fill: "#423923"
  })), _use973 || (_use973 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: -39.688,
    y: -4.763,
    className: "M"
  })), _use974 || (_use974 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -33.072,
    y: -4.763,
    className: "AG"
  })), _use975 || (_use975 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DA",
    x: 28.045,
    y: -5.028,
    className: "j"
  })), _use976 || (_use976 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DB",
    x: 28.046,
    y: -5.027,
    className: "BL"
  })), _use977 || (_use977 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DC",
    x: 28.045,
    y: -5.027,
    fill: "#64a1de"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M79.111 41.937q0-.132.099-.165t.174.041l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.264v-.132m-.033.132h.231-.264.033m.198 0h.165-.264.099",
    className: "CZ"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "m75.109 41.97-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.174-.041.099.033.099.165v.132h-.264l-.033-.099m0 .099h.231-.264.033m.198 0h.165-.264.099",
    className: "Ca"
  })), _use978 || (_use978 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cy",
    x: 18.52,
    y: -5.027,
    fill: "#63a1de"
  })), _use979 || (_use979 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AF",
    x: 40.574,
    y: -34.578,
    fill: "#b2ceea"
  })), _use980 || (_use980 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cz",
    x: 18.521,
    y: -5.027,
    className: "j"
  })), _use981 || (_use981 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: 6.085,
    y: -5.027,
    className: "J"
  })), _use982 || (_use982 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: 6.085,
    y: -5.027,
    className: "CO"
  })), _use983 || (_use983 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: -0.53,
    y: -5.027,
    className: "L"
  })), _use984 || (_use984 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 6.086,
    y: -5.027,
    className: "i"
  })), _use985 || (_use985 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: 6.085,
    y: -5.028,
    className: "Y"
  })), _use986 || (_use986 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DY",
    x: -5.027,
    y: -3.968,
    className: "BT"
  })), _use987 || (_use987 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DZ",
    x: -5.028,
    y: -3.968,
    className: "C"
  })), _use988 || (_use988 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Du",
    fill: "#373122"
  })), _use989 || (_use989 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dv",
    fill: "#dfab2b"
  })), _use990 || (_use990 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dw",
    className: "CW"
  })), _use991 || (_use991 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dx",
    fill: "#383223"
  })), _use992 || (_use992 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -39.687,
    y: -4.762,
    className: "w"
  })), _use993 || (_use993 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -32.808,
    y: -5.027,
    className: "y"
  })), _use994 || (_use994 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dy",
    fill: "#e6ecf3"
  })), _use995 || (_use995 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    x: -18.521,
    y: -2.91,
    fill: "#87b5e3"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M79.905 41.672q0-.132.099-.165t.174.041l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132m-.033.132h.231-.264",
    className: "Cb"
  })), _use996 || (_use996 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cq",
    x: 17.198,
    y: -5.556,
    className: "BM"
  })), _use997 || (_use997 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 3.003,
    y: -62.095,
    className: "Cc"
  })), _use998 || (_use998 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dh",
    x: 42.333,
    y: -2.117,
    fill: "#e5ecf3"
  })), _use999 || (_use999 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: 6.086,
    y: -5.027,
    className: "BG"
  })), _use1000 || (_use1000 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: 6.085,
    y: -5.027,
    className: "AC"
  })), _use1001 || (_use1001 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -0.529,
    y: -5.027,
    className: "V"
  })), _use1002 || (_use1002 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: -0.265,
    y: -5.292,
    className: "v"
  })), _use1003 || (_use1003 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DO",
    x: -6.35,
    y: -5.027,
    className: "N"
  })), _use1004 || (_use1004 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DP",
    x: -6.35,
    y: -5.027,
    fill: "#404040"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "m40.713 41.639.033-.099.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.041.174-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.091.041l-.041.025.021-.012.021-.012-.074-.074-.074-.074-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099",
    className: "CV"
  })), _use1005 || (_use1005 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dz",
    fill: "#cfa02b"
  })), _use1006 || (_use1006 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DW",
    x: -18.256,
    y: -4.498,
    fill: "#d1a12a"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M28.807 41.705q-.033-.099.041-.174l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.074.074-.074.074.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132",
    fill: "#282621"
  })), _use1007 || (_use1007 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -39.423,
    y: -5.027,
    className: "V"
  })), _use1008 || (_use1008 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: -39.158,
    y: -5.292,
    className: "AF"
  })), _use1009 || (_use1009 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Di",
    x: 42.334,
    y: -2.117,
    fill: "#edf0f3"
  })), _use1010 || (_use1010 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dj",
    x: 42.333,
    y: -2.117,
    className: "Cc"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M80.434 41.407q0-.132.099-.165t.174.041l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008H80.5h.198-.264v-.132",
    fill: "#247cd3"
  })), _use1011 || (_use1011 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cq",
    x: 16.669,
    y: -5.821,
    fill: "#247cd4"
  })), _use1012 || (_use1012 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dk",
    x: 42.334,
    y: -2.117,
    className: "Cd"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M73.29 41.407v-.132h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.174.041-.099-.033-.099-.165",
    className: "Ce"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "m72.496 41.407.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.079.079.079.079.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074-.074-.074.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05",
    className: "u"
  })), _use1013 || (_use1013 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 45.509,
    y: -5.557,
    className: "a"
  })), _use1014 || (_use1014 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Da",
    x: 37.042,
    y: -3.969,
    className: "Ax"
  })), _use1015 || (_use1015 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: -0.265,
    y: -5.292,
    className: "K"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "m41.54 41.407-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.079-.078.079-.079-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05",
    fill: "#e8e8e8"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "m41.308 41.374-.033-.099.099.033q.099.033.165.099l.066.066-.07.07-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066q-.066-.066-.099-.165m.314.116-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033",
    fill: "#5f5f5f"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "m40.978 41.374.033-.099h.264l.033.099q.033.099.099.165t.099.165q.033.099.132.132t.132.132.132.132.132.132.132.132q.099.033.169-.037l.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.132.132q.066.066.099.165t.132.132.132.132.132.132q.099.033.165-.033l.066-.066.066.066.132.132.132.132q.066.066.099.165t.132.132.132.132.132.132.132.132.132.132q.099.033.165-.033l.066-.066.066.066.132.132.132.132q.066.066.099.165t.132.132.132.132.132.132.132.132.132.132q.099.033.165-.033l.066-.066.066.066.132.132.132.132q.066.066.099.165t.132.132.132.132.132.132.132.132.132.132q.099.033.169-.037l.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.132.132q.066.066.099.165t.132.132.132.132.132.132q.099.033.165-.033l.066-.066.066.066.132.132.132.132q.066.066.099.165t.132.132.132.132l.033.099-.033.099q-.033.099-.132.132t-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099.041.174l.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099-.099.033q-.099.033-.132.132l-.033.099h-.132q-.132 0-.165.099t.041.174l.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.132q-.132 0-.165.099t-.099.099q-.066 0-.132.066l-.066.066-.066-.066-.132-.132-.132-.132q-.066-.066-.099-.165t-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132q-.099-.033-.169.037l-.07.07.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.016.074.025.074.025-.099-.033-.099-.033-.033-.099q-.033-.099-.099-.165t-.099-.165q-.033-.099-.132-.132t-.132-.132-.132-.132q-.099-.033-.165.033l-.066.066-.066-.066-.132-.132q-.066-.066-.174-.091l-.107-.025.008-.141q.008-.141-.091-.174t-.132-.132-.132-.132-.132-.132-.132-.132q-.099-.033-.165.033l-.066.066-.066-.066-.132-.132-.132-.132q-.066-.066-.099-.165t-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132q-.099-.033-.165.033l-.066.066-.066-.066-.132-.132-.132-.132q-.066-.066-.099-.165t-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132q-.099-.033-.169.037l-.07.07.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.017.074.025.074.025-.099-.033-.099-.033-.033-.099q-.033-.099-.099-.165t-.099-.165q-.033-.099-.132-.132t-.132-.132-.132-.132q-.099-.033-.165.033l-.066.066-.066-.066-.132-.132-.132-.132-.132-.132-.132-.132q-.066-.066-.099-.165t-.132-.132-.132-.132l-.033-.099v-.264l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041.099-.033.099-.165v-.132l.099-.033q.099-.033.132-.132l.033-.099.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041.099-.033.132-.132t.099-.165l.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132q.066-.066.165-.099t.132-.132q.033-.099-.041-.174l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m-1.67 3.621.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m2.381 1.852.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m1.323 1.058.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m1.323 1.058.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m2.381 1.852.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m1.819-3.737-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05m-2.381-1.852-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05m-1.323-1.058-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05m-1.323-1.058-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05",
    className: "X"
  })), _use1016 || (_use1016 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 16.232,
    y: -36.695,
    fill: "#9e7c28"
  })), _use1017 || (_use1017 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: -7.051,
    y: -36.695,
    fill: "#a27f28"
  })), _use1018 || (_use1018 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -39.158,
    y: -5.292,
    className: "a"
  })), _use1019 || (_use1019 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: -39.159,
    y: -5.292,
    className: "K"
  })), _use1020 || (_use1020 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dl",
    x: 42.333,
    y: -2.116,
    fill: "#b4d0eb"
  })), _use1021 || (_use1021 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dm",
    x: 42.333,
    y: -2.117,
    className: "AA"
  })), _use1022 || (_use1022 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#De",
    x: 39.159,
    y: -3.175,
    fill: "#3486d6"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "m73.029 41.147-.004-.136h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.004.128.004.128h-.264.198-.066q-.066 0-.124.008l-.058.008.029-.004.029-.004-.004-.136m.161.128h.165-.264.099",
    className: "BL"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M72.728 41.11q.033-.099.165-.099h.132l.004.136.004.136.029-.004.029-.004-.058.008q-.058.008-.107.025l-.05.017.074-.025.074-.025-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.079-.079-.079-.079-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099",
    fill: "#b1b1b1"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "m72.463 41.11.033-.099.145.012.145.012.021-.012.021-.012-.041.025q-.041.025-.058.074l-.016.05.025-.074.025-.074-.033.099q-.033.099-.099.165l-.066.066-.074-.074-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033",
    className: "C"
  })), _use1023 || (_use1023 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: -0.529,
    y: -5.027,
    className: "AX"
  })), _use1024 || (_use1024 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 39.159,
    y: -5.821,
    className: "AT"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M41.275 41.143v-.132h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.079.079-.079.079.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132",
    className: "Aw"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M41.011 41.143v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.128-.004.128-.004v.264h-.264v-.132m.265-.033v-.165.264-.099",
    fill: "#a7956a"
  })), _use1025 || (_use1025 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EA",
    fill: "#655225"
  })), _use1026 || (_use1026 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: -38.894,
    y: -5.556,
    className: "AU"
  })), _use1027 || (_use1027 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 0.265,
    y: -5.821,
    className: "BE"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "m81.724 40.845.033-.099.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.091-.041l.041-.025-.021.012-.021.012.079.078.079.079.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132t-.174-.041l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099",
    className: "Cf"
  })), _use1028 || (_use1028 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 56.978,
    y: -37.224,
    className: "AZ"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "m72.773 40.891-.012-.145.099.033q.099.033.132.132l.033.099h-.264.198-.066q-.066 0-.107.025l-.041.025.021-.012.021-.012-.012-.145",
    fill: "#1d5286"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "m72.463 40.911-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.079-.079.079-.078-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.099.033.099.033.012.145.012.145-.145-.012-.145-.012-.033-.099",
    fill: "#212326"
  })), _use1029 || (_use1029 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 7.409,
    y: -6.086,
    className: "CO"
  })), _use1030 || (_use1030 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: 7.408,
    y: -6.086,
    className: "J"
  })), _use1031 || (_use1031 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EB",
    className: "Cg"
  })), _use1032 || (_use1032 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EC",
    className: "Ch"
  })), _use1033 || (_use1033 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z",
    x: -7.581,
    y: -37.489,
    className: "CW"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M28.278 40.911q-.033-.099.041-.174l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099",
    fill: "#2a2822"
  })), _use1034 || (_use1034 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DR",
    x: -38.894,
    y: -5.556,
    className: "AC"
  })), _use1035 || (_use1035 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 0.529,
    y: -6.086,
    className: "AT"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "m82.021 40.614.132-.132.066-.066.07.07.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.079-.079-.079-.079-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066m.215-.215-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#dfe9f2"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M81.79 40.647q.033-.099.099-.165l.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07.07.07-.066.066q-.066.066-.165.099l-.099.033.033-.099m.248-.05.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05",
    fill: "#4690d9"
  })), _use1036 || (_use1036 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dp",
    x: 42.333,
    y: -2.116,
    fill: "#1a65af"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "m72.199 40.647-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.07-.07.07-.07.066.066.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.079.079-.079.079.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132m.149-.182-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05",
    fill: "#212a33"
  })), _use1037 || (_use1037 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: 1.058,
    y: -6.35,
    className: "w"
  })), _use1038 || (_use1038 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 7.673,
    y: -6.35,
    className: "BD"
  })), _use1039 || (_use1039 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bv",
    x: -18.786,
    y: -17.462,
    fill: "#f8da8f"
  })), _use1040 || (_use1040 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: -7.58,
    y: -37.488,
    fill: "#947528"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M28.046 40.614q.066-.066.165-.099l.099-.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132l.033.099q.033.099.132.132l.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174.033.099.132.132t.165.099l.132.132.132.132.132.132.132.132.132.132.132.132.132.132q.066.066.099.165t.132.132q.099.033.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.074.141 0 .066-.099.099t-.132.132q-.033.099-.099.165l-.132.132-.132.132-.132.132-.132.132-.066.066-.066-.066q-.066-.066-.165-.033t-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165l-.132.132-.132.132-.132.132-.132.132-.066.066-.066-.066q-.066-.066-.165-.033t-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165l-.132.132-.132.132-.132.132-.132.132-.066.066-.066-.066q-.066-.066-.165-.033t-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165l-.132.132-.132.132-.132.132-.132.132-.066.066-.066-.066q-.066-.066-.165-.033t-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165t-.099.165l-.033.099h-.264l-.033-.099-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132l-.033-.099q-.033-.099-.132-.132l-.099-.033-.033-.099-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132l-.033-.099q-.033-.099-.099-.165l-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132q-.066-.066-.099-.165t-.132-.132q-.099-.033-.174.041l-.074.074.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033-.033-.099-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.074-.074q.074-.074.074-.141 0-.066.066-.132l.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165l.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165l.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165l.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165l.132-.132m-1.902 1.637-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033-.016.017m-2.381 2.117-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033-.016.017m-2.381 2.117-.017.017-.05.05-.05.05.033-.033.066-.066.033-.033-.017.017M19.001 48.6l-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033-.017.016m3.539 2.282.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m2.381-2.117.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m2.381-2.117.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m2.381-2.117.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033",
    className: "X"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "m27.782 40.614.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.074.074.074.074.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07-.07-.07.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05",
    className: "AV"
  })), _use1041 || (_use1041 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 0.794,
    y: -6.35,
    className: "U"
  })), _use1042 || (_use1042 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: 15.611,
    y: -5.821,
    fill: "#d4e2f0"
  })), _use1043 || (_use1043 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: 16.139,
    y: -6.35,
    className: "Aa"
  })), _use1044 || (_use1044 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DE",
    x: 23.813,
    y: -6.615,
    fill: "#1a6ab9"
  })), _use1045 || (_use1045 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DT",
    x: 24.342,
    y: -6.085,
    fill: "#202d39"
  })), _use1046 || (_use1046 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: 1.059,
    y: -6.35,
    fill: "#2e2e2e"
  })), _use1047 || (_use1047 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: 1.323,
    y: -6.615,
    fill: "#bbb"
  })), _use1048 || (_use1048 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ED",
    className: "AY"
  })), _use1049 || (_use1049 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    className: "Am"
  })), _use1050 || (_use1050 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EF",
    fill: "#f1b92d"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "m28.013 40.316.033-.099-.025.074-.025.074.016-.05q.016-.05.025-.107l.008-.058-.004.029-.004.029.132.008.132.008-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.091.041l-.041.025.021-.012.021-.012-.074-.074-.074-.074-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099",
    fill: "#837e73"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M27.749 40.316q.033-.099.165-.099h.132l-.033.099q-.033.099-.099.165l-.066.066-.074-.074-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033",
    className: "I"
  })), _use1051 || (_use1051 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EG",
    fill: "#d4e2ef"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M82.253 40.051q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.091-.041l.041-.025-.021.012-.021.012.07.07.07.07-.066.066-.132.132-.066.066-.074-.074-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05",
    fill: "#2c81d5"
  })), _use1052 || (_use1052 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DO",
    x: 23.812,
    y: -6.615,
    fill: "#1a6fc3"
  })), _use1053 || (_use1053 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EH",
    fill: "#202e3c"
  })), _use1054 || (_use1054 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Da",
    x: 38.629,
    y: -5.292,
    fill: "#434343"
  })), _use1055 || (_use1055 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: 1.322,
    y: -6.615,
    className: "t"
  })), _use1056 || (_use1056 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    x: -30.864,
    y: -66.328,
    fill: "#f8da91"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M28.046 40.084v-.132l.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.025.107l.008.058-.004-.029-.004-.029-.132-.008-.132-.008-.004.029-.004.029.008-.058q.008-.058.008-.124v-.066.198-.132m0-.165v.231-.264",
    fill: "#f8da8e"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "m82.815 39.82.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.079.079.079.079.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.091.041l-.041.025.021-.012.021-.012-.07-.07-.07-.07.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05",
    fill: "#dfe9f2"
  })), _use1057 || (_use1057 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dv",
    x: 42.333,
    y: -2.117,
    className: "AA"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "m71.702 39.82-.066-.066.07-.07.07-.07-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#1a6bbc"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "m71.405 39.853-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.079-.079.079-.079-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.066.066-.07.07-.07.07.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033",
    fill: "#212a33"
  })), _use1058 || (_use1058 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: 1.059,
    y: -6.35,
    className: "CP"
  })), _use1059 || (_use1059 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 40.746,
    y: -7.144,
    fill: "#eaeaea"
  })), _use1060 || (_use1060 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EI",
    fill: "#f5f4f1"
  })), _use1061 || (_use1061 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    x: 0.265,
    y: -0.529,
    fill: "#fac43d"
  })), _use1062 || (_use1062 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EJ",
    className: "d"
  })), _use1063 || (_use1063 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EK",
    className: "z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "m83.046 39.522.033-.099.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.041.174-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.079-.079-.079-.079-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099",
    className: "Cf"
  })), _use1064 || (_use1064 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dz",
    x: 42.333,
    y: -2.117,
    fill: "#4690d9"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "m71.471 39.522-.033-.099.099.033q.099.033.165.099l.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.07.07-.07.07-.066-.066q-.066-.066-.099-.165m.116.182.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05",
    fill: "#1a65b0"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M71.14 39.588q-.033-.099.041-.174l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.079.078-.079.079.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132",
    fill: "#212427"
  })), _use1065 || (_use1065 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 8.996,
    y: -7.409,
    className: "h"
  })), _use1066 || (_use1066 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: 8.996,
    y: -7.409,
    className: "I"
  })), _use1067 || (_use1067 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    x: 17.555,
    y: -39.076,
    className: "CR"
  })), _use1068 || (_use1068 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    x: -8.374,
    y: -39.076,
    className: "Ci"
  })), _use1069 || (_use1069 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 58.566,
    y: -38.811,
    fill: "#77ade1"
  })), _use1070 || (_use1070 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: 35.282,
    y: -38.811,
    fill: "#1c5389"
  })), _use1071 || (_use1071 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ct",
    x: 2.645,
    y: -7.673,
    className: "n"
  })), _use1072 || (_use1072 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 9.261,
    y: -7.673,
    className: "BF"
  })), _use1073 || (_use1073 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CG",
    x: -19.05,
    y: -16.933,
    fill: "#f9d271"
  })), _use1074 || (_use1074 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CH",
    x: -19.05,
    y: -16.933,
    fill: "#f9d16e"
  })), _use1075 || (_use1075 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bv",
    x: 23.283,
    y: -19.05,
    fill: "#b4d0eb"
  })), _use1076 || (_use1076 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bw",
    x: 23.284,
    y: -19.05,
    fill: "#1f3c58"
  })), _use1077 || (_use1077 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DJ",
    x: 2.646,
    y: -7.673,
    fill: "#343434"
  })), _use1078 || (_use1078 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: 2.91,
    y: -7.938,
    className: "BC"
  })), _use1079 || (_use1079 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EI",
    x: 0.264,
    y: -0.794,
    className: "BH"
  })), _use1080 || (_use1080 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EL",
    className: "CT"
  })), _use1081 || (_use1081 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EJ",
    x: -0.264,
    y: -0.794,
    className: "Cj"
  })), _use1082 || (_use1082 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EK",
    x: -0.265,
    y: -0.794,
    className: "BN"
  })), _use1083 || (_use1083 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ED",
    x: 42.069,
    y: -1.587,
    className: "Ck"
  })), _use1084 || (_use1084 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    x: 42.069,
    y: -1.588,
    className: "Cl"
  })), _use1085 || (_use1085 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EM",
    fill: "#1a6bbc"
  })), _use1086 || (_use1086 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    fill: "#212528"
  })), _use1087 || (_use1087 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DR",
    x: 2.646,
    y: -7.672,
    className: "AD"
  })), _use1088 || (_use1088 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DK",
    x: 2.91,
    y: -7.938,
    fill: "#dedede"
  })), _use1089 || (_use1089 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AM",
    x: 3.267,
    y: -34.578,
    fill: "#f6eacd"
  })), _use1090 || (_use1090 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AL",
    x: -23.72,
    y: -34.578,
    className: "Cm"
  })), _use1091 || (_use1091 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    x: 11.205,
    y: -67.916,
    className: "Cc"
  })), _use1092 || (_use1092 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N",
    x: -1.76,
    y: -66.592,
    fill: "#1d4e7e"
  })), _use1093 || (_use1093 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: 2.646,
    y: -7.673,
    fill: "#656565"
  })), _use1094 || (_use1094 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DI",
    x: 42.334,
    y: -8.467,
    className: "c"
  })), _use1095 || (_use1095 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: 18.084,
    y: -41.193,
    fill: "#f7dd9d"
  })), _use1096 || (_use1096 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    x: -8.903,
    y: -41.193,
    fill: "#f7dd9b"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M83.873 38.232V38.1v.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132",
    className: "Cn"
  })), _use1097 || (_use1097 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    x: 42.334,
    y: -2.117,
    className: "Co"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M70.644 38.232V38.1h.132q.132 0 .165.099t-.041.174l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132",
    fill: "#1a72ca"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "m70.346 38.265-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.074l-.025-.025.012.012.012.012.079-.087.079-.087-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.132q-.132 0-.165-.099",
    fill: "#21282f"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M70.148 38.265q.033-.099.099-.099t.099.099q.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132l.033.099q.033.099.132.132l.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174.033.099.132.132t.132.132.132.132q.099.033.165.099l.132.132.132.132.132.132q.066.066.099.165t.132.132.132.132l.033.099-.033.099q-.033.099-.132.132t-.132.132-.132.132-.132.132q-.033.099-.099.165l-.132.132-.132.132-.066.066-.066-.066q-.066-.066-.165-.033t-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165l-.132.132-.132.132-.132.132-.132.132-.066.066-.066-.066q-.066-.066-.165-.033t-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165l-.132.132-.132.132-.132.132-.132.132-.066.066-.066-.066q-.066-.066-.165-.033t-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165l-.132.132-.132.132-.066.066-.066-.066q-.066-.066-.165-.033t-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165l-.132.132-.132.132-.066.066-.066-.066q-.066-.066-.165-.033t-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165l-.132.132-.132.132-.132.132-.132.132-.066.066-.066-.066q-.066-.066-.165-.033t-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165l-.132.132-.132.132-.132.132-.132.132-.066.066-.066-.066q-.066-.066-.165-.033t-.132.132-.132.132-.132.132-.132.132-.132.132q-.033.099-.099.165l-.132.132q-.066.066-.165.099l-.099.033v-.132q0-.132-.132-.132h-.132l-.033-.099-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132l-.033-.099q-.033-.099-.132-.132l-.099-.033-.033-.099-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074q.074-.074.041-.174-.033-.099-.132-.132t-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132q-.099-.033-.099-.099t.099-.099q.099-.033.132-.132t.099-.165l.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165l.132-.132.132-.132.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165l.132-.132.132-.132.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165l.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165l.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165l.132-.132.132-.132.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165l.132-.132.132-.132.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132.132-.132.132-.132.132-.132.132-.132q.033-.099.099-.165l.132-.132.132-.132.066-.066.066.066q.066.066.165.033t.132-.132m-.347.017-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033-.016.017m-1.323 1.058-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033-.016.017m-1.588 1.323-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033-.016.017m-1.588 1.323-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033-.016.017m-1.588 1.323-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033-.016.017m-1.323 1.058-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033-.016.017m-1.588 1.323-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033-.016.017m-1.588 1.323-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033-.016.017m3.01 2.811.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m1.588-1.323.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m1.588-1.323.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m1.588-1.323.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m1.323-1.058.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017M69.9 43.48l.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m1.588-1.323.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033",
    className: "X"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "m69.85 38.232.132-.132.066-.066.07.079.07.079.012-.012.012-.012-.025.025q-.025.025-.041.074l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132t-.165-.033l-.066-.066.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "M"
  })), _use1098 || (_use1098 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: 10.584,
    y: -8.732,
    className: "Z"
  })), _use1099 || (_use1099 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cw",
    x: 10.583,
    y: -8.732,
    className: "Y"
  })), _use1100 || (_use1100 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EO",
    fill: "#f9d57e"
  })), _use1101 || (_use1101 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EO",
    x: -14.552,
    className: "Al"
  })), _use1102 || (_use1102 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    x: 11.469,
    y: -68.445,
    fill: "#87b5e3"
  })), _use1103 || (_use1103 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 4.855,
    y: -46.484,
    fill: "#1d4d7c"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M70.115 37.968q.066-.066.165-.099l.099-.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.079.087-.079.087.012.012.012.012-.025-.025q-.025-.025-.058-.025h-.033.1-.132.1-.033q-.033 0-.058.025l-.025.025.012-.012.012-.012-.07-.079-.07-.078.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05",
    className: "Az"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "m69.85 37.968.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.05-.066l.016-.033-.008.017-.008.017.079.07.079.07.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.066.198.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033",
    className: "BZ"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M42.069 37.968v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.128-.004.128-.004v.264h-.264v-.132m0 .033v.165-.264.099m.265.132v-.231.264-.033m0-.198v-.165.264-.099",
    className: "CQ"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M27.517 37.968v-.132l.128.004.128.004-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.264v-.132m0 .033v.165-.264.099m.265.132v-.231.264-.033m-.265-.331v.231-.264",
    fill: "#facd5c"
  })), _use1104 || (_use1104 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EI",
    x: 42.333,
    y: -2.117,
    className: "j"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M83.84 37.67q.033-.099.165-.099h.132v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.041-.174m.298 0v-.165.264-.099",
    className: "Cb"
  })), _use1105 || (_use1105 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EF",
    x: 42.069,
    y: -2.646,
    fill: "#1b71c6"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M70.049 37.703q0-.066.074-.141l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.264l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.091.041l-.041.025.021-.012.021-.012-.079-.07-.079-.07-.008.017-.008.017.016-.033q.016-.033.016-.066v-.033.1-.066m.331-.033v-.165.264-.099",
    fill: "#c8cacc"
  })), _use1106 || (_use1106 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EC",
    x: 1.058,
    y: -3.175,
    className: "BO"
  })), _use1107 || (_use1107 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CM",
    x: -19.05,
    y: -17.198,
    className: "Ab"
  })), _use1108 || (_use1108 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    x: 59.888,
    y: -41.192,
    className: "BL"
  })), _use1109 || (_use1109 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    x: 33.959,
    y: -41.192,
    className: "Cp"
  })), _use1110 || (_use1110 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EP",
    className: "d"
  })), _use1111 || (_use1111 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EQ",
    className: "BI"
  })), _use1112 || (_use1112 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CG",
    x: 23.283,
    y: -19.05,
    fill: "#64a1de"
  })), _use1113 || (_use1113 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CH",
    x: 23.283,
    y: -19.05,
    fill: "#609fdd"
  })), _use1114 || (_use1114 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EI",
    x: 42.597,
    y: -2.911,
    className: "BJ"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M84.105 36.876q.033-.099.165-.099h.132v.264l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.041-.174m.298.198v-.231.264-.033m0-.198v-.165.264-.099",
    className: "Ca"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M70.115 36.909v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132m0 .033v.165-.264.099m0-.198v.231-.264",
    className: "Cq"
  })), _use1115 || (_use1115 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EK",
    x: 42.068,
    y: -2.91,
    className: "BP"
  })), _use1116 || (_use1116 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: -30.335,
    y: -68.71,
    fill: "#fbc233"
  })), _use1117 || (_use1117 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: -44.887,
    y: -68.71,
    className: "Ak"
  })), _use1118 || (_use1118 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AM",
    x: 45.6,
    y: -36.695,
    fill: "#c9dcee"
  })), _use1119 || (_use1119 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AL",
    x: 18.613,
    y: -36.694,
    className: "Cr"
  })), _use1120 || (_use1120 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ER",
    className: "d"
  })), _use1121 || (_use1121 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EB",
    x: -13.758,
    y: -4.233,
    className: "BI"
  })), _use1122 || (_use1122 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: 60.417,
    y: -43.31,
    fill: "#94bde5"
  })), _use1123 || (_use1123 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    x: 33.43,
    y: -43.31,
    fill: "#92bce5"
  })), _use1124 || (_use1124 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X",
    x: -23.985,
    y: -49.659,
    className: "BO"
  })), _use1125 || (_use1125 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y",
    x: -26.101,
    y: -49.66,
    className: "Ab"
  })), _use1126 || (_use1126 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CB",
    x: 63.5,
    y: -21.166,
    fill: "#72a9e0"
  })), _use1127 || (_use1127 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    x: 33.43,
    y: -43.309,
    className: "Cs"
  })), _use1128 || (_use1128 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    x: 5.649,
    y: -43.574,
    className: "CQ"
  })), _use1129 || (_use1129 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: 3.532,
    y: -43.574,
    fill: "#facd5c"
  })), _use1130 || (_use1130 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CE",
    x: 63.5,
    y: -20.902,
    className: "CY"
  })), _use1131 || (_use1131 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CM",
    x: 23.283,
    y: -19.05,
    fill: "#4d94db"
  })), _use1132 || (_use1132 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CB",
    x: 21.167,
    y: -21.431,
    className: "AM"
  })), _use1133 || (_use1133 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CB",
    x: 6.615,
    y: -21.431,
    fill: "#f9d47b"
  })), _use1134 || (_use1134 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CF",
    x: 63.499,
    y: -20.902,
    className: "AA"
  })), _use1135 || (_use1135 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EQ",
    x: 42.333,
    y: -1.852,
    className: "Aa"
  })), _use1136 || (_use1136 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    x: 5.649,
    y: -43.838,
    fill: "#f7dd9c"
  })), _use1137 || (_use1137 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 3.532,
    y: -43.838,
    className: "Ct"
  })), _use1138 || (_use1138 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EP",
    x: 42.333,
    y: -2.117,
    className: "BM"
  })), _use1139 || (_use1139 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 46.394,
    y: -72.413,
    className: "BK"
  })), _use1140 || (_use1140 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: -23.985,
    y: -50.188,
    fill: "#f6eacc"
  })), _use1141 || (_use1141 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: -26.101,
    y: -50.188,
    fill: "#f6e9c9"
  })), _use1142 || (_use1142 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EJ",
    x: 14.023,
    y: -4.763,
    className: "BH"
  })), _use1143 || (_use1143 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EK",
    x: 14.022,
    y: -4.763,
    className: "CT"
  })), _use1144 || (_use1144 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EI",
    x: -14.023,
    y: -4.763,
    className: "Cj"
  })), _use1145 || (_use1145 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EL",
    x: -14.287,
    y: -3.969,
    className: "BN"
  })), _use1146 || (_use1146 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: 11.998,
    y: -70.826,
    fill: "#1f7ad3"
  })), _use1147 || (_use1147 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: -2.554,
    y: -70.826,
    className: "CX"
  })), _use1148 || (_use1148 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    x: 5.649,
    y: -43.838,
    fill: "#f9d270"
  })), _use1149 || (_use1149 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    x: 3.532,
    y: -43.838,
    fill: "#f9d16d"
  })), _use1150 || (_use1150 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ER",
    x: 42.333,
    y: -2.117,
    className: "BM"
  })), _use1151 || (_use1151 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 46.394,
    y: -73.207,
    className: "BK"
  })), _use1152 || (_use1152 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CH",
    x: -5.027,
    y: -21.696,
    fill: "#f7e5b8"
  })), _use1153 || (_use1153 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CG",
    x: -33.073,
    y: -21.696,
    fill: "#f7e4b4"
  })), _use1154 || (_use1154 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CK",
    x: 63.499,
    y: -21.431,
    className: "AA"
  })), _use1155 || (_use1155 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EB",
    x: 28.575,
    y: -6.614,
    className: "Aa"
  })), _use1156 || (_use1156 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EJ",
    x: 13.759,
    y: -5.556,
    className: "z"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    x: -29.104,
    y: -4.498
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ED",
    x: -13.494,
    y: -6.085
  }))), _use1157 || (_use1157 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EL",
    x: -14.022,
    y: -4.762,
    className: "z"
  })), _use1158 || (_use1158 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CL",
    x: 63.5,
    y: -21.431,
    className: "CY"
  })), _use1159 || (_use1159 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y",
    x: 16.232,
    y: -52.041,
    fill: "#4d94db"
  })), _use1160 || (_use1160 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N",
    x: -30.864,
    y: -71.09,
    fill: "#f8da90"
  })), _use1161 || (_use1161 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    x: -44.358,
    y: -72.414,
    fill: "#f8d98c"
  })), _use1162 || (_use1162 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CB",
    x: 63.5,
    y: -23.548,
    className: "AZ"
  })), _use1163 || (_use1163 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: 45.865,
    y: -45.956,
    fill: "#6ea7df"
  })), _use1164 || (_use1164 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EM",
    x: -29.369,
    y: -5.028,
    className: "AY"
  })), _use1165 || (_use1165 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    x: -29.369,
    y: -5.027,
    className: "Am"
  })), _use1166 || (_use1166 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ED",
    x: -13.229,
    y: -6.615,
    className: "Bq"
  })), _use1167 || (_use1167 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    x: -13.229,
    y: -6.615,
    className: "AY"
  })), _use1168 || (_use1168 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    x: 47.982,
    y: -45.955,
    fill: "#93bce5"
  })), _use1169 || (_use1169 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 45.865,
    y: -45.955,
    className: "Cu"
  })), _use1170 || (_use1170 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: -24.25,
    y: -50.982,
    className: "CU"
  })), _use1171 || (_use1171 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: -25.837,
    y: -50.982,
    fill: "#f8d88a"
  })), _use1172 || (_use1172 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 18.348,
    y: -52.305,
    fill: "#c8dbee"
  })), _use1173 || (_use1173 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 16.232,
    y: -52.305,
    fill: "#c4d9ed"
  })), _use1174 || (_use1174 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EF",
    x: 12.964,
    y: -7.144,
    className: "Cg"
  })), _use1175 || (_use1175 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EA",
    x: 12.436,
    y: -7.938,
    className: "Ch"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M28.575 33.205v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.124-.008.124-.008.004-.029.004-.029-.008.058q-.008.058-.025.107l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033v-.132",
    className: "Ab"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M28.278 33.172q.033-.099.165-.099h.132v.264l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.041-.174",
    fill: "#f5f3ed"
  })), _use1176 || (_use1176 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EJ",
    x: 56.356,
    y: -6.879,
    className: "BJ"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M84.105 32.974q-.033-.099.041-.174l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099m.298.132v-.231.264-.033m0-.198v-.165.264-.099",
    className: "Ca"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M70.115 32.941v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132m0 .033v.165-.264.099m0-.198v.231-.264",
    className: "Cq"
  })), _use1177 || (_use1177 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EL",
    x: 28.046,
    y: -6.085,
    className: "BP"
  })), _use1178 || (_use1178 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z",
    x: 4.855,
    y: -45.426,
    className: "CR"
  })), _use1179 || (_use1179 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AA",
    x: 4.325,
    y: -45.426,
    className: "Ci"
  })), _use1180 || (_use1180 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    x: 47.982,
    y: -45.955,
    fill: "#63a1de"
  })), _use1181 || (_use1181 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    x: 45.865,
    y: -45.955,
    fill: "#5f9fdd"
  })), _use1182 || (_use1182 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: 4.855,
    y: -45.426,
    fill: "#f9d681"
  })), _use1183 || (_use1183 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 4.326,
    y: -45.426,
    className: "AM"
  })), _use1184 || (_use1184 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CH",
    x: 37.306,
    y: -23.812,
    fill: "#b2ceea"
  })), _use1185 || (_use1185 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CG",
    x: 9.26,
    y: -23.812,
    fill: "#aeccea"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "m40.713 32.445-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.074-.074.074-.074-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132t-.041.174l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033-.033-.099",
    fill: "#f5f3ef"
  })), _use1186 || (_use1186 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dp",
    x: 10.319,
    y: -10.318,
    fill: "#faca54"
  })), _use1187 || (_use1187 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Do",
    x: -10.318,
    y: -10.318,
    fill: "#faca52"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M28.807 32.378q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.091-.041l.041-.025-.021.012-.021.012.074.074.074.074.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099-.033.099-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.041-.174",
    fill: "#f5f3ee"
  })), _use1188 || (_use1188 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EJ",
    x: 56.092,
    y: -7.673,
    className: "j"
  })), _use1189 || (_use1189 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    x: 13.229,
    y: -6.615,
    className: "BM"
  })), _use1190 || (_use1190 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ED",
    x: 28.84,
    y: -8.202,
    fill: "#297fd4"
  })), _use1191 || (_use1191 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EL",
    x: 28.311,
    y: -6.879,
    className: "j"
  })), _use1192 || (_use1192 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dq",
    x: 10.584,
    y: -10.583,
    fill: "#f6efde"
  })), _use1193 || (_use1193 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EH",
    x: -31.485,
    y: -7.937,
    fill: "#fac643"
  })), _use1194 || (_use1194 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EG",
    x: -53.181,
    y: -7.937,
    className: "Ab"
  })), _use1195 || (_use1195 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dn",
    x: -10.583,
    y: -10.583,
    fill: "#f6efe0"
  })), _use1196 || (_use1196 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N",
    x: 11.469,
    y: -73.207,
    fill: "#86b5e3"
  })), _use1197 || (_use1197 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    x: -2.024,
    y: -74.531,
    fill: "#82b3e3"
  })), _use1198 || (_use1198 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DH",
    x: -1.323,
    y: -15.082,
    fill: "#f5edd7"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "m39.919 31.915-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.07-.07.07-.07.066.066.132.132.066.066-.07.07-.07.07.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.017m-.232-.232-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05",
    fill: "#fac43e"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "m29.634 31.882.132-.132.066-.066.07.07.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.091.041l-.041.025.021-.012.021-.012-.07-.07-.07-.07.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    fill: "#fac43d"
  })), _use1199 || (_use1199 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -29.633,
    y: -15.082,
    fill: "#f6edd6"
  })), _use1200 || (_use1200 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EM",
    x: 12.964,
    y: -7.144,
    className: "Cn"
  })), _use1201 || (_use1201 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    x: 12.965,
    y: -7.144,
    className: "Co"
  })), _use1202 || (_use1202 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ED",
    x: 29.104,
    y: -8.731,
    fill: "#247cd4"
  })), _use1203 || (_use1203 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    x: 29.104,
    y: -8.731,
    fill: "#e5ecf3"
  })), _use1204 || (_use1204 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DH",
    x: -1.588,
    y: -15.346,
    fill: "#f6edd7"
  })), _use1205 || (_use1205 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DT",
    x: -7.937,
    y: -14.816,
    className: "Ab"
  })), _use1206 || (_use1206 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: -36.777,
    y: -14.552,
    fill: "#fbc849"
  })), _use1207 || (_use1207 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cv",
    x: -29.368,
    y: -15.346,
    fill: "#f5edd9"
  })), _use1208 || (_use1208 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N",
    x: 11.205,
    y: -73.736,
    className: "Cd"
  })), _use1209 || (_use1209 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    x: -1.76,
    y: -75.06,
    fill: "#7fb1e2"
  })), _use1210 || (_use1210 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dx",
    x: 10.583,
    y: -10.584,
    fill: "#f6f0e1"
  })), _use1211 || (_use1211 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DW",
    x: -7.938,
    y: -14.817,
    fill: "#faca53"
  })), _use1212 || (_use1212 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dz",
    x: -10.319,
    y: -10.319,
    fill: "#faca52"
  })), _use1213 || (_use1213 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Du",
    x: -10.584,
    y: -10.584,
    fill: "#f6efdf"
  })), _use1214 || (_use1214 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EM",
    x: 12.7,
    y: -7.673,
    className: "Ck"
  })), _use1215 || (_use1215 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    x: 12.7,
    y: -7.673,
    className: "Cl"
  })), _use1216 || (_use1216 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ED",
    x: 29.369,
    y: -9.26,
    className: "Aa"
  })), _use1217 || (_use1217 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    x: 29.369,
    y: -9.26,
    className: "Ce"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "m39.39 31.122-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.174-.041.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.074.074-.074.074.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.017.074.025.074.025-.099-.033-.099-.033-.033-.099",
    fill: "#f5f3ed"
  })), _use1218 || (_use1218 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: 3.268,
    y: -47.013,
    fill: "#f8d376"
  })), _use1219 || (_use1219 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 5.914,
    y: -47.013,
    fill: "#f9d784"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M30.13 31.056q.033-.099.132-.132t.174.041l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.091.041l-.041.025.021-.012.021-.012-.074-.074-.074-.074-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099",
    fill: "#f5f3ee"
  })), _use1220 || (_use1220 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 17.819,
    y: -53.628,
    className: "BL"
  })), _use1221 || (_use1221 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 16.761,
    y: -53.628,
    className: "Cp"
  })), _use1222 || (_use1222 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AE",
    x: 4.59,
    y: -45.691,
    fill: "#f7e4b7"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "m38.663 30.791-.033-.099h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.008.124.008.124.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132",
    className: "Ch"
  })), _use1223 || (_use1223 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dl",
    x: -7.937,
    y: -12.435,
    fill: "#fac644"
  })), _use1224 || (_use1224 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dm",
    x: -7.938,
    y: -12.436,
    fill: "#f7e4b6"
  })), _use1225 || (_use1225 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: 47.189,
    y: -47.543,
    fill: "#76abe1"
  })), _use1226 || (_use1226 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 46.659,
    y: -47.542,
    className: "AZ"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "m38.596 30.593-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.174-.041.099.033.099.165v.132h-.264l-.033-.099",
    className: "Cg"
  })), _use1227 || (_use1227 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ES",
    fill: "#f8d98c"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "Am"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dh",
    x: 6.614,
    y: -13.23
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dy",
    x: -48.948,
    y: -11.113
  }))), _use1228 || (_use1228 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ET",
    fill: "#f8d88a"
  })), _use1229 || (_use1229 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dg",
    x: -6.614,
    y: -13.23,
    fill: "#f5f2eb"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "m83.046 30.328-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.079-.079.079-.079-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132t-.041.174l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033-.033-.099",
    className: "Cf"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "m82.815 30.295-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07.07-.07.066.066q.066.066.099.165l.033.099-.099-.033q-.099-.033-.165-.099m.116-.149-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05",
    fill: "#448fd9"
  })), _use1230 || (_use1230 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    x: 17.026,
    y: -53.892,
    fill: "#418dd8"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M71.14 30.262q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.079.079.079.078.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099-.033.099-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.041-.174",
    fill: "#eef1f4"
  })), _use1231 || (_use1231 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cq",
    x: -19.05,
    y: -16.933,
    className: "AY"
  })), _use1232 || (_use1232 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: -33.245,
    y: -73.472,
    fill: "#f8da8e"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dh",
    x: 6.085,
    y: -13.494
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dy",
    x: -48.419,
    y: -11.377
  }))), _use1233 || (_use1233 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    x: -66.94,
    y: -14.287,
    className: "CU"
  })), _use1234 || (_use1234 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cr",
    x: -19.05,
    y: -16.933,
    fill: "#f6f1e5"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "m82.815 30.03-.066-.066.07-.07.07-.07-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.079.078-.079.078.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m-.083-.083.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033",
    fill: "#dce6f1"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "m82.517 30.063-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074.074-.074.066.066.132.132.066.066-.07.07-.07.07.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.017m-.232-.232-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05",
    fill: "#3184d6"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "m71.702 30.03.132-.132.066-.066.074.074.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.091.041l-.041.025.021-.012.021-.012-.07-.07-.07-.07.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033",
    className: "Aa"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M71.405 29.997q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.091-.041l.041-.025-.021.012-.021.012.07.07.07.07-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.079-.079-.079-.078-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.314.017.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05",
    fill: "#dee7f1"
  })), _use1235 || (_use1235 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cx",
    x: -19.05,
    y: -16.934,
    className: "z"
  })), _use1236 || (_use1236 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cy",
    x: -19.05,
    y: -16.934,
    fill: "#f7e4b6"
  })), _use1237 || (_use1237 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AF",
    x: 3.003,
    y: -46.484,
    fill: "#f9d16e"
  })), _use1238 || (_use1238 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cz",
    x: -19.05,
    y: -16.934,
    className: "Cj"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M33.073 30.03v-.132H34q.132 0 .232-.033l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041l.099-.033h.528l.099.033q.099.033.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.232.033h.927v.132q0 .132.099.165t.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.232.033h.132v.132q0 .132.099.165t.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033.033.099q.033.099.132.132t.232.033h.132l.033.099q.033.099.132.132l.099.033.033.099q.033.099.099.165l.132.132.132.132q.066.066.099.165t.132.132q.099.033.165.099l.132.132.132.132q.066.066.165.099l.099.033.033.099q.033.099.132.132l.099.033v.132q0 .132.033.232.033.099.132.132l.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132v.132q0 .132.033.232l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132v.927q0 .132.033.232l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174l.033.099v.529l-.033.099q-.033.099.041.174l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.033.232v.927h-.132q-.132 0-.165.099t.041.174l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.033.232v.132h-.132q-.132 0-.165.099t.041.174l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.132q-.132 0-.165.099t.041.174l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099-.099.033q-.099.033-.132.132t-.033.232v.132l-.099.033q-.099.033-.132.132l-.033.099-.099.033q-.099.033-.165.099l-.132.132-.132.132q-.066.066-.165.099t-.132.132q-.033.099-.099.165l-.132.132-.132.132q-.066.066-.099.165l-.033.099-.099.033q-.099.033-.132.132l-.033.099h-.132q-.132 0-.232.033-.099.033-.132.132l-.033.099-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132h-.132q-.132 0-.232.033l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132h-.927q-.132 0-.232.033l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.174-.041l-.099.033h-.529l-.099-.033q-.099-.033-.174.041l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.232-.033h-.927v-.132q0-.132-.099-.165t-.174.041l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.232-.033h-.132v-.132q0-.132-.099-.165t-.174.041l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132q0-.132-.099-.165t-.174.041l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033-.033-.099q-.033-.099-.132-.132t-.232-.033h-.132l-.033-.099q-.033-.099-.132-.132l-.099-.033-.033-.099q-.033-.099-.099-.165l-.132-.132-.132-.132q-.066-.066-.099-.165t-.132-.132q-.099-.033-.165-.099l-.132-.132-.132-.132q-.066-.066-.165-.099l-.099-.033-.033-.099q-.033-.099-.132-.132l-.099-.033v-.132q0-.132-.033-.232-.033-.099-.132-.132l-.099-.033-.033-.099-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132l-.033-.099-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132v-.132q0-.132-.033-.232l-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132v-.927q0-.132-.033-.232l-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.041-.174l-.033-.099v-.529l.033-.099q.033-.099-.041-.174l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099q.033-.099.033-.232v-.927h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099q.033-.099.033-.232v-.132h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099.099-.033q.099-.033.132-.132t.033-.232v-.132l.099-.033q.099-.033.132-.132l.033-.099.099-.033q.099-.033.165-.099l.132-.132.132-.132q.066-.066.165-.099t.132-.132q.033-.099.099-.165l.132-.132.132-.132q.066-.066.099-.165l.033-.099.099-.033q.099-.033.132-.132l.033-.099h.132q.132 0 .232-.033.099-.033.132-.132l.033-.099.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041.099-.033.099-.165v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041.099-.033.099-.165v-.132h.132q.132 0 .232-.033l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041.099-.033.099-.165",
    className: "BR"
  })), _use1239 || (_use1239 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DA",
    x: -19.05,
    y: -16.934,
    fill: "#fac237"
  })), _use1240 || (_use1240 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DB",
    x: -19.05,
    y: -16.934,
    fill: "#f9d16d"
  })), _use1241 || (_use1241 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DC",
    x: -19.05,
    y: -16.934,
    className: "Ci"
  })), _use1242 || (_use1242 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DD",
    x: -19.05,
    y: -16.934,
    className: "z"
  })), _use1243 || (_use1243 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dw",
    x: 53.181,
    y: -12.171,
    fill: "#d4e2ef"
  })), _use1244 || (_use1244 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DP",
    x: 34.396,
    y: -16.933,
    fill: "#2c81d5"
  })), _use1245 || (_use1245 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Da",
    x: 43.127,
    y: -15.61,
    className: "Cb"
  })), _use1246 || (_use1246 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dv",
    x: 31.485,
    y: -12.171,
    fill: "#d3e2f0"
  })), _use1247 || (_use1247 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cx",
    x: -19.844,
    y: -17.198,
    className: "BN"
  })), _use1248 || (_use1248 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    x: -26.63,
    y: -52.834,
    className: "Cm"
  })), _use1249 || (_use1249 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AG",
    x: 3.003,
    y: -46.484,
    className: "Ct"
  })), _use1250 || (_use1250 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ck",
    x: 21.167,
    y: -19.05,
    className: "Al"
  })), _use1251 || (_use1251 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AH",
    x: 2.738,
    y: -46.484,
    fill: "#facd5d"
  })), _use1252 || (_use1252 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AI",
    x: 2.739,
    y: -46.484,
    className: "BO"
  })), _use1253 || (_use1253 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DL",
    x: -19.315,
    y: -16.933,
    className: "CS"
  })), _use1254 || (_use1254 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 11.469,
    y: -77.969,
    className: "Ak"
  })), _use1255 || (_use1255 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    x: 11.205,
    y: -77.969,
    fill: "#fbc131"
  })), _use1256 || (_use1256 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DM",
    x: -18.786,
    y: -16.933,
    className: "CS"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "m34.127 29.762.004-.128h.264l-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.107.025l-.058.008.029-.004.029-.004.004-.128m.103-.128h-.165.264-.099",
    className: "BO"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M33.867 29.766v-.132h.264l-.004.128-.004.128.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132m-.033.132h.231-.264.033m.331-.265h-.231.264-.033m-.198 0h-.165.264-.099",
    fill: "#facd5d"
  })), _use1257 || (_use1257 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ck",
    x: 18.785,
    y: -19.05,
    className: "Al"
  })), _use1258 || (_use1258 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AK",
    x: 6.178,
    y: -46.484,
    className: "Ct"
  })), _use1259 || (_use1259 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DN",
    x: -19.05,
    y: -16.933,
    className: "Cm"
  })), _use1260 || (_use1260 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DD",
    x: -18.256,
    y: -17.198,
    className: "BN"
  })), _use1261 || (_use1261 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DE",
    x: 33.867,
    y: -17.463,
    fill: "#d4e2f0"
  })), _use1262 || (_use1262 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DT",
    x: 34.396,
    y: -16.933,
    fill: "#3486d6"
  })), _use1263 || (_use1263 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DU",
    x: 5.557,
    y: -16.669,
    fill: "#3888d7"
  })), _use1264 || (_use1264 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cu",
    x: 6.35,
    y: -17.463,
    fill: "#d6e3f0"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "m82.021 29.237-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.079-.078.079-.079-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07-.07.07-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05",
    fill: "#dfe8f1"
  })), _use1265 || (_use1265 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DW",
    x: 34.396,
    y: -16.934,
    fill: "#438ed9"
  })), _use1266 || (_use1266 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dz",
    x: 32.014,
    y: -12.435,
    fill: "#418dd8"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M72.199 29.203q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.079.079.079.079.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.066.066-.07-.07-.07-.07-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033",
    fill: "#dde7f1"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "m81.724 29.005-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.174-.041.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.079.079-.079.079.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.017.074.025.074.025-.099-.033-.099-.033-.033-.099",
    className: "Ce"
  })), _use1267 || (_use1267 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AB",
    x: 45.601,
    y: -49.13,
    fill: "#69a4de"
  })), _use1268 || (_use1268 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AC",
    x: 48.247,
    y: -49.13,
    fill: "#78ade1"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M72.463 28.939q.033-.099.132-.132t.174.041l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.091.041l-.041.025.021-.012.021-.012-.079-.079-.079-.079-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099",
    fill: "#eef1f4"
  })), _use1269 || (_use1269 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ES",
    x: 42.862,
    y: -1.852,
    fill: "#b1ceea"
  })), _use1270 || (_use1270 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dh",
    x: 49.477,
    y: -15.082,
    className: "Cl"
  })), _use1271 || (_use1271 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dy",
    x: -7.144,
    y: -12.965,
    fill: "#3285d6"
  })), _use1272 || (_use1272 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ET",
    x: 41.804,
    y: -1.853,
    fill: "#b0cdea"
  })), _use1273 || (_use1273 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cq",
    x: 23.813,
    y: -18.785,
    className: "Ck"
  })), _use1274 || (_use1274 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 9.617,
    y: -75.324,
    fill: "#81b2e2"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "Co"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dh",
    x: 48.948,
    y: -15.346
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dy",
    x: -6.615,
    y: -13.229
  }))), _use1275 || (_use1275 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    x: -25.136,
    y: -16.139,
    fill: "#7fb1e2"
  })), _use1276 || (_use1276 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cr",
    x: 22.754,
    y: -18.785,
    fill: "#eaeff3"
  })), _use1277 || (_use1277 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cq",
    x: 23.284,
    y: -19.05,
    className: "Cn"
  })), _use1278 || (_use1278 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R",
    x: 9.088,
    y: -75.589,
    fill: "#84b4e3"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "#297fd4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dh",
    x: 48.419,
    y: -15.611
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dy",
    x: -6.086,
    y: -13.494
  }))), _use1279 || (_use1279 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BB",
    x: -24.606,
    y: -16.404,
    className: "Cd"
  })), _use1280 || (_use1280 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cr",
    x: 23.283,
    y: -19.05,
    fill: "#e3ebf2"
  })), _use1281 || (_use1281 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cx",
    x: 23.283,
    y: -19.05,
    className: "j"
  })), _use1282 || (_use1282 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cy",
    x: 23.283,
    y: -19.05,
    fill: "#b0cdea"
  })), _use1283 || (_use1283 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AF",
    x: 45.336,
    y: -48.6,
    fill: "#609fdd"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M79.111 27.914v-.132h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.174.041-.099-.033-.099-.165m.298-.132h-.231.264-.033m-.198 0h-.165.264-.099",
    className: "Cq"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M75.407 27.914v-.132H76.466l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041l.099-.033h.529l.099.033q.099.033.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033H79.116v.132q0 .132.099.165t.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.232.033h.132v.132q0 .132.099.165t.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.174-.041l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033.033.099q.033.099.132.132l.099.033.033.099q.033.099.099.165l.132.132.132.132q.066.066.099.165t.132.132.132.132.132.132q.099.033.165.099t.165.099l.099.033.033.099q.033.099.132.132l.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132v.132q0 .132.033.232l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174.033.099.165.099h.132V34.126l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.041.174l.033.099v.529l-.033.099q-.033.099.041.174l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099V36.772h-.132q-.132 0-.165.099t.041.174l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.033.232v.132h-.132q-.132 0-.165.099t.041.174l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.132q-.132 0-.165.099t.041.174l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.132q-.132 0-.165.099t.041.174l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099-.099.033q-.099.033-.132.132l-.033.099-.099.033q-.099.033-.165.099l-.132.132-.132.132q-.066.066-.165.099t-.132.132-.132.132-.132.132q-.033.099-.099.165t-.099.165l-.033.099-.099.033q-.099.033-.132.132l-.033.099h-.133q-.132 0-.232.033-.099.033-.132.132l-.033.099-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132h-.132q-.132 0-.232.033l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.174-.041-.099.033-.099.165v.132H78.058l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.174-.041l-.099.033h-.529l-.099-.033q-.099-.033-.174.041l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033H75.408v-.132q0-.132-.099-.165t-.174.041l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.232-.033h-.132v-.132q0-.132-.099-.165t-.174.041l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132q0-.132-.099-.165t-.174.041l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033-.033-.099q-.033-.099-.132-.132t-.232-.033h-.132l-.033-.099q-.033-.099-.132-.132l-.099-.033-.033-.099q-.033-.099-.099-.165l-.132-.132-.132-.132q-.066-.066-.099-.165t-.132-.132-.132-.132-.132-.132q-.099-.033-.165-.099t-.165-.099l-.099-.033-.033-.099q-.033-.099-.132-.132l-.099-.033-.033-.099-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132l-.033-.099-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132l-.033-.099-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132v-.132q0-.132-.033-.232l-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.041-.174-.033-.099-.165-.099h-.132v-.662q0-.132-.033-.232l-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.041-.174l-.033-.099v-1.057l.033-.099q.033-.099-.041-.174l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099q.033-.099.033-.232v-.662h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099q.033-.099.033-.232v-.132h.132q.132 0 .165-.099T70.634 32l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.041-.174l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099.033-.099.099-.033q.099-.033.132-.132l.033-.099.099-.033q.099-.033.165-.099t.165-.099q.099-.033.132-.132t.132-.132.132-.132q.033-.099.099-.165l.132-.132.132-.132q.066-.066.099-.165l.033-.099.099-.033q.099-.033.132-.132l.033-.099.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041.099-.033.099-.165v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041.099-.033.099-.165v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041.099-.033.099-.165v-.132h.132q.132 0 .232-.033l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.174.041.099-.033.099-.165m-5.292 5.126v.231-.264.033m0 3.638v.165-.264.099m5.259 5.391h.231-.264.033m3.638 0h.165-.264.099m.794-.265h.165-.264.099m4.333-4.2v-.231.264-.033m.265-.794v-.231.264-.033m0-3.638v-.165.264-.099m-5.259-5.391h-.231.264-.033m-3.638 0h-.165.264-.099",
    fill: "#1976d2"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "m75.109 27.881.033-.099h.264v.132q0 .132-.099.165t-.174-.041l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.331-.099h-.231.264-.033m-.198 0h-.165.264-.099",
    fill: "#247cd3"
  })), _use1284 || (_use1284 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DB",
    x: 23.283,
    y: -19.05,
    fill: "#5f9fdd"
  })), _use1285 || (_use1285 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DC",
    x: 23.283,
    y: -19.05,
    className: "Cp"
  })), _use1286 || (_use1286 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DD",
    x: 23.283,
    y: -19.05,
    className: "j"
  })), _use1287 || (_use1287 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cx",
    x: 22.49,
    y: -19.315,
    className: "BP"
  })), _use1288 || (_use1288 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    x: 15.703,
    y: -54.951,
    className: "Cr"
  })), _use1289 || (_use1289 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AG",
    x: 45.337,
    y: -48.601,
    className: "Cu"
  })), _use1290 || (_use1290 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ck",
    x: 63.5,
    y: -21.167,
    className: "Cs"
  })), _use1291 || (_use1291 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dr",
    y: -14.552,
    fill: "#4e95db"
  })), _use1292 || (_use1292 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CK",
    x: 56.885,
    y: -28.046,
    className: "AA"
  })), _use1293 || (_use1293 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DL",
    x: 23.018,
    y: -19.05,
    className: "CZ"
  })), _use1294 || (_use1294 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AT",
    x: 57.507,
    y: -38.018,
    className: "CX"
  })), _use1295 || (_use1295 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DM",
    x: 23.547,
    y: -19.05,
    className: "CZ"
  })), _use1296 || (_use1296 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CS",
    x: 29.898,
    y: -25.4,
    className: "AA"
  })), _use1297 || (_use1297 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ds",
    y: -14.552,
    fill: "#4e95db"
  })), _use1298 || (_use1298 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dt",
    y: -14.552,
    className: "Cs"
  })), _use1299 || (_use1299 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AK",
    x: 48.511,
    y: -48.601,
    className: "Cu"
  })), _use1300 || (_use1300 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DN",
    x: 23.284,
    y: -19.05,
    className: "Cr"
  })), _use1301 || (_use1301 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DD",
    x: 24.077,
    y: -19.315,
    className: "BP"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .132V0H135.168V135.168H126.852 127 0V126.852 127 .412M35.058 120.65h.132l.099-.033q.099-.033.165-.099t.165-.099l.099-.033H36.906q.132 0 .232-.033.099-.033.132-.132t.165-.099h.66l.099-.033q.099-.033.165-.099t.165-.099l.099-.033h.528l.099-.033q.099-.033.165-.099t.165-.099l.099-.033h.264l.099-.033q.099-.033.165-.099t.165-.099l.099-.033h.264l.099-.033q.099-.033.165-.099t.165-.099l.099-.033h.132q.132 0 .232-.033.099-.033.132-.132t.165-.099h.132l.099-.033q.099-.033.165-.099t.165-.099l.099-.033h.132q.132 0 .232-.033.099-.033.132-.132t.165-.099h.132l.099-.033q.099-.033.165-.099t.165-.099l.099-.033.099-.033q.099-.033.165-.099t.165-.099l.099-.033.099-.033q.099-.033.165-.099t.165-.099l.099-.033.099-.033q.099-.033.165-.099t.165-.099l.198-.066q.099-.033.132-.132t.132-.132q.099-.033.165-.099t.165-.099l.099-.033.099-.033q.099-.033.165-.099l.132-.132.132-.132q.066-.066.165-.099l.099-.033.099-.033q.099-.033.165-.099l.132-.132.132-.132q.066-.066.165-.099l.099-.033.099-.033q.099-.033.165-.099l.132-.132.132-.132.132-.132.132-.132q.066-.066.165-.099l.099-.033.099-.033q.099-.033.132-.132t.132-.132q.099-.033.165-.099l.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132q.066-.066.099-.165l.033-.099.033-.099q.033-.099.099-.165l.132-.132.132-.132q.066-.066.099-.165t.132-.132.132-.132l.066-.198q.033-.099.099-.165l.132-.132.132-.132q.066-.066.099-.165l.033-.099.033-.099q.033-.099.099-.165l.132-.132.132-.132q.066-.066.099-.165l.066-.198q.033-.099.099-.165t.099-.165l.033-.099.033-.099q.033-.099.099-.165l.132-.132.132-.132q.066-.066.099-.165l.033-.099.033-.099q.033-.099.099-.165t.099-.165l.033-.099H126.531l.099-.033q.099-.033.165-.099t.165-.099l.099-.033h.264l.099-.033q.099-.033.165-.099t.165-.099l.099-.033.099-.033q.099-.033.165-.099t.165-.099l.099-.033.099-.033q.099-.033.165-.099l.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132q.066-.066.099-.165l.033-.099.033-.099q.033-.099.099-.165t.099-.165l.033-.099.033-.099q.033-.099.099-.165t.099-.165l.033-.099v-.264l.033-.099q.033-.099.099-.165t.099-.165l.033-.099V19.507l-.033-.099q-.033-.099-.099-.165t-.099-.165l-.033-.099v-.264l-.033-.099q-.033-.099-.099-.165t-.099-.165l-.033-.099-.033-.099q-.033-.099-.099-.165t-.099-.165l-.033-.099-.033-.099q-.033-.099-.099-.165l-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132-.132q-.066-.066-.165-.099l-.099-.033-.099-.033q-.099-.033-.165-.099t-.165-.099l-.099-.033-.099-.033q-.099-.033-.165-.099t-.165-.099l-.099-.033H127l-.099-.033q-.099-.033-.165-.099t-.165-.099l-.099-.033H17.305l-.099.033q-.099.033-.165.099t-.165.099l-.099.033h-.264l-.099.033q-.099.033-.165.099t-.165.099l-.099.033-.099.033q-.099.033-.165.099t-.165.099l-.099.033-.099.033q-.099.033-.165.099l-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132q-.066.066-.099.165l-.033.099-.033.099q-.033.099-.099.165t-.099.165l-.033.099-.033.099q-.033.099-.099.165t-.099.165l-.033.099v.264l-.033.099q-.033.099-.099.165t-.099.165l-.033.099V48.65h-.792l-.099.033q-.099.033-.165.099t-.165.099l-.099.033h-.132q-.132 0-.232.033-.099.033-.132.132t-.165.099h-.132l-.099.033q-.099.033-.165.099t-.165.099l-.198.066q-.099.033-.132.132t-.132.132q-.099.033-.165.099t-.165.099l-.099.033-.099.033q-.099.033-.165.099l-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132q-.066.066-.099.165l-.033.099-.033.099q-.033.099-.099.165l-.132.132-.132.132q-.066.066-.099.165l-.033.099-.033.099q-.033.099-.099.165t-.099.165l-.033.099v.132q0 .132-.099.165t-.132.132q-.033.099-.033.232v.132l-.033.099q-.033.099-.099.165t-.099.165l-.033.099V57.892l.033.099q.033.099.099.165t.099.165l.033.099v.132q0 .132.033.232.033.099.132.132t.099.165v.132l.033.099q.033.099.099.165t.099.165l.033.099.033.099q.033.099.099.165l.132.132.132.132q.066.066.099.165l.066.198q.033.099.132.132t.132.132q.033.099.099.165l.132.132.132.132.132.132.132.132.132.132q.066.066.165.099t.132.132.132.132l.198.066q.099.033.165.099l.132.132.132.132q.066.066.165.099l.099.033.099.033q.099.033.165.099t.165.099l.099.033h.132q.132 0 .165.099t.132.132q.099.033.232.033h.264q.132 0 .165.099t.132.132q.099.033.232.033h.66v9.672q0 .132-.132.132t-.232.033q-.099.033-.132.132l-.066.198q-.033.099-.099.165l-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132-.132.132q-.066.066-.099.165l-.033.099-.033.099q-.033.099-.099.165l-.132.132-.132.132-.132.132-.132.132q-.066.066-.099.165l-.033.099-.033.099q-.033.099-.099.165l-.132.132-.132.132q-.066.066-.099.165l-.033.099-.033.099q-.033.099-.099.165l-.132.132-.132.132q-.066.066-.099.165l-.033.099-.033.099q-.033.099-.099.165t-.099.165l-.033.099-.033.099q-.033.099-.099.165t-.099.165q-.033.099-.132.132t-.132.132l-.066.198q-.033.099-.099.165t-.099.165l-.033.099v.132q0 .132-.099.165t-.132.132l-.066.198q-.033.099-.099.165t-.099.165l-.033.099-.033.099q-.033.099-.099.165t-.099.165l-.033.099v.264l-.033.099q-.033.099-.099.165t-.099.165l-.033.099-.033.099q-.033.099-.099.165t-.099.165l-.033.099v.264l-.033.099q-.033.099-.099.165t-.099.165l-.033.099v.264l-.033.099q-.033.099-.099.165t-.099.165l-.033.099v.264l-.033.099q-.033.099-.099.165t-.099.165l-.033.099v.528l-.033.099q-.033.099-.099.165t-.099.165l-.033.099v.792l-.033.099q-.033.099-.099.165t-.099.165l-.033.099v1.056l-.033.099q-.033.099-.099.165t-.099.165l-.033.099V96.564l.033.099q.033.099.099.165t.099.165l.033.099v1.056l.033.099q.033.099.099.165t.099.165l.033.099v.792l.033.099q.033.099.099.165t.099.165l.033.099v.396q0 .132.033.232.033.099.132.132t.099.165v.396l.033.099q.033.099.099.165t.099.165l.033.099v.264l.033.099q.033.099.099.165t.099.165l.033.099v.264l.033.099q.033.099.099.165t.099.165l.033.099.033.099q.033.099.099.165t.099.165l.033.099v.132q0 .132.033.232.033.099.132.132t.099.165v.132l.033.099q.033.099.099.165t.099.165l.033.099.033.099q.033.099.099.165t.099.165l.033.099.033.099q.033.099.132.132t.099.165q0 .132.033.232.033.099.132.132t.132.132q.033.099.099.165t.099.165l.033.099.033.099q.033.099.099.165t.099.165l.033.099.033.099q.033.099.099.165l.132.132.132.132q.066.066.099.165l.033.099.033.099q.033.099.099.165l.132.132.132.132q.066.066.099.165l.066.198q.033.099.132.132t.132.132q.033.099.099.165l.132.132.132.132q.066.066.099.165l.066.198q.033.099.099.165l.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132q.066.066.099.165l.066.198q.033.099.132.132l.198.066q.099.033.165.099l.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132.132q.066.066.165.099t.132.132.132.132l.099.033.099.033q.099.033.165.099l.132.132.132.132q.066.066.165.099t.132.132.132.132l.099.033.099.033q.099.033.165.099l.132.132.132.132q.066.066.165.099l.099.033.099.033q.099.033.165.099t.165.099q.099.033.132.132t.132.132l.099.033.099.033q.099.033.165.099t.165.099l.099.033.099.033q.099.033.165.099t.165.099q.099.033.132.132t.132.132l.198.066q.099.033.165.099t.165.099l.099.033.099.033q.099.033.165.099t.165.099l.099.033.099.033q.099.033.165.099t.165.099q.099.033.232.033.132 0 .165.099t.132.132q.099.033.232.033h.132l.099.033q.099.033.165.099t.165.099l.099.033.099.033q.099.033.165.099t.165.099l.099.033h.264l.099.033q.099.033.165.099t.165.099l.099.033h.264l.099.033q.099.033.165.099t.165.099l.099.033h.264l.099.033q.099.033.165.099t.165.099l.099.033h.528l.099.033q.099.033.165.099t.165.099q.099.033.232.033h.66l.099.033q.099.033.165.099t.165.099l.099.033h.924q.132 0 .165.099t.132.132q.099.033.232.033H34.87",
    fillOpacity: 0
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M71.11 107.764q.037-.095.136-.128l.099-.033-.074.025-.074.025.05-.017q.05-.016.107-.025l.058-.008-.029.004-.029.004-.037.095q-.037.095-.136.128l-.099.033.074-.025.074-.025-.05.016q-.05.017-.107.025l-.058.008.029-.004.029-.004.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M70.552 107.735q0-.132.132-.132h.132v.264h-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M23.72 107.735v-.132h.132q.132 0 .132.132v.132h-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M23.456 107.735v-.132h.264v.264h-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    d: "M22.927 107.735v-.132l.099.033q.099.033.132.132l.033.099h-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M22.133 107.735v-.132h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074q-.074.074-.174.041-.099-.033-.099-.165m.298-.132H22.2h.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    d: "m21.633 107.442-.037-.095-.029-.004-.029-.004.058.008q.058.008.107.025l.05.017-.074-.025-.074-.025.099.033q.099.033.136.128l.037.095.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.136-.128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "m72.139 107.206.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07q.07.07.037.169-.033.099-.132.132t-.132.132-.132.132q-.099.033-.169-.037l-.07-.07-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066.132-.132.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M72.437 106.446q.033-.099.128-.136l.095-.037.004-.029.004-.029-.008.058q-.008.058-.025.107l-.016.05.025-.074.025-.074-.033.099q-.033.099-.128.136l-.095.037-.004.029-.004.029.008-.058q.008-.058.025-.107l.016-.05-.025.074-.025.074.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K",
    d: "m20.016 106.412-.066-.066.074-.074.074-.074-.017-.017-.017-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.016-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.017.017.017.016-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.017.016.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M72.404 105.619v-.132h.264v.529h-.264v-.397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "m19.223 105.619-.066-.066.074-.074.074-.074-.017-.016-.017-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.017-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.017.016.017.017-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.017.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "m72.437 105.056-.033-.099.025.074.025.074-.016-.05q-.016-.05-.025-.107l-.008-.058.004.029.004.029.095.037q.095.037.128.136l.033.099-.025-.074-.025-.074.016.05q.016.05.025.107l.008.058-.004-.029-.004-.029-.095-.037q-.095-.037-.128-.136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "m18.197 104.263-.033-.099.025.074.025.074-.017-.05q-.017-.05-.025-.107l-.008-.058.004.029.004.029.095.037q.095.037.128.136l.033.099-.025-.074-.025-.074.017.05q.017.05.025.107l.008.058-.004-.029-.004-.029-.095-.037q-.095-.037-.128-.136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    d: "m71.875 104.031-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07q.07-.07.17-.037.099.033.132.132t.132.132.132.132q.033.099-.037.169l-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132-.132-.132-.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    d: "M18.164 104.031v-.132.198-.066q0-.066-.008-.124l-.008-.058.004.029.004.029.136-.004q.136-.004.169.095t-.041.174l-.074.074.017.017.017.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    d: "m71.11 103.738-.037-.095-.029-.004-.029-.004.058.008q.058.008.107.025l.05.017-.074-.025-.074-.025.099.033q.099.033.136.128l.037.095.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.136-.128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "M70.552 103.767v-.132h.264v.264h-.132q-.132 0-.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M23.72 103.502v-.132h.264v.132q0 .132-.132.132h-.132v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M17.9 103.502v-.132h.264l.033.099q.033.099-.041.174l-.074.074.017.017.017.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    d: "M22.1 103.006q-.033-.099.037-.169l.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.132.132.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.07.07q-.07.07-.17.037-.099-.033-.132-.132t-.132-.132-.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    d: "M22.133 102.444v-.132h.132q.132 0 .165.099t-.037.169l-.07.07.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.017.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X",
    d: "m66.087 86.006-.033-.099.025.074.025.074-.016-.05q-.016-.05-.025-.107l-.008-.058.004.029.004.029.128.004.128.004v.264l-.099-.033q-.099-.033-.132-.132m.232 0v-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    d: "M53.618 86.04v-.132l.128-.004.128-.004.004-.029.004-.029-.008.058q-.008.058-.025.107l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033v-.132m0-.165v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    d: "M66.054 85.775v-.132l.128.004.128.004-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264l-.128-.004-.128-.004.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132m.265.165v-.231.264-.033m-.265-.331v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M53.618 85.775v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.128-.004.128-.004v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.128.004-.128.004v-.132m0 .033v.165-.264.099m.265-.066v-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M66.054 85.51v-.132l.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.025.107l.008.058-.004-.029-.004-.029-.128-.004-.128-.004v-.132m0 .033v.165-.264.099m0-.198v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M53.651 85.543q.033-.099.132-.132l.099-.033v.264l-.128.004-.128.004-.004.029-.004.029.008-.058q.008-.058.025-.107l.016-.05-.025.074-.025.074.033-.099m.232.132v-.231.264-.033m0-.198v-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M65.756 85.279q-.033-.099.041-.174l.074-.074-.016-.017-.016-.016.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.132q-.132 0-.165-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M53.883 85.246v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.017q.05-.016.083-.05l.033-.033-.016.016-.016.017.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M53.585 85.213q.033-.099.165-.099h.132v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.017-.083.05l-.033.033.016-.017.016-.016-.074-.074q-.074-.074-.041-.174m.298.198v-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "m65.558 84.419-.033-.099.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.025.107l.008.058-.004-.029-.004-.029-.095-.037q-.095-.037-.128-.136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M54.181 84.485q.033-.099.132-.132l.099-.033-.033.099q-.033.099-.128.136l-.095.037-.004.029-.004.029.008-.058q.008-.058.025-.107l.016-.05-.025.074-.025.074.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M54.445 84.22q.033-.099.099-.165l.066-.066.07.07.07.07.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066q-.066.066-.165.099l-.099.033.033-.099m.182-.248-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "m64.499 83.361-.033-.099.099.033q.099.033.165.099l.066.066-.07.07-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066q-.066-.066-.099-.165m.314.116-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M63.937 83.129v-.132h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.017-.074.074q-.074.074-.174.041-.099-.033-.099-.165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "m63.375 82.633-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.016.074-.074q.074-.074.174-.041.099.033.099.165v.132h-.264l-.033-.099m0 .099h.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "m63.139 82.604-.004-.128-.029-.004-.029-.004.058.008q.058.008.107.025l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099h-.264l-.004-.128m-.029.128h.231-.264.033m.198 0h.165-.264.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "m62.647 82.567-.033-.099h.264l.004.128.004.128.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.265-.099h-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M56.562 82.633q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.017.107-.025l.058-.008-.029.004-.029.004-.004.128-.004.128h-.264l.033-.099m-.066.099h.231-.264.033m.198 0h.165-.264.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M36.387 80.252q-.033-.099.041-.174l.074-.074-.016-.016-.016-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M23.985 80.219v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.016.083-.05l.033-.033-.016.016-.016.017.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M36.42 79.69v-.132h.264v.264l-.128-.004-.128-.004.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132m.265.165v-.231.264-.033m0-.198v-.165.264-.099m-.265-.132v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M23.985 79.69v-.132h.264v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.128.004-.128.004v-.132m0 .033v.165-.264.099m.265-.066v-.165.264-.099m-.265-.132v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M36.42 79.425v-.132l.128.004.128.004-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.264v-.132m0 .033v.165-.264.099m.265.132v-.231.264-.033m-.265-.331v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M23.985 79.425v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.128-.004.128-.004v.264h-.264v-.132m0 .033v.165-.264.099m.265.132v-.231.264-.033m0-.198v-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M36.42 78.896v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.016.017.016.016-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132m0 .033v.165-.264.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M24.25 78.896v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.017.083-.05l.033-.033-.016.017-.016.016.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132m0-.165v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "m36.189 78.598-.033-.099.025.074.025.074-.016-.05q-.016-.05-.025-.107l-.008-.058.004.029.004.029.124.008.124.008-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264l-.099-.033q-.099-.033-.132-.132m.232.198v-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M24.25 78.631v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.124-.008.124-.008.004-.029.004-.029-.008.058q-.008.058-.025.107l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033v-.132m0 .033v.165-.264.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    d: "M36.156 78.367v-.132l.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.025.107l.008.058-.004-.029-.004-.029-.124-.008-.124-.008.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AA",
    d: "M24.283 78.4q.033-.099.132-.132l.099-.033v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.124.008-.124.008-.004.029-.004.029.008-.058q.008-.058.025-.107l.016-.05-.025.074-.025.074.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AB",
    d: "m35.924 78.069-.033-.099.099.033q.099.033.132.132l.033.099-.099-.033q-.099-.033-.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AC",
    d: "M24.547 78.135q.033-.099.132-.132l.099-.033-.033.099q-.033.099-.132.132l-.099.033.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AD",
    d: "m26.069 76.746.033-.099h.264v.132q0 .132-.099.165t-.174-.041l-.074-.074-.016.017-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AE",
    d: "m34.304 76.515-.008-.124-.029-.004-.029-.004.058.008q.058.008.107.025l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.008-.124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AF",
    d: "m34.072 76.481-.033-.099h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.008.124.008.124.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132m.066-.099h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AG",
    d: "M33.245 76.25v-.132h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.004.128.004.128h-.264v-.132m-.033.132h.231-.264.033m.198 0h.165-.264.099m-.066-.265h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AH",
    d: "m32.985 76.246-.004-.128h.264v.264h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.004-.128m.161.136h.165-.264.099m.132-.265h-.231.264-.033m-.198 0h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AI",
    d: "m32.749 76.217-.033-.099h.264l.004.128.004.128.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132m.265-.099h-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AJ",
    d: "M27.425 76.25v-.132h.264l-.004.128-.004.128.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132m-.033.132h.231-.264.033m.331-.265h-.231.264-.033m-.198 0h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AK",
    d: "m27.164 76.254.004-.128-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264v.264h-.264l.004-.128m-.037.128h.231-.264.033m.198 0h.165-.264.099m.132-.265h-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AL",
    d: "m51.27 73.306-.033-.099.025.074.025.074-.016-.05q-.016-.05-.025-.107l-.008-.058.004.029.004.029.128.004.128.004v.264l-.099-.033q-.099-.033-.132-.132m.232.198v-.231.264-.033m0-.198v-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AM",
    d: "M38.802 73.34v-.132l.128-.004.128-.004.004-.029.004-.029-.008.058q-.008.058-.025.107l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033v-.132m0 .033v.165-.264.099m0-.198v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AN",
    d: "M17.668 67.023q.033-.099.128-.136l.095-.037.004-.029.004-.029-.008.058q-.008.058-.025.107l-.017.05.025-.074.025-.074-.033.099q-.033.099-.128.136l-.095.037-.004.029-.004.029.008-.058q.008-.058.025-.107l.017-.05-.025.074-.025.074.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AO",
    d: "M21.306 66.758q-.033-.099.037-.169l.07-.07-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.132q-.132 0-.165-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AP",
    d: "M20.545 65.931v-.132h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.017.05q.017.05.041.091l.025.041-.012-.021-.012-.021-.07.07q-.07.07-.169.037-.099-.033-.099-.165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AQ",
    d: "m18.664 65.902.037-.095-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264v.132q0 .132-.099.165t-.169-.037l-.07-.07-.012.021-.012.021.025-.041q.025-.041.041-.091l.017-.05-.025.074-.025.074.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AR",
    d: "M18.131 65.898q.033-.099.132-.132t.169.037l.07.07.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.132.132-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07q-.07-.07-.037-.17.033-.099.132-.132t.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AS",
    d: "m20.31 65.638-.037-.095-.029-.004-.029-.004.058.008q.058.008.107.025l.05.016-.074-.025-.074-.025.099.033q.099.033.136.128l.037.095.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.136-.128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AT",
    d: "M19.487 65.667v-.132h.529v.264h-.529v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AU",
    d: "m119.298 48.522.037-.095-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264-.198.066q.066 0 .124-.008l.058-.008-.029.004-.029.004.004.136q.004.136-.095.169t-.174-.041l-.074-.074-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AV",
    d: "M119.092 48.58q.037-.095.136-.128l.099-.033-.074.025-.074.025.05-.016q.05-.016.107-.025l.058-.008-.029.004-.029.004-.037.095q-.037.095-.136.128l-.099.033.074-.025.074-.025-.05.016q-.05.016-.107.025l-.058.008.029-.004.029-.004.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AW",
    d: "M118.798 48.551v-.132l.099-.033q.099-.033.174.041l.074.074.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AX",
    d: "m98.926 48.58-.037-.095.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.016.017.016.074-.074q.074-.074.174-.041l.099.033v.264h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AY",
    d: "m98.429 48.547.004-.136-.029-.004-.029-.004.058.008q.058.008.124.008h.066-.198.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.074.074q-.074.074-.174.041-.099-.033-.095-.169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AZ",
    d: "M119.621 48.315q.037-.095.103-.161l.066-.066.066.066.066.066-.066.066q-.066.066-.165.099l-.099.033.074-.025.074-.025-.05.016q-.05.016-.107.025l-.058.008.029-.004.029-.004.037-.095m.252-.046.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Aa",
    d: "M119.327 48.287q0-.132.099-.165t.169.037l.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.017.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ab",
    d: "m98.396 48.315-.037-.095.025.074.025.074-.017-.05q-.017-.05-.041-.091l-.025-.041.012.021.012.021.07-.07q.07-.07.169-.037.099.033.099.165v.132h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ac",
    d: "m98.161 48.287-.066-.066.066-.066.066-.066.066.066q.066.066.103.161l.037.095.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.165-.099m.116-.149-.05-.05-.017-.016-.017-.016.033.033.066.066.033.033-.05-.05m-.198.066.017.016.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ad",
    d: "m119.857 48.022.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.066.198.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.016m.232-.232.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ae",
    d: "m97.896 48.022-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.017.016.017.016-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.017-.016-.05-.05-.05-.05.033.033.066.066.033.033-.017-.016m-.232-.232-.05-.05-.017-.016-.017-.016.033.033.066.066.033.033-.05-.05m-.198.066.017.016.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Af",
    d: "M120.121 47.757q.066-.066.161-.103l.095-.037.004-.029.004-.029-.008.058q-.008.058-.025.107l-.017.05.025-.074.025-.074-.033.099q-.033.099-.099.165l-.066.066-.066-.066-.066-.066.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.066.198.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ag",
    d: "m97.665 47.724-.033-.099.025.074.025.074-.017-.05q-.017-.05-.025-.107l-.008-.058.004.029.004.029.095.037q.095.037.161.103l.066.066-.066.066-.066.066-.066-.066q-.066-.066-.099-.165m.116.182.05.05.017.016.017.016-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.017-.016-.05-.05-.05-.05.033.033.066.066.033.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ah",
    d: "M120.386 47.493v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.017-.017.017.074.074q.074.074.041.174-.033.099-.169.095l-.136-.004-.004.029-.004.029.008-.058q.008-.058.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ai",
    d: "M120.088 47.46q.033-.099.165-.099h.132v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.016q-.05.016-.091.041l-.041.025.021-.012.021-.012-.07-.07q-.07-.07-.037-.169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Aj",
    d: "M97.632 47.493v-.132h.132q.132 0 .165.099t-.037.169l-.07.07.021.012.021.012-.041-.025q-.041-.025-.091-.041l-.05-.016.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ak",
    d: "M97.334 47.526q-.033-.099.041-.174l.074-.074-.017-.017-.017-.017.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264-.198.066q0 .066.008.124l.008.058-.004-.029-.004-.029-.136.004q-.136.004-.169-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Al",
    d: "m120.353 46.931.033-.099h.264v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.017-.017.017-.017-.074-.074q-.074-.074-.041-.174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Am",
    d: "M97.367 46.964v-.132h.264l.033.099q.033.099-.041.174l-.074.074.017.017.017.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "An",
    d: "M120.353 46.203q-.033-.099.041-.174l.074-.074-.017-.017-.017-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.264l-.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ao",
    d: "M97.367 46.17v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.017.017-.017.017.074.074q.074.074.041.174l-.033.099h-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ap",
    d: "M120.386 45.641v-.132.198-.066q0-.066-.008-.124l-.008-.058.004.029.004.029.136-.004q.136-.004.169.095t-.041.174l-.074.074.017.017.017.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Aq",
    d: "M97.632 45.641v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.017q.05-.017.091-.041l.041-.025-.021.012-.021.012.07.07q.07.07.037.169-.033.099-.165.099h-.132v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ar",
    d: "M97.334 45.608q.033-.099.169-.095l.136.004.004-.029.004-.029-.008.058q-.008.058-.008.124v.066-.198.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.017-.017.017-.017-.074-.074q-.074-.074-.041-.174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "As",
    d: "m120.121 45.376-.066-.066.066-.066.066-.066.066.066q.066.066.099.165l.033.099-.025-.074-.025-.074.017.05q.017.05.025.107l.008.058-.004-.029-.004-.029-.095-.037q-.095-.037-.161-.103m.116-.149-.05-.05-.017-.017-.017-.017.033.033.066.066.033.033-.05-.05m-.198.066.017.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "At",
    d: "M97.665 45.409q.033-.099.099-.165l.066-.066.066.066.066.066-.066.066q-.066.066-.161.103l-.095.037-.004.029-.004.029.008-.058q.008-.058.025-.107l.017-.05-.025.074-.025.074.033-.099m.248-.05.05-.05.017-.017.017-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Au",
    d: "m119.857 45.112-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.017.017.017.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.017-.017-.05-.05-.05-.05.033.033.066.066.033.033-.017-.017m-.232-.232-.05-.05-.017-.017-.017-.017.033.033.066.066.033.033-.05-.05m-.198.066.017.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Av",
    d: "m97.896 45.112.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.017.017-.05.05-.017.017-.017.017.033-.033.066-.066.033-.033-.05.05m.066.198.017-.017.05-.05.05-.05-.033.033-.066.066-.033.033.017-.017m.232-.232.05-.05.017-.017.017-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Aw",
    d: "m119.621 44.818-.037-.095-.029-.004-.029-.004.058.008q.058.008.107.025l.05.017-.074-.025-.074-.025.099.033q.099.033.165.099l.066.066-.066.066-.066.066-.066-.066q-.066-.066-.103-.161m.12.178.05.05.017.017.017.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.017-.017-.05-.05-.05-.05.033.033.066.066.033.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ax",
    d: "M98.161 44.847q.066-.066.165-.099l.099-.033-.074.025-.074.025.05-.017q.05-.017.107-.025l.058-.008-.029.004-.029.004-.037.095q-.037.095-.103.161l-.066.066-.066-.066-.066-.066.066-.066m-.017.017-.05.05-.017.017-.017.017.033-.033.066-.066.033-.033-.05.05m.066.198.017-.017.05-.05.05-.05-.033.033-.066.066-.033.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ay",
    d: "m119.298 44.611-.037-.095.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.017.017.017.074-.074q.074-.074.174-.041.099.033.095.169l-.004.136.029.004.029.004-.058-.008q-.058-.008-.124-.008h-.066.198-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Az",
    d: "M118.798 44.582v-.132h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.017-.074.074q-.074.074-.174.041l-.099-.033v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BA",
    d: "m98.926 44.553.037-.095-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264v.264l-.099.033q-.099.033-.174-.041l-.074-.074-.017.017-.017.017.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BB",
    d: "M98.719 44.611q.037-.095.136-.128l.099-.033-.074.025-.074.025.05-.017q.05-.017.107-.025l.058-.008-.029.004-.029.004-.037.095q-.037.095-.136.128l-.099.033.074-.025.074-.025-.05.017q-.05.017-.107.025l-.058.008.029-.004.029-.004.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BC",
    d: "M98.429 44.586q-.004-.136.095-.169t.174.041l.074.074.017-.017.017-.017-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264.198-.066q-.066 0-.124.008l-.058.008.029-.004.029-.004-.004-.136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BD",
    d: "m119.298 40.055.037-.095-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264-.198.066q.066 0 .124-.008l.058-.008-.029.004-.029.004.004.136q.004.136-.095.169t-.174-.041l-.074-.074-.017.017-.017.017.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BE",
    d: "M118.798 40.084v-.132l.099-.033q.099-.033.174.041l.074.074.017-.017.017-.017-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BF",
    d: "m98.926 40.113-.037-.095.025.074.025.074-.017-.05q-.017-.05-.05-.083L98.839 40l.017.017.017.017.074-.074q.074-.074.174-.041l.099.033v.264h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BG",
    d: "m98.429 40.08.004-.136-.029-.004-.029-.004.058.008q.058.008.124.008h.066-.198.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.017-.074.074q-.074.074-.174.041-.099-.033-.095-.169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BH",
    d: "M119.621 39.849q.037-.095.103-.161l.066-.066.066.066.066.066-.066.066q-.066.066-.165.099l-.099.033.074-.025.074-.025-.05.017q-.05.017-.107.025l-.058.008.029-.004.029-.004.037-.095m.252-.045.05-.05.017-.017.017-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.017.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BI",
    d: "m98.161 39.82-.066-.066.066-.066.066-.066.066.066q.066.066.103.161l.037.095.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.165-.099m.116-.149-.05-.05-.017-.017-.017-.017.033.033.066.066.033.033-.05-.05m-.198.066.017.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BJ",
    d: "M120.121 39.291q.066-.066.161-.103l.095-.037.004-.029.004-.029-.008.058q-.008.058-.025.107l-.017.05.025-.074.025-.074-.033.099q-.033.099-.099.165l-.066.066-.066-.066-.066-.066.066-.066m-.017.017-.05.05-.017.017-.017.017.033-.033.066-.066.033-.033-.05.05m.066.198.017-.017.05-.05.05-.05-.033.033-.066.066-.033.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BK",
    d: "m97.665 39.258-.033-.099.025.074.025.074-.017-.05q-.017-.05-.025-.107l-.008-.058.004.029.004.029.095.037q.095.037.161.103l.066.066-.066.066-.066.066-.066-.066q-.066-.066-.099-.165m.116.182.05.05.017.017.017.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.017-.017-.05-.05-.05-.05.033.033.066.066.033.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BL",
    d: "M120.386 39.026v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.017.017-.017.017.074.074q.074.074.041.174-.033.099-.169.095l-.136-.004-.004.029-.004.029.008-.058q.008-.058.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BM",
    d: "M120.088 38.993q.033-.099.165-.099h.132v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.017q-.05.017-.091.041l-.041.025.021-.012.021-.012-.07-.07q-.07-.07-.037-.169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BN",
    d: "M97.334 39.059q-.033-.099.041-.174l.074-.074-.017-.017-.017-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264-.198.066q0 .066.008.124l.008.058-.004-.029-.004-.029-.136.004q-.136.004-.169-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BO",
    d: "M120.088 37.207q-.033-.099.037-.17l.07-.07-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.132q-.132 0-.165-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BP",
    d: "M92.34 36.38v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.017.017-.017.017.074.074q.074.074.174.041l.099-.033h.529l.099.033q.099.033.174-.041l.074-.074-.017-.017-.017-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.169-.037l.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.132.132.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.07.07q-.07.07-.037.17.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.017-.074.074q-.074.074-.041.174l.033.099v.528l-.033.099q-.033.099.041.174l.074.074.017-.017.017-.017-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099h-.132q-.132 0-.165.099t.037.169l.07.07.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.132.132-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07q-.07-.07-.17-.037-.099.033-.099.165v.132l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.017-.017.017-.017-.074-.074q-.074-.074-.174-.041l-.099.033h-.529l-.099-.033q-.099-.033-.174.041l-.074.074.017.017.017.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132q0-.132-.099-.165t-.169.037l-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132-.132-.132-.132-.132-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07q.07-.07.037-.17-.033-.099-.165-.099h-.132l-.033-.099-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.017.017.017.074-.074q.074-.074.041-.174l-.033-.099v-.529l.033-.099q.033-.099-.041-.174l-.074-.074-.017.017-.017.017.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.037-.169l-.07-.07-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066.132-.132.132-.132.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07q.07.07.17.037.099-.033.099-.165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BQ",
    d: "M99.484 36.116v-.132H118.563v.132q0 .132.132.132h.132l.099.033q.099.033.174-.041l.074-.074-.017-.017-.017-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.132q0 .132.099.165t.169-.037l.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.132.132.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.07.07q-.07.07-.037.17.033.099.165.099h.132l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.017-.017-.017-.074.074q-.074.074-.041.174l.033.099v.528l-.033.099q-.033.099.041.174l.074.074.017-.017.017-.017-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099h-.132q-.132 0-.165.099t.037.169l.07.07.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.132.132-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07q-.07-.07-.17-.037-.099.033-.099.165v.132l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.017-.017.017-.017-.074-.074q-.074-.074-.174-.041l-.099.033h-.132q-.132 0-.132.132v.132H99.483v-.132q0-.132-.132-.132h-.132l-.099-.033q-.099-.033-.174.041l-.074.074.017.017.017.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132q0-.132-.099-.165t-.169.037l-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132-.132-.132-.132-.132-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07q.07-.07.037-.17-.033-.099-.165-.099h-.132l-.033-.099-.033-.099.025.074.025.074-.017-.05q-.017-.05-.05-.083l-.033-.033.017.017.017.017.074-.074q.074-.074.041-.174l-.033-.099v-.529l.033-.099q.033-.099-.041-.174l-.074-.074-.017.017-.017.017.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099.033-.099h.132q.132 0 .165-.099t-.037-.169l-.07-.07-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066.132-.132.132-.132.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07q.07.07.17.037.099-.033.099-.165v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.017.017-.017.017.074.074q.074.074.174.041l.099-.033h.132q.132 0 .132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BR",
    d: "m16.371 63.07.033-.099h.264v.132q0 .132-.099.165t-.174-.041l-.074-.074-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BS",
    d: "m16.14 63.103.008-.124-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264l-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.107.025l-.058.008.029-.004.029-.004.008-.124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BT",
    d: "M15.908 63.136q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.107-.025l.058-.008-.029.004-.029.004-.008.124-.008.124.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264l.033-.099m-.066.099h.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BU",
    d: "m11.63 63.116.012-.145h.132q.132 0 .165.099l.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.083.083-.083.083.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.112-.021-.112-.021.012-.145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BV",
    d: "M11.377 63.103v-.132h.264l-.012.145-.012.145.021.012.021.012-.041-.025q-.041-.025-.108-.025h-.066.198-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BW",
    d: "m16.669 62.839.008-.124-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264l-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.107.025l-.058.008.029-.004.029-.004.008-.124m.298-.132h-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BX",
    d: "M16.438 62.872q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.107-.025l.058-.008-.029.004-.029.004-.008.124-.008.124.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264l.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BY",
    d: "m10.352 62.541-.033-.099h.132q.132 0 .132.132v.132l-.099-.033q-.099-.033-.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BZ",
    d: "m8.467 61.516-.066-.066.074-.074.074-.074-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.017.016.017.016-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.017.016.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ba",
    d: "m55.794 61.218.033-.099h.264v.132q0 .132-.099.165t-.174-.041l-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.132-.099h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bb",
    d: "m55.038 61.255.004-.128-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264v.264h-.264l.004-.128m-.037.128h.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bc",
    d: "m52.913 61.255-.004-.128-.029-.004-.029-.004.058.008q.058.008.107.025l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099h-.264l-.004-.128m-.029.128h.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bd",
    d: "M52.652 61.251v-.132h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.004.128.004.128h-.264v-.132m.165.132h.165-.264.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Be",
    d: "M51.859 61.251v-.132h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074q-.074.074-.174.041-.099-.033-.099-.165m.298-.132h-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bf",
    d: "m51.363 60.953-.033-.099h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.008.124.008.124.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.066-.099h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bg",
    d: "m57.121 60.693.037-.095-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264v.132q0 .132-.099.165t-.174-.041l-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bh",
    d: "M56.621 60.722q0-.132.099-.165t.174.041l.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bi",
    d: "m51.036 60.751-.037-.095.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074q.074-.074.174-.041.099.033.099.165v.132h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bj",
    d: "M50.536 60.722v-.132h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074q-.074.074-.174.041-.099-.033-.099-.165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bk",
    d: "M19.844 60.193v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.124-.008.124-.008.004-.029.004-.029-.008.058q-.008.058-.025.107l-.017.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bl",
    d: "M20.109 59.928v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bm",
    d: "m49.213 59.664-.066-.066.07-.07.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066q.066.066.099.165l.033.099-.099-.033q-.099-.033-.165-.099m-.083-.083.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bn",
    d: "m48.915 59.697-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074.074-.074.066.066.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.079.079-.079.079.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.149-.182-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bo",
    d: "m7.111 59.697-.033-.099.025.074.025.074-.017-.05q-.017-.05-.041-.091l-.025-.041.012.021.012.021.079-.079.079-.079-.017-.016-.017-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.264l-.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bp",
    d: "m59.002 59.399.132-.132.066-.066.074.074.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074-.074-.074.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bq",
    d: "M58.705 59.366q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.074.074.074.074-.066.066-.132.132-.066.066-.07-.07-.07-.07-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Br",
    d: "m48.948 59.399-.066-.066.074-.074.074-.074-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07-.07.07-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bs",
    d: "m48.651 59.432-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074.074-.074.066.066.132.132.066.066-.074.074-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.232-.232-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bt",
    d: "M58.969 59.101q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.074.074.074.074-.066.066-.132.132-.066.066-.074-.074-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bu",
    d: "m48.684 59.134-.066-.066.074-.074.074-.074-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bv",
    d: "M60.094 58.109q.033-.099.128-.136l.095-.037.004-.029.004-.029-.008.058q-.008.058-.025.107l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bw",
    d: "m47.658 58.043-.033-.099.025.074.025.074-.016-.05q-.016-.05-.025-.107l-.008-.058.004.029.004.029.095.037q.095.037.128.136l.033.099-.099-.033q-.099-.033-.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bx",
    d: "M60.325 57.812v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "By",
    d: "M60.028 57.778q.033-.099.165-.099h.132v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074q-.074-.074-.041-.174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bz",
    d: "M47.625 57.812v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CA",
    d: "M47.328 57.845q-.033-.099.041-.174l.074-.074-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.132q-.132 0-.165-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CB",
    d: "M20.902 57.282v-.132h.264v.264h-.264v-.132m0 .033v.165-.264.099m.265.132v-.231.264-.033m0-.198v-.165.264-.099m-.265-.132v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CC",
    d: "M60.855 56.753v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.016-.016.016.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132m0-.165v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CD",
    d: "M46.799 56.786q-.033-.099.041-.174l.074-.074-.016-.016-.016-.016.033.033q.033.033.083.05l.05.016-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099m.298-.066v-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CE",
    d: "M20.902 56.753v-.132h.264v.264h-.264v-.132m0 .033v.165-.264.099m.265.132v-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CF",
    d: "M20.936 56.522q.033-.099.132-.132l.099-.033v.264h-.264l.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CG",
    d: "M60.888 56.257q.033-.099.132-.132l.099-.033v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.124.008-.124.008-.004.029-.004.029.008-.058q.008-.058.025-.107l.016-.05-.025.074-.025.074.033-.099m.232-.066v-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CH",
    d: "M46.832 56.224v-.132l.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.025.107l.008.058-.004-.029-.004-.029-.124-.008-.124-.008.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132m0-.165v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CI",
    d: "M60.821 55.926q.033-.099.165-.099h.132v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074q-.074-.074-.041-.174m.298.198v-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CJ",
    d: "M46.832 55.959v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132m0 .033v.165-.264.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CK",
    d: "m20.936 55.662-.033-.099h.264v.264l-.099-.033q-.099-.033-.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CL",
    d: "M20.902 55.43v-.132h.264v.264h-.264v-.132m.265-.033v-.165.264-.099m-.265-.132v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CM",
    d: "M46.567 54.901v-.132l.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.025.107l.008.058-.004-.029-.004-.029-.128-.004-.128-.004v-.132m0 .033v.165-.264.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CN",
    d: "M6.648 54.14q.033-.099.132-.132l.099-.033v.132q0 .132-.132.132h-.132l.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CO",
    d: "M6.383 54.14q.033-.099.099-.165l.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.079.079.079.079.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099h-.264l.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CP",
    d: "m6.582 53.81.033-.099h.264v.264l-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.079-.079-.079-.079-.012.021-.012.021.025-.041q.025-.041.041-.091l.017-.05-.025.074-.025.074.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CQ",
    d: "M20.638 53.578v-.132l.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.017.05q.017.05.025.107l.008.058-.004-.029-.004-.029-.124-.008-.124-.008.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CR",
    d: "M20.638 53.314v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.017.016.017.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033-.099-.033v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CS",
    d: "M46.567 53.049v-.132h.264l-.033.099q-.033.099-.132.132l-.099.033v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CT",
    d: "M20.638 52.784v-.132l.099-.033.099-.033-.074.025-.074.025.05-.016q.05-.016.091-.041l.041-.025-.021.012-.021.012.079.079.079.079.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099q-.033.099-.165.099h-.132v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CU",
    d: "m21.167 52.255.132-.132.066-.066.074.074.074.074.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074-.074-.074.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.232-.232-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CV",
    d: "M20.869 52.222q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.074.074.074.074-.066.066-.132.132-.066.066-.07-.07-.07-.07-.012.021-.012.021.025-.041q.025-.041.041-.091l.017-.05-.025.074-.025.074.033-.099m.083.248.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.016m.232-.232.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CW",
    d: "M7.177 52.288q.033-.099.099-.165l.066-.066.074.074.074.074.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099h-.264l.033-.099m.182-.248-.017.016-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CX",
    d: "M21.134 51.958q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.017.016-.017.016.074.074.074.074-.066.066-.132.132-.066.066-.074-.074-.074-.074-.017.016-.017.016.033-.033q.033-.033.05-.083l.017-.05-.025.074-.025.074.033-.099m.083.248.017-.016.05-.05.05-.05-.033.033-.066.066-.033.033.017-.016m.232-.232.05-.05.017-.016.017-.016-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CY",
    d: "m7.938 51.197.132-.132.066-.066.074.074.074.074.017-.016.017-.016-.033.033q-.033.033-.05.083l-.017.05.025-.074.025-.074-.033.099-.033.099-.099.033-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.017-.016.017-.016-.074-.074-.074-.074.066-.066m-.017.016-.05.05-.017.016-.017.016.033-.033.066-.066.033-.033-.05.05m.232-.232L8.134 51l-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CZ",
    d: "m46.269 50.965-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.016.016.016.074-.074.074-.074.066.066.132.132.066.066-.066.066q-.066.066-.165.033t-.132-.132m.38.05-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.232-.232-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ca",
    d: "m22.49 50.932.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.066.198.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cb",
    d: "m46.302 50.668-.066-.066.07-.07.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.43-.165.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cc",
    d: "m23.019 50.668.132-.132.066-.066.074.074.074.074.016-.016.016-.016-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132t-.165-.033l-.066-.066.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cd",
    d: "m45.74 50.436-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.07-.07.07-.07.066.066.132.132.066.066-.074.074-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.232-.232-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ce",
    d: "m61.913 50.139.132-.132.066-.066.07.07.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.016q-.05.016-.083.05l-.033.033.016-.016.016-.016-.074-.074-.074-.074.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cf",
    d: "m45.509 50.139-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.07.07-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m.347.083-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.232-.232-.05-.05-.016-.016-.016-.016.033.033.066.066.033.033-.05-.05m-.198.066.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cg",
    d: "m62.177 49.874.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07-.07-.07.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.298-.033.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.016-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ch",
    d: "M61.88 49.841q.033-.099.132-.132t.165.033l.066.066-.066.066-.132.132-.066.066-.074-.074-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ci",
    d: "m62.707 49.345.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07.07.07-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.016.016-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.066.198.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cj",
    d: "m44.45 49.08-.066-.066.066-.066q.066-.066.165-.033t.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.016-.016-.016-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.016.016.016-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.016.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ck",
    d: "M14.817 48.816v-.132h.264v.264h-.264v-.132m-.033.132h.231-.264.033m.198 0h.165-.264.099m.132-.265h-.231.264-.033m-.198 0h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cl",
    d: "M14.023 48.816v-.132h.264l.033.099.033.099-.025-.074-.025-.074.017.05q.017.05.05.083l.033.033-.017-.016-.017-.016-.074.074q-.074.074-.174.041l-.099-.033v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cm",
    d: "M64.79 47.46q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.016q.05-.016.083-.05l.033-.033-.016.017-.016.017.074.074.074.074-.066.066-.132.132-.066.066-.074-.074-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.016.016-.016-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cn",
    d: "m48.915 47.526-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.07-.07.07-.07.066.066.132.132.066.066-.074.074-.074.074.016.016.016.016-.033-.033q-.033-.033-.083-.05l-.05-.016.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.232-.232-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Co",
    d: "m58.738 47.228.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07-.07-.07.066-.066m-.016.017-.05.05-.016.016-.016.016.033-.033.066-.066.033-.033-.05.05m.298-.033.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cp",
    d: "M58.44 47.195q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074.074.074-.066.066-.132.132-.066.066-.074-.074-.074-.074-.016.016-.016.016.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.016.05-.05.05-.05-.033.033-.066.066-.033.033.016-.016m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cq",
    d: "m57.121 47.257-.037-.095.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.174-.041.099.033.099.165v.132h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cr",
    d: "M50.536 47.228q0-.132.099-.165t.174.041l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.037.095-.037.095.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cs",
    d: "m48.684 47.228-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.07.07-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m.347.083-.016-.016-.05-.05-.05-.05.033.033.066.066.033.033-.016-.016m-.232-.232-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05m-.198.066.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ct",
    d: "m65.882 46.964.132-.132.066-.066.074.074.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132t-.165-.033l-.066-.066.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cu",
    d: "m65.617 46.964.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.07.07.07.07-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.066.198.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cv",
    d: "m59.002 46.964.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.066.198.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cw",
    d: "M58.705 46.931q.033-.099.132-.132t.165.033l.066.066-.066.066-.132.132-.066.066-.074-.074-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cx",
    d: "m56.588 46.997-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.174-.041.099.033.099.165v.132h-.264l-.033-.099m0 .099h.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cy",
    d: "m56.357 46.964-.008-.124-.029-.004-.029-.004.058.008q.058.008.107.025l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099h-.264.198-.066q-.066 0-.124-.008l-.058-.008.029.004.029.004-.008-.124m.165.132h.165-.264.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cz",
    d: "M55.827 46.964v-.132h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.174.041-.099-.033-.099-.165m.298-.132h-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DA",
    d: "m51.826 46.931.033-.099h.264v.132q0 .132-.099.165t-.174-.041l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.132-.099h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DB",
    d: "m51.594 46.964.008-.124-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264l-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.107.025l-.058.008.029-.004.029-.004.008-.124m.298-.132h-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DC",
    d: "M51.363 46.997q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.107-.025l.058-.008-.029.004-.029.004-.008.124-.008.124.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264l.033-.099m-.066.099h.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DD",
    d: "M51.065 46.964q0-.132.099-.165t.174.041l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.264v-.132m.165.132h.165-.264.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DE",
    d: "m48.419 46.964-.066-.066.07-.07.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.017m-.43-.165.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DF",
    d: "m48.121 46.997-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074.074-.074.066.066.132.132.066.066-.066.066q-.066.066-.165.033t-.132-.132m.38.05-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.017m-.232-.232-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DG",
    d: "m41.805 46.964-.066-.066.066-.066q.066-.066.165-.033t.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DH",
    d: "m41.54 46.964-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.017m-.232-.232-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05m-.198.066.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DI",
    d: "M26.69 46.931q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074.074.074-.066.066-.132.132-.066.066-.074-.074-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DJ",
    d: "m66.146 46.699.132-.132.066-.066.074.074.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074-.074-.074.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DK",
    d: "M65.849 46.666q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074.074.074-.066.066-.132.132-.066.066-.07-.07-.07-.07-.012.021-.012.021.025-.041q.025-.041.041-.091l.016-.05-.025.074-.025.074.033-.099m.083.248.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DL",
    d: "M54.505 46.699v-.132h.264l.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.174.041l-.099-.033v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DM",
    d: "m53.149 46.666.033-.099h.264v.264l-.099.033q-.099.033-.174-.041l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DN",
    d: "M52.156 46.732q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.107-.025l.058-.008-.029.004-.029.004-.004.128-.004.128h-.264l.033-.099m-.066.099h.231-.264.033m.198 0h.165-.264.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DO",
    d: "m48.155 46.699-.066-.066.074-.074.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07-.07.07-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DP",
    d: "m47.857 46.732-.033-.099.025.074.025.074-.016-.05q-.016-.05-.041-.091l-.025-.041.012.021.012.021.07-.07.07-.07.066.066.132.132.066.066-.074.074-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.017m-.232-.232-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DQ",
    d: "m40.978 46.732-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074.074-.074.066.066.132.132.066.066-.074.074-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132m.38.05-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.017m-.232-.232-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DR",
    d: "m66.411 46.434.132-.132.066-.066.07.07.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074-.074-.075.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DS",
    d: "m47.89 46.434-.066-.066.074-.074.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m-.232-.232.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DT",
    d: "m47.625 46.434-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.07.07-.07.07.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m.347.083-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.017m-.232-.232-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05m-.198.066.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DU",
    d: "m66.675 46.17.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.07-.07-.07-.07.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.298-.033.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DV",
    d: "m47.625 46.17-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07q.07-.07.17-.037.099.033.132.132l.033.099-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074-.074.074-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DW",
    d: "m47.394 46.137-.033-.099.099.033q.099.033.165.099l.066.066-.066.066-.066.066-.066-.066q-.066-.066-.099-.165m.116.182.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DX",
    d: "m47.063 46.203-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.079-.079.079-.079-.021-.012-.021-.012.041.025q.041.025.091.041l.05.017-.074-.025-.074-.025.099.033.099.033.033.099.033.099-.025-.074-.025-.074.016.05q.016.05.041.091l.025.041-.012-.021-.012-.021-.07.07q-.07.07-.169.037-.099-.033-.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DY",
    d: "m47.096 45.905-.066-.066.07-.07.07-.07-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066q.066.066.099.165l.033.099-.099-.033q-.099-.033-.165-.099m-.083-.083.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DZ",
    d: "m46.799 45.938-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074.074-.074.066.066.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.079.079-.079.079.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132m.149-.182-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Da",
    d: "m28.84 45.376.132-.132.066-.066.07.07.07.07.012-.021.012-.021-.025.041q-.025.041-.041.091l-.016.05.025-.074.025-.074-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074-.074-.074.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.232-.232-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Db",
    d: "m36.509 44.314.004-.128h.264l-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.107.025l-.058.008.029-.004.029-.004.004-.128m.302-.128h-.231.264-.033m-.198 0h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dc",
    d: "M35.19 44.318v-.132l.099-.033q.099-.033.174.041l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dd",
    d: "m34.363 44.351-.033-.099.025.074.025.074-.016-.05q-.016-.05-.05-.083l-.033-.033.016.017.016.017.074-.074q.074-.074.174-.041l.099.033v.264h-.264l-.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "De",
    d: "m34.127 44.322-.004-.128-.029-.004-.029-.004.058.008q.058.008.107.025l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099h-.264l-.004-.128m-.029.128h.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Df",
    d: "m33.106 44.285-.033-.099h.264l.004.128.004.128.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132m.265-.099h-.231.264-.033m-.198 0h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dg",
    d: "M37.571 43.789q0-.132.099-.165t.174.041l.074.074.016-.017.016-.017-.033.033q-.033.033-.05.083l-.016.05.025-.074.025-.074-.033.099-.033.099h-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dh",
    d: "M31.486 43.789v-.132h.264-.198.066q.066 0 .124.008l.058.008-.029-.004-.029-.004.037.095.037.095-.025-.074-.025-.074.016.05q.016.05.05.083l.033.033-.016-.017-.016-.017-.074.074q-.074.074-.174.041-.099-.033-.099-.165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Di",
    d: "m38.596 43.491.033-.099h.264v.132q0 .132-.099.165t-.174-.041l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dj",
    d: "M38.394 43.553q.037-.095.136-.128l.099-.033-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.107.025l-.058.008.029-.004.029-.004.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dk",
    d: "m31.254 43.491-.033-.099.099.033q.099.033.136.128l.037.095.029.004.029.004-.058-.008q-.058-.008-.107-.025l-.05-.017.074.025.074.025-.099-.033q-.099-.033-.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dl",
    d: "m38.894 43.259.008-.124-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264l-.033.099q-.033.099-.132.132l-.099.033.074-.025.074-.025-.05.017q-.05.017-.107.025l-.058.008.029-.004.029-.004.008-.124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dm",
    d: "M38.663 43.293q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.107-.025l.058-.008-.029.004-.029.004-.008.124-.008.124.029-.004.029-.004-.058.008q-.058.008-.124.008h-.066.198-.264l.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dn",
    d: "m39.688 42.73.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066.05-.05.05-.05-.033.033q-.033.033-.058.074l-.025.041.012-.021.012-.021-.074-.074-.074-.074-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066m.281-.017.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Do",
    d: "M39.456 42.763q.033-.099.099-.165l.066-.066.066.066.066.066-.066.066q-.066.066-.165.099l-.099.033.033-.099m.248-.05.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dp",
    d: "m30.163 42.73-.066-.066.066-.066.066-.066.066.066q.066.066.099.165l.033.099-.099-.033q-.099-.033-.165-.099m.116-.149-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05m-.198.066.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dq",
    d: "m29.898 42.73-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.074.074-.074.074.012.021.012.021-.025-.041q-.025-.041-.058-.074l-.033-.033.05.05.05.05-.066-.066-.132-.132m.116-.149-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05m-.198.066.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dr",
    d: "M78.052 42.201v-.132h.264v.264h-.264v-.132m.165.132h.165-.264.099m.132-.265h-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ds",
    d: "M76.2 42.201v-.132h.264v.264H76.2v-.132m-.033.132h.231-.264.033m.132-.265h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dt",
    d: "M75.936 42.201v-.132h.264v.264h-.264v-.132m-.033.132h.231-.264.033m.198 0h.165-.264.099m.132-.265h-.231.264-.033m-.198 0h-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Du",
    d: "m40.482 41.937.132-.132.066-.066-.05.05-.05.05.033-.033q.033-.033.058-.074l.025-.041-.012.021-.012.021.074.074.074.074.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.066.198.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dv",
    d: "m40.217 41.937.132-.132.066-.066.066.066.066.066-.066.066-.132.132-.066.066-.07-.07-.07-.07-.021.012-.021.012.041-.025q.041-.025.074-.058l.033-.033-.05.05-.05.05.066-.066m.05.215.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.232-.232.05-.05.016-.017.016-.017-.033.033-.066.066-.033.033.05-.05m-.066-.198-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dw",
    d: "m29.369 41.937-.066-.066.066-.066.066-.066.066.066.132.132.066.066-.05-.05-.05-.05.033.033q.033.033.074.058l.041.025-.021-.012-.021-.012-.07.07-.07.07-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m-.033-.298-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05m-.198.066.016.017.05.05.05.05-.033-.033-.066-.066-.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dx",
    d: "m29.105 41.937-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.074-.074.074-.074-.012-.021-.012-.021.025.041q.025.041.058.074l.033.033-.05-.05-.05-.05.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dy",
    d: "m80.405 41.643.037-.095-.029.004-.029.004.058-.008q.058-.008.124-.008h.066-.198.264v.132q0 .132-.099.165t-.174-.041l-.074-.074-.016.017-.016.017.033-.033q.033-.033.05-.083l.016-.05-.025.074-.025.074.037-.095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dz",
    d: "M40.482 41.672q.066-.066.165-.099l.099-.033-.033.099q-.033.099-.099.165l-.066.066-.066-.066-.066-.066.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.066.198.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EA",
    d: "m28.608 41.11-.033-.099.025.074.025.074-.016-.05q-.016-.05-.025-.107l-.008-.058.004.029.004.029.124.008.124.008-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264l-.099-.033q-.099-.033-.132-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EB",
    d: "M41.275 40.878v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.041.174l-.033.099h-.264v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EC",
    d: "M41.044 40.911q.033-.099.132-.132l.099-.033v.264l-.128.004-.128.004-.004.029-.004.029.008-.058q.008-.058.025-.107l.016-.05-.025.074-.025.074.033-.099m.232.132v-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ED",
    d: "M41.54 40.349v-.132.198-.066q0-.066.008-.124l.008-.058-.004.029-.004.029.095-.037.095-.037-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EE",
    d: "M41.242 40.316q.033-.099.165-.099h.132v.264-.198.066q0 .066-.008.124l-.008.058.004-.029.004-.029-.095.037-.095.037.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.041-.174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EF",
    d: "M28.311 40.349v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EG",
    d: "m82.55 40.084.132-.132.066-.066.07.07.07.07.021-.012.021-.012-.041.025q-.041.025-.074.058l-.033.033.05-.05.05-.05-.066.066-.132.132-.066.066-.066-.066-.066-.066.066-.066m-.016.017-.05.05-.016.017-.016.017.033-.033.066-.066.033-.033-.05.05m.066.198.016-.017.05-.05.05-.05-.033.033-.066.066-.033.033.016-.017m.165-.43-.016.017-.05.05-.05.05.033-.033.066-.066.033-.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EH",
    d: "m71.702 40.084-.066-.066.05.05.05.05-.033-.033q-.033-.033-.074-.058l-.041-.025.021.012.021.012.07-.07.07-.07.066.066.132.132.066.066-.066.066-.066.066-.066-.066-.132-.132m.149.149.05.05.016.017.016.017-.033-.033-.066-.066-.033-.033.05.05m.198-.066-.016-.017-.05-.05-.05-.05.033.033.066.066.033.033-.016-.017m-.232-.232-.05-.05-.016-.017-.016-.017.033.033.066.066.033.033-.05-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EI",
    d: "M41.805 39.82v-.132l.099-.033.099-.033-.074.025-.074.025.05-.017q.05-.017.083-.05l.033-.033-.016.017-.016.017.074.074q.074.074.041.174-.033.099-.165.099h-.132v-.132m0-.165v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EJ",
    d: "M28.046 39.82v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132m0 .033v.165-.264.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EK",
    d: "M27.749 39.853q-.033-.099.041-.174l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.264h-.132q-.132 0-.165-.099m.298-.066v-.165.264-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EL",
    d: "M41.771 38.993q.033-.099.165-.099h.132v.264l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.041-.174m.298.198v-.231.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EM",
    d: "M70.909 38.762v-.132h.132q.132 0 .165.099t-.041.174l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.095-.037-.095-.037.004.029.004.029-.008-.058q-.008-.058-.008-.124v-.066.198-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EN",
    d: "M70.611 38.795q-.033-.099.041-.174l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.095.037.095.037-.004-.029-.004-.029.008.058q.008.058.008.124v.066-.198.264h-.132q-.132 0-.165-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EO",
    d: "M42.069 38.232V38.1h.264v.264h-.264v-.132m0 .033v.165-.264.099m.265.132v-.231.264-.033m0-.198v-.165.264-.099m-.265-.132v.231-.264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EP",
    d: "m42.036 37.406.033-.099h.264v.264l-.099.033-.099.033.074-.025.074-.025-.05.017q-.05.017-.083.05l-.033.033.016-.017.016-.017-.074-.074q-.074-.074-.041-.174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EQ",
    d: "M27.517 37.439v-.132h.264l.033.099q.033.099-.041.174l-.074.074.016.017.016.017-.033-.033q-.033-.033-.083-.05l-.05-.017.074.025.074.025-.099-.033-.099-.033v-.132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ER",
    d: "M42.036 36.678q-.033-.099.041-.174l.074-.074-.016-.017-.016-.017.033.033q.033.033.083.05l.05.017-.074-.025-.074-.025.099.033.099.033v.264h-.264l-.033-.099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ES",
    d: "m38.394 30.53-.037-.095-.029-.004-.029-.004.058.008q.058.008.107.025l.05.017-.074-.025-.074-.025.099.033q.099.033.132.132l.033.099-.099-.033q-.099-.033-.136-.128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ET",
    d: "M31.254 30.593q.033-.099.132-.132l.099-.033-.074.025-.074.025.05-.017q.05-.017.107-.025l.058-.008-.029.004-.029.004-.037.095q-.037.095-.136.128l-.099.033.033-.099"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.82e0310149a87c836e4b549ef0eb0ec9.svg";
export { ForwardRef as ReactComponent };